//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import authService from '../components/api-authorization/AuthorizeService';
export class ApiClientBase {
    baseApiUrl: string = '';

    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const token = await authService.getAccessToken();
        options.headers = { ...options.headers, authorization: `Bearer ${token}` };
        return Promise.resolve(options);
    }

    protected transformResult(
        url: string,
        response: Response,
        processor: (response: Response) => any
    ) {
        if (response.status === 401) {
            const isAuthRoute = window.location.pathname.startsWith('/authentication');
            const isRecovering = sessionStorage.getItem(AUTH_RECOVERY_FLAG) === '1';

            console.warn(
                '[ApiClient] 401 Unauthorized — session/token rejected by API.',
                { url, statusText: response.statusText, isAuthRoute, isRecovering }
            );

            // Avoid infinite loops when already recovering or already on auth routes.
            if (isAuthRoute || isRecovering) {
                return processor(response);
            }

            // 2026-03-23: Mark this tab as "recovering" before auth redirect.
            sessionStorage.setItem(AUTH_RECOVERY_FLAG, '1');
            // 2026-03-23: Cleanup transient oidc-client state entries from interrupted flows.
            authService.clearStaleAuthState().catch((error: unknown) => {
                console.warn('[ApiClient] Failed to clear stale OIDC state before login redirect.', {
                    error,
                });
            });
            // 2026-03-23: Remove persisted user so next login starts cleanly.
            authService.userManager?.removeUser?.().catch((error: unknown) => {
                console.warn('[ApiClient] Failed to remove stale OIDC user before login redirect.', {
                    error,
                });
            });

            // 2026-03-23: Use login redirect instead of hard reload to avoid reload loops.
            // NOTE: Login.tsx validates returnUrl as a same-origin *absolute* URL.
            const returnUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
            window.location.assign(`/authentication/login?returnUrl=${encodeURIComponent(returnUrl)}`);
            return new Promise(() => {});
        }

        // 2026-03-23: Recovery completed on non-auth routes, clear loop-prevention flag.
        if (!window.location.pathname.startsWith('/authentication')) {
            sessionStorage.removeItem(AUTH_RECOVERY_FLAG);
        }

        return processor(response);
    }

    protected getBaseUrl(defaultUrl: string, baseUrl?: string) {
        return this.baseApiUrl;
    }
}

export class ApiTokensClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(request: CreateApiTokenRequest): Promise<ApiTokenCreatedVm> {
        let url_ = this.baseUrl + "/api/ApiTokens";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ApiTokenCreatedVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiTokenCreatedVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenCreatedVm>(null as any);
    }

    getAll(): Promise<ApiTokenVm[]> {
        let url_ = this.baseUrl + "/api/ApiTokens";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ApiTokenVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTokenVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenVm[]>(null as any);
    }

    revoke(id: number): Promise<ApiTokenVm> {
        let url_ = this.baseUrl + "/api/ApiTokens/{id}/revoke";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRevoke(_response));
        });
    }

    protected processRevoke(response: Response): Promise<ApiTokenVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTokenVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiTokenVm>(null as any);
    }
}

export class CategoriesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CategoryVm[]> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CategoryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CategoryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm[]>(null as any);
    }

    create(command: CreateCategoryCommandOfCategory): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CategoryVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    getById(id: number): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    update(id: number, command: UpdateCategoryCommandOfCategory): Promise<CategoryVm> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CategoryVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CitiesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CityVm[]> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CityVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CityVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm[]>(null as any);
    }

    create(command: CreateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CityVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    getById(id: number): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    update(id: number, command: UpdateCityCommandOfCity): Promise<CityVm> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CityVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Cities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateClubCoachCommandOfClubCoach): Promise<ClubCoachVm> {
        let url_ = this.baseUrl + "/api/ClubCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubCoachVm>(null as any);
    }

    update(id: number, command: UpdateClubCoachCommandOfClubCoach): Promise<ClubCoachVm> {
        let url_ = this.baseUrl + "/api/ClubCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateClubPlayerCommandOfClubPlayer): Promise<ClubPlayerVm> {
        let url_ = this.baseUrl + "/api/ClubPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPlayerVm>(null as any);
    }

    update(id: number, command: UpdateClubPlayerCommandOfClubPlayer): Promise<ClubPlayerVm> {
        let url_ = this.baseUrl + "/api/ClubPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/ClubPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ClubsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getChanged(since: string | null | undefined, limit?: number | null | undefined, includeDeleted?: boolean | null | undefined, afterId?: number | null | undefined): Promise<ChangedFeedListVm> {
        return changedFeed(this.http, this.baseUrl, "/api/Clubs/changed", since, limit, includeDeleted, afterId, (key, value) => this.jsonParseReviver ? this.jsonParseReviver(key, value) : value, (options) => this.transformOptions(options), (url, response, processor) => this.transformResult(url, response, processor));
    }

    getAll(): Promise<ClubVm[]> {
        let url_ = this.baseUrl + "/api/Clubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ClubVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClubVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubVm[]>(null as any);
    }

    create(command: CreateClubCommandOfClub): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ClubDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Federation: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfClubVm> {
        let url_ = this.baseUrl + "/api/Clubs/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Federation !== undefined && filter_Federation !== null)
            url_ += "Filter.Federation=" + encodeURIComponent("" + filter_Federation) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfClubVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfClubVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfClubVm>(null as any);
    }

    getById(id: number): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    update(id: number, command: UpdateClubCommandOfClub): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Clubs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    removeClubFromFederation(id: number): Promise<ClubDetailVm> {
        let url_ = this.baseUrl + "/api/Clubs/{id}/remove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveClubFromFederation(_response));
        });
    }

    protected processRemoveClubFromFederation(response: Response): Promise<ClubDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClubDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClubDetailVm>(null as any);
    }
}

export class CoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CoachVm[]> {
        let url_ = this.baseUrl + "/api/Coaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CoachVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CoachVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachVm[]>(null as any);
    }

    create(command: CreateCoachCommand): Promise<CoachDetailVm> {
        let url_ = this.baseUrl + "/api/Coaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CoachDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CoachDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfCoachVm> {
        let url_ = this.baseUrl + "/api/Coaches/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCoachVm>(null as any);
    }

    getById(id: number): Promise<CoachDetailVm> {
        let url_ = this.baseUrl + "/api/Coaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CoachDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoachDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoachDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Coaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CompetitionsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getChanged(since: string | null | undefined, limit?: number | null | undefined, includeDeleted?: boolean | null | undefined, afterId?: number | null | undefined): Promise<ChangedFeedListVm> {
        return changedFeed(this.http, this.baseUrl, "/api/Competitions/changed", since, limit, includeDeleted, afterId, (key, value) => this.jsonParseReviver ? this.jsonParseReviver(key, value) : value, (options) => this.transformOptions(options), (url, response, processor) => this.transformResult(url, response, processor));
    }

    getAll(): Promise<CompetitionVm[]> {
        let url_ = this.baseUrl + "/api/Competitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompetitionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompetitionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionVm[]>(null as any);
    }

    create(command: CreateCompetitionCommandOfCompetition): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_StartDate: Date | null | undefined, filter_EndDate: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Federation: string | null | undefined, filter_Category: string | null | undefined, filter_CompetitionType: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfCompetitionVm> {
        let url_ = this.baseUrl + "/api/Competitions/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_StartDate !== undefined && filter_StartDate !== null)
            url_ += "Filter.StartDate=" + encodeURIComponent(filter_StartDate ? "" + filter_StartDate.toISOString() : "") + "&";
        if (filter_EndDate !== undefined && filter_EndDate !== null)
            url_ += "Filter.EndDate=" + encodeURIComponent(filter_EndDate ? "" + filter_EndDate.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Federation !== undefined && filter_Federation !== null)
            url_ += "Filter.Federation=" + encodeURIComponent("" + filter_Federation) + "&";
        if (filter_Category !== undefined && filter_Category !== null)
            url_ += "Filter.Category=" + encodeURIComponent("" + filter_Category) + "&";
        if (filter_CompetitionType !== undefined && filter_CompetitionType !== null)
            url_ += "Filter.CompetitionType=" + encodeURIComponent("" + filter_CompetitionType) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfCompetitionVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfCompetitionVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfCompetitionVm>(null as any);
    }

    getById(id: number): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionCommandOfCompetition): Promise<CompetitionDetailVm> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Competitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteMatches(id: number, keep: string | null | undefined): Promise<DeleteCompetitionMatchesResultVm> {
        let url_ = this.baseUrl + "/api/Competitions/{id}/matches?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (keep !== undefined && keep !== null)
            url_ += "keep=" + encodeURIComponent("" + keep) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteMatches(_response));
        });
    }

    protected processDeleteMatches(response: Response): Promise<DeleteCompetitionMatchesResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCompetitionMatchesResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteCompetitionMatchesResultVm>(null as any);
    }

    getStandings(id: number): Promise<StandingsVm[]> {
        let url_ = this.baseUrl + "/api/Competitions/{id}/standings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStandings(_response));
        });
    }

    protected processGetStandings(response: Response): Promise<StandingsVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandingsVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandingsVm[]>(null as any);
    }

    updateStandings(id: number): Promise<StandingsVm[]> {
        let url_ = this.baseUrl + "/api/Competitions/{id}/standings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStandings(_response));
        });
    }

    protected processUpdateStandings(response: Response): Promise<StandingsVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StandingsVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StandingsVm[]>(null as any);
    }
}

export class CompetitionTeamsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    backfillFromImports(command: BackfillCompetitionTeamsRequest): Promise<BackfillCompetitionTeamsResultVm> {
        const url_ = this.baseUrl + "/api/CompetitionTeams/backfill-from-imports";
        const options_: RequestInit = {
            body: JSON.stringify(command),
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" }
        };
        return this.transformOptions(options_)
            .then(options => this.http.fetch(url_, options))
            .then(response => this.transformResult(url_, response, async (response: Response) => {
                const text = await response.text();
                if (response.status === 200) {
                    return JSON.parse(text) as BackfillCompetitionTeamsResultVm;
                }
                return throwException("Competition team backfill failed.", response.status, text, {});
            }));
    }

    create(command: CreateCompetitionTeamCommand): Promise<CompetitionTeamVm> {
        let url_ = this.baseUrl + "/api/CompetitionTeams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionTeamVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTeamVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionTeamCommandOfCompetitionTeam): Promise<CompetitionTeamVm> {
        let url_ = this.baseUrl + "/api/CompetitionTeams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTeamVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTeamVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionTeams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CompetitionTypesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CompetitionTypeVm[]> {
        let url_ = this.baseUrl + "/api/CompetitionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CompetitionTypeVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompetitionTypeVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm[]>(null as any);
    }

    create(command: CreateCompetitionTypeCommandOfCompetitionType): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CompetitionTypeVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    getById(id: number): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTypeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    update(id: number, command: UpdateCompetitionTypeCommandOfCompetitionType): Promise<CompetitionTypeVm> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CompetitionTypeVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompetitionTypeVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompetitionTypeVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/CompetitionTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CountriesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<CountryVm[]> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<CountryVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryVm[]>(null as any);
    }

    create(command: CreateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = CountryDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    getById(id: number): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    update(id: number, command: UpdateCountryCommandOfCountry): Promise<CountryDetailVm> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CountryDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDetailVm>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Countries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EventsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getLightByMatchId(matchId: number): Promise<EventLightVm[]> {
        let url_ = this.baseUrl + "/api/Events/light/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLightByMatchId(_response));
        });
    }

    protected processGetLightByMatchId(response: Response): Promise<EventLightVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventLightVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventLightVm[]>(null as any);
    }

    getByMatchId(matchId: number): Promise<EventVm[]> {
        let url_ = this.baseUrl + "/api/Events/{matchId}";
        if (matchId === undefined || matchId === null)
            throw new Error("The parameter 'matchId' must be defined.");
        url_ = url_.replace("{matchId}", encodeURIComponent("" + matchId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByMatchId(_response));
        });
    }

    protected processGetByMatchId(response: Response): Promise<EventVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm[]>(null as any);
    }

    create(command: CreateEventCommand): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = EventVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }

    update(id: number, command: UpdateEventCommand): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }

    delete(id: number): Promise<EventVm> {
        let url_ = this.baseUrl + "/api/Events/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<EventVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm>(null as any);
    }
}

export class ExternalSourceEntitiesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    refresh(command: RefreshExternalSourceCatalogCommand): Promise<ExternalSourceCatalogRefreshVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefresh(_response));
        });
    }

    protected processRefresh(response: Response): Promise<ExternalSourceCatalogRefreshVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceCatalogRefreshVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceCatalogRefreshVm>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    eurocupBackfillPlayerNameDob(command: BackfillEurocupPlayerNameDobMapsCommand): Promise<EurocupPlayerNameDobBackfillVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/eurocup-backfill-player-name-dob";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEurocupBackfillPlayerNameDob(_response));
        });
    }

    protected processEurocupBackfillPlayerNameDob(response: Response): Promise<EurocupPlayerNameDobBackfillVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EurocupPlayerNameDobBackfillVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EurocupPlayerNameDobBackfillVm>(null as any);
    }

    importGame(command: ImportHungaryGameCommand): Promise<ImportHungaryGameResultVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/import-game";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportGame(_response));
        });
    }

    protected processImportGame(response: Response): Promise<ImportHungaryGameResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHungaryGameResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHungaryGameResultVm>(null as any);
    }

    hungaryWatched(): Promise<WatchedHungaryCompetitionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/hungary-watched";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHungaryWatched(_response));
        });
    }

    protected processHungaryWatched(response: Response): Promise<WatchedHungaryCompetitionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WatchedHungaryCompetitionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WatchedHungaryCompetitionVm[]>(null as any);
    }

    hungaryCatalog(): Promise<HungaryCatalogVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/hungary-catalog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHungaryCatalog(_response));
        });
    }

    protected processHungaryCatalog(response: Response): Promise<HungaryCatalogVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HungaryCatalogVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HungaryCatalogVm>(null as any);
    }

    hungaryGames(competitionId: number | undefined): Promise<HungaryGamesListVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/hungary-games?";
        if (competitionId === null)
            throw new Error("The parameter 'competitionId' cannot be null.");
        else if (competitionId !== undefined)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHungaryGames(_response));
        });
    }

    protected processHungaryGames(response: Response): Promise<HungaryGamesListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HungaryGamesListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HungaryGamesListVm>(null as any);
    }

    syncMatches(id: number, command: SetExternalSourceSyncMatchesCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/sync-matches";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSyncMatches(_response));
        });
    }

    protected processSyncMatches(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    mvlszSeasons(): Promise<MvlszSeasonOptionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/mvlsz-seasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMvlszSeasons(_response));
        });
    }

    protected processMvlszSeasons(response: Response): Promise<MvlszSeasonOptionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MvlszSeasonOptionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MvlszSeasonOptionVm[]>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    eurocupSeasons(): Promise<MvlszSeasonOptionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/eurocup-seasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEurocupSeasons(_response));
        });
    }

    protected processEurocupSeasons(response: Response): Promise<MvlszSeasonOptionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MvlszSeasonOptionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MvlszSeasonOptionVm[]>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    eurocupWatched(): Promise<WatchedHungaryCompetitionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/eurocup-watched";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEurocupWatched(_response));
        });
    }

    protected processEurocupWatched(response: Response): Promise<WatchedHungaryCompetitionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WatchedHungaryCompetitionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WatchedHungaryCompetitionVm[]>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    eurocupGames(season: number | undefined): Promise<EurocupGamesListVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/eurocup-games?";
        if (season === null)
            throw new Error("The parameter 'season' cannot be null.");
        else if (season !== undefined)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEurocupGames(_response));
        });
    }

    protected processEurocupGames(response: Response): Promise<EurocupGamesListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EurocupGamesListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EurocupGamesListVm>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    importEurocupGame(command: ImportEurocupGameCommand): Promise<ImportHungaryGameResultVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/import-eurocup-game";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportEurocupGame(_response));
        });
    }

    protected processImportEurocupGame(response: Response): Promise<ImportHungaryGameResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHungaryGameResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHungaryGameResultVm>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    championsLeagueSeasons(): Promise<MvlszSeasonOptionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/champions-league-seasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChampionsLeagueSeasons(_response));
        });
    }

    protected processChampionsLeagueSeasons(response: Response): Promise<MvlszSeasonOptionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MvlszSeasonOptionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MvlszSeasonOptionVm[]>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    championsLeagueWatched(): Promise<WatchedHungaryCompetitionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/champions-league-watched";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChampionsLeagueWatched(_response));
        });
    }

    protected processChampionsLeagueWatched(response: Response): Promise<WatchedHungaryCompetitionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WatchedHungaryCompetitionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WatchedHungaryCompetitionVm[]>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    championsLeagueGames(season: number | undefined): Promise<ChampionsLeagueGamesListVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/champions-league-games?";
        if (season === null)
            throw new Error("The parameter 'season' cannot be null.");
        else if (season !== undefined)
            url_ += "season=" + encodeURIComponent("" + season) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChampionsLeagueGames(_response));
        });
    }

    protected processChampionsLeagueGames(response: Response): Promise<ChampionsLeagueGamesListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChampionsLeagueGamesListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChampionsLeagueGamesListVm>(null as any);
    }

    /** Legacy men's Microplus endpoint for historical season imports.
     * Use the generic microplus methods for current-season integrations; existing guards remain. */
    importChampionsLeagueGame(command: ImportChampionsLeagueGameCommand): Promise<ImportHungaryGameResultVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/import-champions-league-game";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportChampionsLeagueGame(_response));
        });
    }

    protected processImportChampionsLeagueGame(response: Response): Promise<ImportHungaryGameResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHungaryGameResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHungaryGameResultVm>(null as any);
    }

    microplusWatched(): Promise<MicroplusWatchedEventVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/microplus-watched";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMicroplusWatched(_response));
        });
    }

    protected processMicroplusWatched(response: Response): Promise<MicroplusWatchedEventVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MicroplusWatchedEventVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MicroplusWatchedEventVm[]>(null as any);
    }

    microplusGames(event: string): Promise<MicroplusGamesListVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/microplus-watched/games?";
        url_ += "event=" + encodeURIComponent(event) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMicroplusGames(_response));
        });
    }

    protected processMicroplusGames(response: Response): Promise<MicroplusGamesListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MicroplusGamesListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MicroplusGamesListVm>(null as any);
    }

    importMicroplusGame(command: ImportMicroplusGameCommand): Promise<ImportHungaryGameResultVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/import-microplus-game";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportMicroplusGame(_response));
        });
    }

    protected processImportMicroplusGame(response: Response): Promise<ImportHungaryGameResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHungaryGameResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHungaryGameResultVm>(null as any);
    }

    mvlszCompetitions(seasonId: number | null | undefined): Promise<MvlszCompetitionOptionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/mvlsz-competitions?";
        if (seasonId !== undefined && seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMvlszCompetitions(_response));
        });
    }

    protected processMvlszCompetitions(response: Response): Promise<MvlszCompetitionOptionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MvlszCompetitionOptionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MvlszCompetitionOptionVm[]>(null as any);
    }

    search(source: ExternalSourceEnum | undefined, entityType: ExternalSourceEntityTypeEnum | undefined, mapped: boolean | null | undefined, name: string | null | undefined, seasonId: number | null | undefined, competitionId: number | null | undefined, pageIndex: number | undefined, pageSize: number | undefined): Promise<ExternalSourceEntitySearchVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/search?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (mapped !== undefined && mapped !== null)
            url_ += "mapped=" + encodeURIComponent("" + mapped) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (seasonId !== undefined && seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<ExternalSourceEntitySearchVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntitySearchVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntitySearchVm>(null as any);
    }

    arenaSearch(entityType: ExternalSourceEntityTypeEnum | undefined, query: string | null | undefined, clubId: number | null | undefined): Promise<ArenaEntityCandidateVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/arena-search?";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "entityType=" + encodeURIComponent("" + entityType) + "&";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (clubId !== undefined && clubId !== null)
            url_ += "clubId=" + encodeURIComponent("" + clubId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processArenaSearch(_response));
        });
    }

    protected processArenaSearch(response: Response): Promise<ArenaEntityCandidateVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArenaEntityCandidateVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArenaEntityCandidateVm[]>(null as any);
    }

    suggestions(id: number): Promise<ExternalSourceSuggestionVm[]> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/suggestions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuggestions(_response));
        });
    }

    protected processSuggestions(response: Response): Promise<ExternalSourceSuggestionVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalSourceSuggestionVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceSuggestionVm[]>(null as any);
    }

    map(id: number, command: MapExternalSourceEntityCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/map";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMap(_response));
        });
    }

    protected processMap(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    unmap(id: number): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/unmap";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnmap(_response));
        });
    }

    protected processUnmap(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    createClub(id: number, command: CreateMappedClubCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/create-club";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateClub(_response));
        });
    }

    protected processCreateClub(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    createTeam(id: number, command: CreateMappedTeamCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/create-team";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateTeam(_response));
        });
    }

    protected processCreateTeam(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    createPlayer(id: number, command: CreateMappedPlayerCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/create-player";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePlayer(_response));
        });
    }

    protected processCreatePlayer(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }

    createPlayers(command: CreateMappedPlayersCommand): Promise<CreateMappedPlayersResultVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/create-players";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePlayers(_response));
        });
    }

    protected processCreatePlayers(response: Response): Promise<CreateMappedPlayersResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateMappedPlayersResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateMappedPlayersResultVm>(null as any);
    }

    createCompetition(id: number, command: CreateMappedCompetitionCommand): Promise<ExternalSourceEntityVm> {
        let url_ = this.baseUrl + "/api/ExternalSourceEntities/{id}/create-competition";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCompetition(_response));
        });
    }

    protected processCreateCompetition(response: Response): Promise<ExternalSourceEntityVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalSourceEntityVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalSourceEntityVm>(null as any);
    }
}

export class FederationOfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateFederationOfficialCommandOfFederationOfficial): Promise<FederationOfficialVm> {
        let url_ = this.baseUrl + "/api/FederationOfficials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FederationOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FederationOfficialVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationOfficialVm>(null as any);
    }

    update(id: number, command: UpdateFederationOfficialCommand): Promise<FederationOfficialVm> {
        let url_ = this.baseUrl + "/api/FederationOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FederationOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationOfficialVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/FederationOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class FederationsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<FederationVm[]> {
        let url_ = this.baseUrl + "/api/Federations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<FederationVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FederationVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationVm[]>(null as any);
    }

    create(command: CreateFederationCommandOfFederation): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = FederationDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Country: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfFederationVm> {
        let url_ = this.baseUrl + "/api/Federations/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfFederationVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfFederationVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfFederationVm>(null as any);
    }

    getById(id: number): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    update(id: number, command: UpdateFederationCommand): Promise<FederationDetailVm> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FederationDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FederationDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FederationDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Federations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class HealthClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MatchCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchCoachCommandOfMatchCoach): Promise<MatchCoachVm> {
        let url_ = this.baseUrl + "/api/MatchCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchCoachVm>(null as any);
    }

    update(id: number, command: UpdateMatchCoachCommandOfMatchCoach): Promise<MatchCoachVm> {
        let url_ = this.baseUrl + "/api/MatchCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchTableLinkVm implements IMatchTableLinkVm {
    url!: string;

    constructor(data?: IMatchTableLinkVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): MatchTableLinkVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchTableLinkVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

export interface IMatchTableLinkVm {
    url: string;
}

export class MatchTableLinksVm implements IMatchTableLinksVm {
    status!: string;
    message: string | undefined;
    matchId: number | undefined;
    clock: MatchTableLinkVm | undefined;
    scoreboard: MatchTableLinkVm | undefined;
    validFrom: string | undefined;
    validUntil: string | undefined;

    constructor(data?: IMatchTableLinksVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.matchId = _data["matchId"];
            this.clock = _data["clock"] ? MatchTableLinkVm.fromJS(_data["clock"]) : <any>undefined;
            this.scoreboard = _data["scoreboard"] ? MatchTableLinkVm.fromJS(_data["scoreboard"]) : <any>undefined;
            this.validFrom = _data["validFrom"];
            this.validUntil = _data["validUntil"];
        }
    }

    static fromJS(data: any): MatchTableLinksVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchTableLinksVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["matchId"] = this.matchId;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["scoreboard"] = this.scoreboard ? this.scoreboard.toJSON() : <any>undefined;
        data["validFrom"] = this.validFrom;
        data["validUntil"] = this.validUntil;
        return data;
    }
}

export interface IMatchTableLinksVm {
    status: string;
    message: string | undefined;
    matchId: number | undefined;
    clock: MatchTableLinkVm | undefined;
    scoreboard: MatchTableLinkVm | undefined;
    validFrom: string | undefined;
    validUntil: string | undefined;
}

export class MatchesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    reorderShootout(matchId: number, command: ReorderShootoutCommand): Promise<EventVm[]> {
        let url_ = this.baseUrl + "/api/Matches/" + encodeURIComponent("" + matchId) + "/shootout-order";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            body: JSON.stringify(command),
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReorderShootout(_response));
        });
    }

    protected processReorderShootout(response: Response): Promise<EventVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EventVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventVm[]>(null as any);
    }

    getAll(): Promise<MatchVm[]> {
        let url_ = this.baseUrl + "/api/Matches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<MatchVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchVm[]>(null as any);
    }

    create(command: CreateMatchCommandOfMatch): Promise<MatchDetailVm> {
        let url_ = this.baseUrl + "/api/Matches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDetailVm>(null as any);
    }

    getPaginated(paginationFilter: PaginationFilterOfMatchFilter): Promise<PaginatedListOfMatchVm> {
        let url_ = this.baseUrl + "/api/Matches/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paginationFilter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfMatchVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfMatchVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfMatchVm>(null as any);
    }

    getAnalysis(query: GetMatchAnalysisQuery): Promise<MatchAnalysisVm[]> {
        let url_ = this.baseUrl + "/api/Matches/analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAnalysis(_response));
        });
    }

    protected processGetAnalysis(response: Response): Promise<MatchAnalysisVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MatchAnalysisVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchAnalysisVm[]>(null as any);
    }

    getChanged(since: string | null | undefined, competitionId: number | null | undefined, limit: number | null | undefined, includeDeleted?: boolean | null | undefined, afterId?: number | null | undefined): Promise<MatchChangedListVm> {
        let url_ = this.baseUrl + "/api/Matches/changed?";
        if (since !== undefined && since !== null)
            url_ += "since=" + encodeURIComponent("" + since) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (includeDeleted !== undefined && includeDeleted !== null)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (afterId !== undefined && afterId !== null)
            url_ += "afterId=" + encodeURIComponent("" + afterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetChanged(_response));
        });
    }

    protected processGetChanged(response: Response): Promise<MatchChangedListVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchChangedListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchChangedListVm>(null as any);
    }

    getById(id: number): Promise<MatchDetailVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<MatchDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchDetailVm>(null as any);
    }

    getLight(id: number): Promise<MatchReadLightVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/light";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLight(_response));
        });
    }

    protected processGetLight(response: Response): Promise<MatchReadLightVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchReadLightVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchReadLightVm>(null as any);
    }

    getLineup(id: number): Promise<MatchLineupVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/lineup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLineup(_response));
        });
    }

    protected processGetLineup(response: Response): Promise<MatchLineupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchLineupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchLineupVm>(null as any);
    }

    getTableLinks(id: number): Promise<MatchTableLinksVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/table-links";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTableLinks(_response));
        });
    }

    protected processGetTableLinks(response: Response): Promise<MatchTableLinksVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchTableLinksVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchTableLinksVm>(null as any);
    }

    update(id: number, command: UpdateMatchCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getLineupFromLastFinishedMatch(id: number): Promise<LatestFinishedMatchLineupVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/lineup-from-last-finished-match";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLineupFromLastFinishedMatch(_response));
        });
    }

    protected processGetLineupFromLastFinishedMatch(response: Response): Promise<LatestFinishedMatchLineupVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LatestFinishedMatchLineupVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LatestFinishedMatchLineupVm>(null as any);
    }

    deleteEvents(id: number): Promise<DeleteMatchEventsResultVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/events";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEvents(_response));
        });
    }

    protected processDeleteEvents(response: Response): Promise<DeleteMatchEventsResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteMatchEventsResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteMatchEventsResultVm>(null as any);
    }

    openValidationWindow(id: number): Promise<ValidationWindowVm | null> {
        return this.validationWindowRequest(id, "open");
    }

    submitValidationWindow(id: number): Promise<ValidationWindowVm | null> {
        return this.validationWindowRequest(id, "submit");
    }

    private async validationWindowRequest(id: number, action: "open" | "submit"): Promise<ValidationWindowVm | null> {
        const url = this.baseUrl + "/api/Matches/" + encodeURIComponent(String(id)) + "/validation/" + action;
        const options = await this.transformOptions({ method: "POST", headers: { "Accept": "application/json" } });
        const response = await this.http.fetch(url, options);
        return this.transformResult(url, response, async (result: Response) => {
            const text = await result.text();
            if (result.status === 204) return null;
            if (result.status === 200) return text ? JSON.parse(text) : null;
            return throwException("An unexpected server error occurred.", result.status, text, {});
        });
    }

    async createValidatorGame(id: number, request: { email: string }): Promise<number> {
        const url = this.baseUrl + "/api/Matches/" + encodeURIComponent(String(id)) + "/validator-game";
        const options = await this.transformOptions({
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify(request),
        });
        const response = await this.http.fetch(url, options);
        return this.transformResult(url, response, async (result: Response) => {
            const text = await result.text();
            if (result.status === 200) return JSON.parse(text);
            throw text || "Validator game could not be created.";
        });
    }

    async bulkCreateValidatorGames(id: number, request: { emails: string }): Promise<BulkValidatorGameResult[]> {
        const url = this.baseUrl + "/api/Matches/" + encodeURIComponent(String(id)) + "/validator-games/bulk";
        const options = await this.transformOptions({
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify(request),
        });
        const response = await this.http.fetch(url, options);
        return this.transformResult(url, response, async (result: Response) => {
            const text = await result.text();
            if (result.status === 200) return JSON.parse(text);
            throw text || "Validator games could not be created.";
        });
    }

    setSyncLock(id: number, request: SetMatchSyncLockRequest): Promise<MatchSyncLockVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/sync-lock";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetSyncLock(_response));
        });
    }

    protected processSetSyncLock(response: Response): Promise<MatchSyncLockVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchSyncLockVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchSyncLockVm>(null as any);
    }

    reimportFromSource(id: number): Promise<ImportHungaryGameResultVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/reimport-from-source";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReimportFromSource(_response));
        });
    }

    protected processReimportFromSource(response: Response): Promise<ImportHungaryGameResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportHungaryGameResultVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportHungaryGameResultVm>(null as any);
    }

    startReimportJob(id: number): Promise<ReimportMatchJobVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/reimport-jobs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartReimportJob(_response));
        });
    }

    protected processStartReimportJob(response: Response): Promise<ReimportMatchJobVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReimportMatchJobVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReimportMatchJobVm>(null as any);
    }

    getReimportJob(id: number, jobId: string): Promise<ReimportMatchJobVm> {
        let url_ = this.baseUrl + "/api/Matches/{id}/reimport-jobs/{jobId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReimportJob(_response));
        });
    }

    protected processGetReimportJob(response: Response): Promise<ReimportMatchJobVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReimportMatchJobVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReimportMatchJobVm>(null as any);
    }

    updateOfficials(id: number, command: CreateOrUpdateMatchOfficialsCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/officials";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateOfficials(_response));
        });
    }

    protected processUpdateOfficials(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePlayers(id: number, command: CreateOrUpdateMatchPlayersCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/players";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePlayers(_response));
        });
    }

    protected processUpdatePlayers(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateCoaches(id: number, command: CreateOrUpdateMatchCoachesCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/coaches";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCoaches(_response));
        });
    }

    protected processUpdateCoaches(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateMatchLog(id: number, command: UpdateMatchLogCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{id}/log";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMatchLog(_response));
        });
    }

    protected processUpdateMatchLog(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateDisciplinaryNote(id: number, command: UpdateMatchDisciplinaryNoteCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/Matches/{id}/disciplinary-note";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateDisciplinaryNote(_response));
        });
    }

    protected processUpdateDisciplinaryNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmMatchLog(matchOfficialId: number, command: ConfirmMatchLogCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Matches/{matchOfficialId}/confirm";
        if (matchOfficialId === undefined || matchOfficialId === null)
            throw new Error("The parameter 'matchOfficialId' must be defined.");
        url_ = url_.replace("{matchOfficialId}", encodeURIComponent("" + matchOfficialId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmMatchLog(_response));
        });
    }

    protected processConfirmMatchLog(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchOfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchOfficialCommandOfMatchOfficial): Promise<MatchOfficialVm> {
        let url_ = this.baseUrl + "/api/MatchOfficials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchOfficialVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchOfficialVm>(null as any);
    }

    update(id: number, command: UpdateMatchOfficialCommandOfMatchOfficial): Promise<MatchOfficialVm> {
        let url_ = this.baseUrl + "/api/MatchOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchOfficialVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchOfficials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class MatchPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateMatchPlayerCommandOfMatchPlayer): Promise<MatchPlayerVm> {
        let url_ = this.baseUrl + "/api/MatchPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MatchPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = MatchPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchPlayerVm>(null as any);
    }

    update(id: number, command: UpdateMatchPlayerCommandOfMatchPlayer): Promise<MatchPlayerVm> {
        let url_ = this.baseUrl + "/api/MatchPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MatchPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/MatchPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class OfficialsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<OfficialVm[]> {
        let url_ = this.baseUrl + "/api/Officials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<OfficialVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OfficialVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialVm[]>(null as any);
    }

    create(command: CreateOfficialCommand): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OfficialDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfOfficialVm> {
        let url_ = this.baseUrl + "/api/Officials/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfOfficialVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfOfficialVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfOfficialVm>(null as any);
    }

    getById(id: number): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficialDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    update(id: number, command: UpdateOfficialCommandOfOfficial): Promise<OfficialDetailVm> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<OfficialDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfficialDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OfficialDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Officials/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePin(id: number, command: UpdateOfficialPinCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Officials/{id}/pin";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePin(_response));
        });
    }

    protected processUpdatePin(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PersonsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getAll(): Promise<PersonVm[]> {
        let url_ = this.baseUrl + "/api/Persons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PersonVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm[]>(null as any);
    }

    create(command: CreatePersonCommandOfPerson): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Persons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PersonVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    searchAll(input: string | null | undefined): Promise<PersonVm[]> {
        let url_ = this.baseUrl + "/api/Persons/search?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearchAll(_response));
        });
    }

    protected processSearchAll(response: Response): Promise<PersonVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PersonVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm[]>(null as any);
    }

    merge(id: number, command: MergePersonCommand): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Persons/{id}/merge";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMerge(_response));
        });
    }

    protected processMerge(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    update(id: number, command: UpdatePersonCommandOfPerson): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Persons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Persons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getChanged(since: string | null | undefined, limit?: number | null | undefined, includeDeleted?: boolean | null | undefined, afterId?: number | null | undefined): Promise<ChangedFeedListVm> {
        return changedFeed(this.http, this.baseUrl, "/api/Players/changed", since, limit, includeDeleted, afterId, (key, value) => this.jsonParseReviver ? this.jsonParseReviver(key, value) : value, (options) => this.transformOptions(options), (url, response, processor) => this.transformResult(url, response, processor));
    }

    getAll(): Promise<PlayerVm[]> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<PlayerVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlayerVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerVm[]>(null as any);
    }

    create(command: CreatePlayerCommand): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = PlayerDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    getPaginated(filter_Name: string | null | undefined, filter_Surname: string | null | undefined, filter_CountryOfBirth: string | null | undefined, filter_CityOfBirth: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfPlayerVm> {
        let url_ = this.baseUrl + "/api/Players/search?";
        if (filter_Name !== undefined && filter_Name !== null)
            url_ += "Filter.Name=" + encodeURIComponent("" + filter_Name) + "&";
        if (filter_Surname !== undefined && filter_Surname !== null)
            url_ += "Filter.Surname=" + encodeURIComponent("" + filter_Surname) + "&";
        if (filter_CountryOfBirth !== undefined && filter_CountryOfBirth !== null)
            url_ += "Filter.CountryOfBirth=" + encodeURIComponent("" + filter_CountryOfBirth) + "&";
        if (filter_CityOfBirth !== undefined && filter_CityOfBirth !== null)
            url_ += "Filter.CityOfBirth=" + encodeURIComponent("" + filter_CityOfBirth) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfPlayerVm>(null as any);
    }

    getLightProfile(id: number): Promise<PlayerLightProfileVm> {
        let url_ = this.baseUrl + "/api/Players/{id}/light-profile";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLightProfile(_response));
        });
    }

    protected processGetLightProfile(response: Response): Promise<PlayerLightProfileVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerLightProfileVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerLightProfileVm>(null as any);
    }

    getById(id: number): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    update(id: number, command: UpdatePlayerCommandOfPlayer): Promise<PlayerDetailVm> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<PlayerDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Players/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPlayers(playerIds: number[] | null | undefined): Promise<PlayerExtendedVm[]> {
        let url_ = this.baseUrl + "/api/Players/extended-info?";
        if (playerIds !== undefined && playerIds !== null)
            playerIds && playerIds.forEach(item => { url_ += "playerIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayers(_response));
        });
    }

    protected processGetPlayers(response: Response): Promise<PlayerExtendedVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlayerExtendedVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerExtendedVm[]>(null as any);
    }

    getPlayerStats(playerId: number | undefined, competitionId: number | null | undefined, matchId: number | null | undefined): Promise<PlayerStatsVm> {
        let url_ = this.baseUrl + "/api/Players/stats?";
        if (playerId === null)
            throw new Error("The parameter 'playerId' cannot be null.");
        else if (playerId !== undefined)
            url_ += "PlayerId=" + encodeURIComponent("" + playerId) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "CompetitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (matchId !== undefined && matchId !== null)
            url_ += "MatchId=" + encodeURIComponent("" + matchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayerStats(_response));
        });
    }

    protected processGetPlayerStats(response: Response): Promise<PlayerStatsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlayerStatsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlayerStatsVm>(null as any);
    }
}

export class SignalRDocsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    matchHubContract(): Promise<MatchMessage> {
        let url_ = this.baseUrl + "/match";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMatchHubContract(_response));
        });
    }

    protected processMatchHubContract(response: Response): Promise<MatchMessage> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchMessage.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MatchMessage>(null as any);
    }
}

export class TeamCoachesClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateTeamCoachCommandOfTeamCoach): Promise<TeamCoachVm> {
        let url_ = this.baseUrl + "/api/TeamCoaches";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamCoachVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamCoachVm>(null as any);
    }

    update(id: number, command: UpdateTeamCoachCommandOfTeamCoach): Promise<TeamCoachVm> {
        let url_ = this.baseUrl + "/api/TeamCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamCoachVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamCoachVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamCoachVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/TeamCoaches/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamPlayersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    create(command: CreateTeamPlayerCommandOfTeamPlayer): Promise<TeamPlayerVm> {
        let url_ = this.baseUrl + "/api/TeamPlayers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamPlayerVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamPlayerVm>(null as any);
    }

    update(id: number, command: UpdateTeamPlayerCommandOfTeamPlayer): Promise<TeamPlayerVm> {
        let url_ = this.baseUrl + "/api/TeamPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamPlayerVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamPlayerVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamPlayerVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/TeamPlayers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamsClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    getChanged(since: string | null | undefined, limit?: number | null | undefined, includeDeleted?: boolean | null | undefined, afterId?: number | null | undefined): Promise<ChangedFeedListVm> {
        return changedFeed(this.http, this.baseUrl, "/api/Teams/changed", since, limit, includeDeleted, afterId, (key, value) => this.jsonParseReviver ? this.jsonParseReviver(key, value) : value, (options) => this.transformOptions(options), (url, response, processor) => this.transformResult(url, response, processor));
    }

    getAll(federationId: number | null | undefined): Promise<TeamVm[]> {
        let url_ = this.baseUrl + "/api/Teams?";
        if (federationId !== undefined && federationId !== null)
            url_ += "federationId=" + encodeURIComponent("" + federationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<TeamVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamVm[]>(null as any);
    }

    create(command: CreateTeamCommandOfTeam): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = TeamDetailVm.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    getPaginated(filter_NameUniversal: string | null | undefined, filter_ShortName: string | null | undefined, filter_ActiveFrom: Date | null | undefined, filter_ActiveTo: Date | null | undefined, filter_IsPro: boolean | null | undefined, filter_Club: string | null | undefined, filter_Category: string | null | undefined, filter_Country: string | null | undefined, filter_City: string | null | undefined, pageIndex: number | null | undefined, pageSize: number | null | undefined, sortBy: string | null | undefined, sortOrder: string | null | undefined): Promise<PaginatedListOfTeamVm> {
        let url_ = this.baseUrl + "/api/Teams/search?";
        if (filter_NameUniversal !== undefined && filter_NameUniversal !== null)
            url_ += "Filter.NameUniversal=" + encodeURIComponent("" + filter_NameUniversal) + "&";
        if (filter_ShortName !== undefined && filter_ShortName !== null)
            url_ += "Filter.ShortName=" + encodeURIComponent("" + filter_ShortName) + "&";
        if (filter_ActiveFrom !== undefined && filter_ActiveFrom !== null)
            url_ += "Filter.ActiveFrom=" + encodeURIComponent(filter_ActiveFrom ? "" + filter_ActiveFrom.toISOString() : "") + "&";
        if (filter_ActiveTo !== undefined && filter_ActiveTo !== null)
            url_ += "Filter.ActiveTo=" + encodeURIComponent(filter_ActiveTo ? "" + filter_ActiveTo.toISOString() : "") + "&";
        if (filter_IsPro !== undefined && filter_IsPro !== null)
            url_ += "Filter.IsPro=" + encodeURIComponent("" + filter_IsPro) + "&";
        if (filter_Club !== undefined && filter_Club !== null)
            url_ += "Filter.Club=" + encodeURIComponent("" + filter_Club) + "&";
        if (filter_Category !== undefined && filter_Category !== null)
            url_ += "Filter.Category=" + encodeURIComponent("" + filter_Category) + "&";
        if (filter_Country !== undefined && filter_Country !== null)
            url_ += "Filter.Country=" + encodeURIComponent("" + filter_Country) + "&";
        if (filter_City !== undefined && filter_City !== null)
            url_ += "Filter.City=" + encodeURIComponent("" + filter_City) + "&";
        if (pageIndex !== undefined && pageIndex !== null)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortBy !== undefined && sortBy !== null)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPaginated(_response));
        });
    }

    protected processGetPaginated(response: Response): Promise<PaginatedListOfTeamVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTeamVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTeamVm>(null as any);
    }

    getById(id: number): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    update(id: number, command: UpdateTeamCommandOfTeam): Promise<TeamDetailVm> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TeamDetailVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamDetailVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDetailVm>(null as any);
    }

    delete(id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getMissingShortName(): Promise<TeamMissingShortNameVm[]> {
        let url_ = this.baseUrl + "/api/Teams/missing-short-name";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMissingShortName(_response));
        });
    }

    protected processGetMissingShortName(response: Response): Promise<TeamMissingShortNameVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMissingShortNameVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMissingShortNameVm[]>(null as any);
    }

    getTeamMinInfo(competitionId: number | null | undefined, teamIds: number[] | null | undefined): Promise<TeamMinInfoDto[]> {
        let url_ = this.baseUrl + "/api/Teams/min-info?";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "competitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (teamIds !== undefined && teamIds !== null)
            teamIds && teamIds.forEach(item => { url_ += "teamIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTeamMinInfo(_response));
        });
    }

    protected processGetTeamMinInfo(response: Response): Promise<TeamMinInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMinInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMinInfoDto[]>(null as any);
    }

    getPlayerStats(teamId: number | undefined, competitionId: number | null | undefined, matchId: number | null | undefined): Promise<TeamStatsVm> {
        let url_ = this.baseUrl + "/api/Teams/stats?";
        if (teamId === null)
            throw new Error("The parameter 'teamId' cannot be null.");
        else if (teamId !== undefined)
            url_ += "TeamId=" + encodeURIComponent("" + teamId) + "&";
        if (competitionId !== undefined && competitionId !== null)
            url_ += "CompetitionId=" + encodeURIComponent("" + competitionId) + "&";
        if (matchId !== undefined && matchId !== null)
            url_ += "MatchId=" + encodeURIComponent("" + matchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPlayerStats(_response));
        });
    }

    protected processGetPlayerStats(response: Response): Promise<TeamStatsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TeamStatsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamStatsVm>(null as any);
    }
}

export class UsersClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    async resendConfirmation(id: string): Promise<void> {
        const url = this.baseUrl + "/api/Users/" + encodeURIComponent(id) + "/resend-confirmation";
        const options = await this.transformOptions({
            method: "POST",
            headers: { "Accept": "application/json" },
        });
        const response = await this.http.fetch(url, options);
        return this.transformResult(url, response, async (result: Response) => {
            if (result.status === 204) return;
            throw (await result.text()) || "Confirmation email could not be sent.";
        });
    }

    getAll(): Promise<UserVm[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<UserVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserVm.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm[]>(null as any);
    }

    create(command: CreateUserCommand): Promise<ApplicationUser> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ApplicationUser> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApplicationUser.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUser>(null as any);
    }

    getById(id: string): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    update(id: string, command: UpdateUserCommand): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserVm>(null as any);
    }

    delete(id: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ApiTokenCreatedVm implements IApiTokenCreatedVm {
    token!: string;
    apiToken!: ApiTokenVm;

    constructor(data?: IApiTokenCreatedVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.apiToken = _data["apiToken"] ? ApiTokenVm.fromJS(_data["apiToken"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiTokenCreatedVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTokenCreatedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["apiToken"] = this.apiToken ? this.apiToken.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiTokenCreatedVm {
    token: string;
    apiToken: ApiTokenVm;
}

export class ApiTokenVm implements IApiTokenVm {
    id!: number;
    tokenId!: string;
    name!: string;
    roles!: string;
    createdById!: string | undefined;
    createdDate!: Date;
    expiresAt!: Date;
    revokedDate!: Date | undefined;
    isRevoked!: boolean;
    isExpired!: boolean;
    isActive!: boolean;

    constructor(data?: IApiTokenVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tokenId = _data["tokenId"];
            this.name = _data["name"];
            this.roles = _data["roles"];
            this.createdById = _data["createdById"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
            this.revokedDate = _data["revokedDate"] ? new Date(_data["revokedDate"].toString()) : <any>undefined;
            this.isRevoked = _data["isRevoked"];
            this.isExpired = _data["isExpired"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ApiTokenVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTokenVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tokenId"] = this.tokenId;
        data["name"] = this.name;
        data["roles"] = this.roles;
        data["createdById"] = this.createdById;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        data["revokedDate"] = this.revokedDate ? this.revokedDate.toISOString() : <any>undefined;
        data["isRevoked"] = this.isRevoked;
        data["isExpired"] = this.isExpired;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IApiTokenVm {
    id: number;
    tokenId: string;
    name: string;
    roles: string;
    createdById: string | undefined;
    createdDate: Date;
    expiresAt: Date;
    revokedDate: Date | undefined;
    isRevoked: boolean;
    isExpired: boolean;
    isActive: boolean;
}

export class CreateApiTokenRequest implements ICreateApiTokenRequest {
    name!: string | undefined;
    role!: string | undefined;
    expiresAt!: Date;

    constructor(data?: ICreateApiTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.role = _data["role"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateApiTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["role"] = this.role;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateApiTokenRequest {
    name: string | undefined;
    role: string | undefined;
    expiresAt: Date;
}

export class CategoryVm implements ICategoryVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    gender!: string | undefined;
    shouldPlayersAdvanceCategoryYearly!: boolean;
    lowerAgeLimit!: number | undefined;
    upperAgeLimit!: number | undefined;

    constructor(data?: ICategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.gender = _data["gender"];
            this.shouldPlayersAdvanceCategoryYearly = _data["shouldPlayersAdvanceCategoryYearly"];
            this.lowerAgeLimit = _data["lowerAgeLimit"];
            this.upperAgeLimit = _data["upperAgeLimit"];
        }
    }

    static fromJS(data: any): CategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["gender"] = this.gender;
        data["shouldPlayersAdvanceCategoryYearly"] = this.shouldPlayersAdvanceCategoryYearly;
        data["lowerAgeLimit"] = this.lowerAgeLimit;
        data["upperAgeLimit"] = this.upperAgeLimit;
        return data;
    }
}

export interface ICategoryVm {
    id: number;
    name: string;
    nameUniversal: string;
    description: string | undefined;
    gender: string | undefined;
    shouldPlayersAdvanceCategoryYearly: boolean;
    lowerAgeLimit: number | undefined;
    upperAgeLimit: number | undefined;
}

export class CreateCategoryCommandOfCategory implements ICreateCategoryCommandOfCategory {
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    shouldPlayersAdvanceCategoryYearly!: boolean;
    lowerAgeLimit!: number | undefined;
    upperAgeLimit!: number | undefined;
    genderId!: GenderEnum;

    constructor(data?: ICreateCategoryCommandOfCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.shouldPlayersAdvanceCategoryYearly = _data["shouldPlayersAdvanceCategoryYearly"];
            this.lowerAgeLimit = _data["lowerAgeLimit"];
            this.upperAgeLimit = _data["upperAgeLimit"];
            this.genderId = _data["genderId"];
        }
    }

    static fromJS(data: any): CreateCategoryCommandOfCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryCommandOfCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["shouldPlayersAdvanceCategoryYearly"] = this.shouldPlayersAdvanceCategoryYearly;
        data["lowerAgeLimit"] = this.lowerAgeLimit;
        data["upperAgeLimit"] = this.upperAgeLimit;
        data["genderId"] = this.genderId;
        return data;
    }
}

export interface ICreateCategoryCommandOfCategory {
    name: string;
    nameUniversal: string;
    description: string | undefined;
    shouldPlayersAdvanceCategoryYearly: boolean;
    lowerAgeLimit: number | undefined;
    upperAgeLimit: number | undefined;
    genderId: GenderEnum;
}

export enum GenderEnum {
    Male = 100,
    Female = 101,
    Mixed = 102,
}

export class UpdateCategoryCommandOfCategory extends CreateCategoryCommandOfCategory implements IUpdateCategoryCommandOfCategory {
    id!: number;

    constructor(data?: IUpdateCategoryCommandOfCategory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCategoryCommandOfCategory {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryCommandOfCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCategoryCommandOfCategory extends ICreateCategoryCommandOfCategory {
    id: number;
}

export class CityVm implements ICityVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    countryId!: number;
    country!: string;

    constructor(data?: ICityVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
        }
    }

    static fromJS(data: any): CityVm {
        data = typeof data === 'object' ? data : {};
        let result = new CityVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        return data;
    }
}

export interface ICityVm {
    id: number;
    name: string;
    nameUniversal: string;
    countryId: number;
    country: string;
}

export class CreateCityCommandOfCity implements ICreateCityCommandOfCity {
    name!: string;
    nameUniversal!: string;
    countryId!: number;

    constructor(data?: ICreateCityCommandOfCity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateCityCommandOfCity {
    name: string;
    nameUniversal: string;
    countryId: number;
}

export class UpdateCityCommandOfCity extends CreateCityCommandOfCity implements IUpdateCityCommandOfCity {
    id!: number;

    constructor(data?: IUpdateCityCommandOfCity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCityCommandOfCity {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCityCommandOfCity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCityCommandOfCity extends ICreateCityCommandOfCity {
    id: number;
}

export class ClubCoachVm implements IClubCoachVm {
    id!: number | undefined;
    clubId!: number;
    coachId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    club!: ClubVm;
    coach!: CoachVm;

    constructor(data?: IClubCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clubId = _data["clubId"];
            this.coachId = _data["coachId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.club = _data["club"] ? ClubVm.fromJS(_data["club"]) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clubId"] = this.clubId;
        data["coachId"] = this.coachId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClubCoachVm {
    id: number | undefined;
    clubId: number;
    coachId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    club: ClubVm;
    coach: CoachVm;
}

export class ClubVm implements IClubVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    president!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    isPro!: boolean;
    isNational!: boolean;
    federationId!: number | undefined;
    federation!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: IClubVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.president = _data["president"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.isPro = _data["isPro"];
            this.isNational = _data["isNational"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): ClubVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["president"] = this.president;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["isPro"] = this.isPro;
        data["isNational"] = this.isNational;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface IClubVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    president: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    isPro: boolean;
    isNational: boolean;
    federationId: number | undefined;
    federation: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class CoachVm implements ICoachVm {
    id!: number;
    personId!: number;
    name!: string;
    surname!: string;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: ICoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): CoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new CoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface ICoachVm {
    id: number;
    personId: number;
    name: string;
    surname: string;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export class CreateClubCoachCommandOfClubCoach implements ICreateClubCoachCommandOfClubCoach {
    clubId!: number;
    coachId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateClubCoachCommandOfClubCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.coachId = _data["coachId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateClubCoachCommandOfClubCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubCoachCommandOfClubCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["coachId"] = this.coachId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateClubCoachCommandOfClubCoach {
    clubId: number;
    coachId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateClubCoachCommandOfClubCoach extends CreateClubCoachCommandOfClubCoach implements IUpdateClubCoachCommandOfClubCoach {
    id!: number;

    constructor(data?: IUpdateClubCoachCommandOfClubCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubCoachCommandOfClubCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubCoachCommandOfClubCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubCoachCommandOfClubCoach extends ICreateClubCoachCommandOfClubCoach {
    id: number;
}

export class ClubPlayerVm implements IClubPlayerVm {
    id!: number | undefined;
    clubId!: number;
    playerId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    club!: ClubVm;
    player!: PlayerVm;

    constructor(data?: IClubPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clubId = _data["clubId"];
            this.playerId = _data["playerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.club = _data["club"] ? ClubVm.fromJS(_data["club"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ClubPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clubId"] = this.clubId;
        data["playerId"] = this.playerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["club"] = this.club ? this.club.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }
}

export interface IClubPlayerVm {
    id: number | undefined;
    clubId: number;
    playerId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    club: ClubVm;
    player: PlayerVm;
}

export class PlayerVm implements IPlayerVm {
    id!: number;
    personId!: number;
    birthDate!: Date;
    name!: string;
    surname!: string;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: IPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): PlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface IPlayerVm {
    id: number;
    personId: number;
    birthDate: Date;
    name: string;
    surname: string;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export enum PlayerPositionEnum {
    Goalkeeper = 400,
    Driver = 401,
    Left_Driver = 402,
    Right_Driver = 403,
    Central_Defender = 404,
    Left_Winger = 405,
    Right_Winger = 406,
    Center_Forward = 407,
}

export class CreateClubPlayerCommandOfClubPlayer implements ICreateClubPlayerCommandOfClubPlayer {
    clubId!: number;
    playerId!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateClubPlayerCommandOfClubPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clubId = _data["clubId"];
            this.playerId = _data["playerId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateClubPlayerCommandOfClubPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubPlayerCommandOfClubPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clubId"] = this.clubId;
        data["playerId"] = this.playerId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateClubPlayerCommandOfClubPlayer {
    clubId: number;
    playerId: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateClubPlayerCommandOfClubPlayer extends CreateClubPlayerCommandOfClubPlayer implements IUpdateClubPlayerCommandOfClubPlayer {
    id!: number;

    constructor(data?: IUpdateClubPlayerCommandOfClubPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubPlayerCommandOfClubPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubPlayerCommandOfClubPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubPlayerCommandOfClubPlayer extends ICreateClubPlayerCommandOfClubPlayer {
    id: number;
}

export class PaginatedListOfClubVm implements IPaginatedListOfClubVm {
    pageItems!: ClubVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfClubVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ClubVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfClubVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfClubVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfClubVm {
    pageItems: ClubVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class ClubDetailVm extends ClubVm implements IClubDetailVm {
    logo!: string | undefined;
    teams!: TeamVm[];
    players!: ClubPlayerVm[];
    coaches!: ClubCoachVm[];

    constructor(data?: IClubDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(ClubPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(ClubCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClubDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new ClubDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IClubDetailVm extends IClubVm {
    logo: string | undefined;
    teams: TeamVm[];
    players: ClubPlayerVm[];
    coaches: ClubCoachVm[];
}

export class TeamVm implements ITeamVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    isPro!: boolean;
    clubId!: number | undefined;
    federation!: string;
    federationId!: number;
    club!: string;
    categoryId!: number;
    category!: string;
    gender!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: ITeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.isPro = _data["isPro"];
            this.clubId = _data["clubId"];
            this.federation = _data["federation"];
            this.federationId = _data["federationId"];
            this.club = _data["club"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.gender = _data["gender"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): TeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["isPro"] = this.isPro;
        data["clubId"] = this.clubId;
        data["federation"] = this.federation;
        data["federationId"] = this.federationId;
        data["club"] = this.club;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["gender"] = this.gender;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface ITeamVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    isPro: boolean;
    clubId: number | undefined;
    federation: string;
    federationId: number;
    club: string;
    categoryId: number;
    category: string;
    gender: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class CreateClubCommandOfClub implements ICreateClubCommandOfClub {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    president!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    isNational!: boolean;
    federationId!: number | undefined;
    countryId!: number | undefined;
    cityId!: number | undefined;
    teamCategories!: number[] | undefined;

    constructor(data?: ICreateClubCommandOfClub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.president = _data["president"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.isNational = _data["isNational"];
            this.federationId = _data["federationId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            if (Array.isArray(_data["teamCategories"])) {
                this.teamCategories = [] as any;
                for (let item of _data["teamCategories"])
                    this.teamCategories!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateClubCommandOfClub {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClubCommandOfClub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["president"] = this.president;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["isNational"] = this.isNational;
        data["federationId"] = this.federationId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        if (Array.isArray(this.teamCategories)) {
            data["teamCategories"] = [];
            for (let item of this.teamCategories)
                data["teamCategories"].push(item);
        }
        return data;
    }
}

export interface ICreateClubCommandOfClub {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    president: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    isNational: boolean;
    federationId: number | undefined;
    countryId: number | undefined;
    cityId: number | undefined;
    teamCategories: number[] | undefined;
}

export class UpdateClubCommandOfClub extends CreateClubCommandOfClub implements IUpdateClubCommandOfClub {
    id!: number;

    constructor(data?: IUpdateClubCommandOfClub) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateClubCommandOfClub {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClubCommandOfClub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateClubCommandOfClub extends ICreateClubCommandOfClub {
    id: number;
}

export class PaginatedListOfCoachVm implements IPaginatedListOfCoachVm {
    pageItems!: CoachVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(CoachVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfCoachVm {
    pageItems: CoachVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CoachDetailVm implements ICoachDetailVm {
    id!: number;
    personId!: number;
    person!: PersonVm;
    matches!: MatchCoachVm[];
    teams!: TeamCoachVm[];
    clubs!: ClubCoachVm[];

    constructor(data?: ICoachDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoachDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CoachDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoachDetailVm {
    id: number;
    personId: number;
    person: PersonVm;
    matches: MatchCoachVm[];
    teams: TeamCoachVm[];
    clubs: ClubCoachVm[];
}

export class PersonVm implements IPersonVm {
    id!: number;
    name!: string;
    surname!: string;
    birthDate!: Date;
    nationality!: string | undefined;
    address!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    photo!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;
    coachId!: number | undefined;
    officialId!: number | undefined;
    playerId!: number | undefined;
    coach!: CoachVm | undefined;
    official!: OfficialVm | undefined;
    player!: PlayerVm | undefined;

    constructor(data?: IPersonVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.photo = _data["photo"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
            this.coachId = _data["coachId"];
            this.officialId = _data["officialId"];
            this.playerId = _data["playerId"];
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonVm {
        data = typeof data === 'object' ? data : {};
        let result = new PersonVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["photo"] = this.photo;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        data["coachId"] = this.coachId;
        data["officialId"] = this.officialId;
        data["playerId"] = this.playerId;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPersonVm {
    id: number;
    name: string;
    surname: string;
    birthDate: Date;
    nationality: string | undefined;
    address: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    photo: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
    coachId: number | undefined;
    officialId: number | undefined;
    playerId: number | undefined;
    coach: CoachVm | undefined;
    official: OfficialVm | undefined;
    player: PlayerVm | undefined;
}

export class OfficialVm implements IOfficialVm {
    id!: number;
    personId!: number;
    name!: string;
    surname!: string;
    title!: string | undefined;
    countryOfBirthId!: number | undefined;
    countryOfBirth!: string | undefined;
    cityOfBirthId!: number | undefined;
    cityOfBirth!: string | undefined;

    constructor(data?: IOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.personId = _data["personId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.title = _data["title"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.countryOfBirth = _data["countryOfBirth"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.cityOfBirth = _data["cityOfBirth"];
        }
    }

    static fromJS(data: any): OfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["personId"] = this.personId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["title"] = this.title;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["countryOfBirth"] = this.countryOfBirth;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["cityOfBirth"] = this.cityOfBirth;
        return data;
    }
}

export interface IOfficialVm {
    id: number;
    personId: number;
    name: string;
    surname: string;
    title: string | undefined;
    countryOfBirthId: number | undefined;
    countryOfBirth: string | undefined;
    cityOfBirthId: number | undefined;
    cityOfBirth: string | undefined;
}

export class MatchCoachVm implements IMatchCoachVm {
    id!: number | undefined;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    match!: MatchVm;
    coach!: CoachVm;
    team!: TeamVm;
    role!: string;

    constructor(data?: IMatchCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): MatchCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IMatchCoachVm {
    id: number | undefined;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    match: MatchVm;
    coach: CoachVm;
    team: TeamVm;
    role: string;
}

export enum CoachRoleEnum {
    Head_Coach = 500,
    Assistant_Coach = 501,
}

export class MatchVm implements IMatchVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    federationId!: number;
    federationDisplayName!: string;
    competitionId!: number;
    competitionDisplayName!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string | undefined;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    statusId!: MatchStatusEnum;
    status!: string;
    matchSegmentId!: MatchSegmentEnum;
    matchSegment!: string;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    referees!: OfficialVm[];
    delegates!: OfficialVm[];
    secretaries!: OfficialVm[];
    disciplinaryNote!: string | undefined;
    syncLocked!: boolean;
    lastModifiedUtc!: Date | undefined;
    revision!: number | undefined;

    constructor(data?: IMatchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.federationId = _data["federationId"];
            this.federationDisplayName = _data["federationDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegment = _data["matchSegment"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            if (Array.isArray(_data["referees"])) {
                this.referees = [] as any;
                for (let item of _data["referees"])
                    this.referees!.push(OfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["delegates"])) {
                this.delegates = [] as any;
                for (let item of _data["delegates"])
                    this.delegates!.push(OfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["secretaries"])) {
                this.secretaries = [] as any;
                for (let item of _data["secretaries"])
                    this.secretaries!.push(OfficialVm.fromJS(item));
            }
            this.disciplinaryNote = _data["disciplinaryNote"];
            this.syncLocked = _data["syncLocked"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.revision = _data["revision"];
        }
    }

    static fromJS(data: any): MatchVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["federationId"] = this.federationId;
        data["federationDisplayName"] = this.federationDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegment"] = this.matchSegment;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        if (Array.isArray(this.referees)) {
            data["referees"] = [];
            for (let item of this.referees)
                data["referees"].push(item.toJSON());
        }
        if (Array.isArray(this.delegates)) {
            data["delegates"] = [];
            for (let item of this.delegates)
                data["delegates"].push(item.toJSON());
        }
        if (Array.isArray(this.secretaries)) {
            data["secretaries"] = [];
            for (let item of this.secretaries)
                data["secretaries"].push(item.toJSON());
        }
        data["disciplinaryNote"] = this.disciplinaryNote;
        data["syncLocked"] = this.syncLocked;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["revision"] = this.revision;
        return data;
    }
}

export interface IMatchVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    federationId: number;
    federationDisplayName: string;
    competitionId: number;
    competitionDisplayName: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string | undefined;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    startDate: Date;
    endDate: Date | undefined;
    statusId: MatchStatusEnum;
    status: string;
    matchSegmentId: MatchSegmentEnum;
    matchSegment: string;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    referees: OfficialVm[];
    delegates: OfficialVm[];
    secretaries: OfficialVm[];
    disciplinaryNote: string | undefined;
    syncLocked: boolean;
    lastModifiedUtc: Date | undefined;
    revision: number | undefined;
}

export enum MatchStatusEnum {
    Not_Started = 200,
    First_Period = 201,
    Second_Period = 202,
    Third_Period = 203,
    Fourth_Period = 204,
    Overtime = 205,
    Finished = 206,
    Cancelled = 207,
}

export enum MatchSegmentEnum {
    Single = 300,
    Half = 301,
    Third = 302,
    Quarter = 303,
}

export class TeamCoachVm implements ITeamCoachVm {
    id!: number | undefined;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    coach!: CoachVm;
    team!: TeamVm;
    role!: string;

    constructor(data?: ITeamCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): TeamCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface ITeamCoachVm {
    id: number | undefined;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    coach: CoachVm;
    team: TeamVm;
    role: string;
}

export class CreateCoachCommand implements ICreateCoachCommand {
    personId!: number;
    clubs!: CreateClubCoachCommandOfClubCoach[] | undefined;
    teams!: CreateTeamCoachCommandOfTeamCoach[] | undefined;

    constructor(data?: ICreateCoachCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(CreateClubCoachCommandOfClubCoach.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(CreateTeamCoachCommandOfTeamCoach.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCoachCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCoachCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateCoachCommand {
    personId: number;
    clubs: CreateClubCoachCommandOfClubCoach[] | undefined;
    teams: CreateTeamCoachCommandOfTeamCoach[] | undefined;
}

export class CreateTeamCoachCommandOfTeamCoach implements ICreateTeamCoachCommandOfTeamCoach {
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateTeamCoachCommandOfTeamCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTeamCoachCommandOfTeamCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCoachCommandOfTeamCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateTeamCoachCommandOfTeamCoach {
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class CompetitionVm implements ICompetitionVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    extraCompetitionStages!: string[];
    season!: string | undefined;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    matchLogTemplateLanguage!: string | undefined;
    isPro!: boolean;
    isInternational!: boolean;
    gameLogPinConfirmationRequired!: boolean;
    matchSegmentId!: MatchSegmentEnum;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    federationId!: number;
    federation!: string;
    categoryId!: number | undefined;
    category!: string | undefined;
    competitionTypeId!: number | undefined;
    competitionType!: string | undefined;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: ICompetitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            if (Array.isArray(_data["extraCompetitionStages"])) {
                this.extraCompetitionStages = [] as any;
                for (let item of _data["extraCompetitionStages"])
                    this.extraCompetitionStages!.push(item);
            }
            this.season = _data["season"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.matchLogTemplateLanguage = _data["matchLogTemplateLanguage"];
            this.isPro = _data["isPro"];
            this.isInternational = _data["isInternational"];
            this.gameLogPinConfirmationRequired = _data["gameLogPinConfirmationRequired"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.competitionTypeId = _data["competitionTypeId"];
            this.competitionType = _data["competitionType"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): CompetitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (Array.isArray(this.extraCompetitionStages)) {
            data["extraCompetitionStages"] = [];
            for (let item of this.extraCompetitionStages)
                data["extraCompetitionStages"].push(item);
        }
        data["season"] = this.season;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["matchLogTemplateLanguage"] = this.matchLogTemplateLanguage;
        data["isPro"] = this.isPro;
        data["isInternational"] = this.isInternational;
        data["gameLogPinConfirmationRequired"] = this.gameLogPinConfirmationRequired;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["competitionTypeId"] = this.competitionTypeId;
        data["competitionType"] = this.competitionType;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface ICompetitionVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    extraCompetitionStages: string[];
    season: string | undefined;
    startDate: Date | undefined;
    endDate: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    matchLogTemplateLanguage: string | undefined;
    isPro: boolean;
    isInternational: boolean;
    gameLogPinConfirmationRequired: boolean;
    matchSegmentId: MatchSegmentEnum;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    federationId: number;
    federation: string;
    categoryId: number | undefined;
    category: string | undefined;
    competitionTypeId: number | undefined;
    competitionType: string | undefined;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
}

export class PaginatedListOfCompetitionVm implements IPaginatedListOfCompetitionVm {
    pageItems!: CompetitionVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfCompetitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(CompetitionVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfCompetitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfCompetitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfCompetitionVm {
    pageItems: CompetitionVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class CompetitionDetailVm extends CompetitionVm implements ICompetitionDetailVm {
    logo!: string | undefined;
    competitionTeams!: CompetitionTeamVm[];
    matches!: MatchVm[];

    constructor(data?: ICompetitionDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["competitionTeams"])) {
                this.competitionTeams = [] as any;
                for (let item of _data["competitionTeams"])
                    this.competitionTeams!.push(CompetitionTeamVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompetitionDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.competitionTeams)) {
            data["competitionTeams"] = [];
            for (let item of this.competitionTeams)
                data["competitionTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompetitionDetailVm extends ICompetitionVm {
    logo: string | undefined;
    competitionTeams: CompetitionTeamVm[];
    matches: MatchVm[];
}

export class CompetitionTeamVm implements ICompetitionTeamVm {
    id!: number;
    description!: string | undefined;
    isDisqualified!: boolean;
    isSeed!: boolean;
    competitionId!: number;
    competition!: CompetitionVm;
    teamId!: number;
    team!: TeamVm;

    constructor(data?: ICompetitionTeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isDisqualified = _data["isDisqualified"];
            this.isSeed = _data["isSeed"];
            this.competitionId = _data["competitionId"];
            this.competition = _data["competition"] ? CompetitionVm.fromJS(_data["competition"]) : <any>undefined;
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompetitionTeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionTeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isDisqualified"] = this.isDisqualified;
        data["isSeed"] = this.isSeed;
        data["competitionId"] = this.competitionId;
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompetitionTeamVm {
    id: number;
    description: string | undefined;
    isDisqualified: boolean;
    isSeed: boolean;
    competitionId: number;
    competition: CompetitionVm;
    teamId: number;
    team: TeamVm;
}

export class CreateCompetitionCommandOfCompetition implements ICreateCompetitionCommandOfCompetition {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    extraCompetitionStages!: string[] | undefined;
    season!: string;
    startDate!: Date | undefined;
    endDate!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    matchLogTemplateLanguage!: string | undefined;
    isPro!: boolean;
    isInternational!: boolean;
    gameLogPinConfirmationRequired!: boolean;
    matchSegmentId!: MatchSegmentEnum;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    federationId!: number;
    categoryId!: number | undefined;
    competitionTypeId!: number | undefined;
    countryId!: number | undefined;
    cityId!: number | undefined;

    constructor(data?: ICreateCompetitionCommandOfCompetition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            if (Array.isArray(_data["extraCompetitionStages"])) {
                this.extraCompetitionStages = [] as any;
                for (let item of _data["extraCompetitionStages"])
                    this.extraCompetitionStages!.push(item);
            }
            this.season = _data["season"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.matchLogTemplateLanguage = _data["matchLogTemplateLanguage"];
            this.isPro = _data["isPro"];
            this.isInternational = _data["isInternational"];
            this.gameLogPinConfirmationRequired = _data["gameLogPinConfirmationRequired"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.federationId = _data["federationId"];
            this.categoryId = _data["categoryId"];
            this.competitionTypeId = _data["competitionTypeId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): CreateCompetitionCommandOfCompetition {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionCommandOfCompetition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        if (Array.isArray(this.extraCompetitionStages)) {
            data["extraCompetitionStages"] = [];
            for (let item of this.extraCompetitionStages)
                data["extraCompetitionStages"].push(item);
        }
        data["season"] = this.season;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["matchLogTemplateLanguage"] = this.matchLogTemplateLanguage;
        data["isPro"] = this.isPro;
        data["isInternational"] = this.isInternational;
        data["gameLogPinConfirmationRequired"] = this.gameLogPinConfirmationRequired;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["federationId"] = this.federationId;
        data["categoryId"] = this.categoryId;
        data["competitionTypeId"] = this.competitionTypeId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        return data;
    }
}

export interface ICreateCompetitionCommandOfCompetition {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    extraCompetitionStages: string[] | undefined;
    season: string;
    startDate: Date | undefined;
    endDate: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    matchLogTemplateLanguage: string | undefined;
    isPro: boolean;
    isInternational: boolean;
    gameLogPinConfirmationRequired: boolean;
    matchSegmentId: MatchSegmentEnum;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    federationId: number;
    categoryId: number | undefined;
    competitionTypeId: number | undefined;
    countryId: number | undefined;
    cityId: number | undefined;
}

export class UpdateCompetitionCommandOfCompetition extends CreateCompetitionCommandOfCompetition implements IUpdateCompetitionCommandOfCompetition {
    id!: number;

    constructor(data?: IUpdateCompetitionCommandOfCompetition) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionCommandOfCompetition {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionCommandOfCompetition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionCommandOfCompetition extends ICreateCompetitionCommandOfCompetition {
    id: number;
}

export class DeleteCompetitionMatchesResultVm implements IDeleteCompetitionMatchesResultVm {
    deletedCount!: number;
    deletedMatchIds!: number[] | undefined;

    constructor(data?: IDeleteCompetitionMatchesResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletedCount = _data["deletedCount"];
            if (Array.isArray(_data["deletedMatchIds"])) {
                this.deletedMatchIds = [] as any;
                for (let item of _data["deletedMatchIds"])
                    this.deletedMatchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteCompetitionMatchesResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCompetitionMatchesResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletedCount"] = this.deletedCount;
        if (Array.isArray(this.deletedMatchIds)) {
            data["deletedMatchIds"] = [];
            for (let item of this.deletedMatchIds)
                data["deletedMatchIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteCompetitionMatchesResultVm {
    deletedCount: number;
    deletedMatchIds: number[] | undefined;
}

export class StandingsVm implements IStandingsVm {
    standingType!: StandingTypeEnum;
    rankings!: StandingVm[] | undefined;

    constructor(data?: IStandingsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standingType = _data["standingType"];
            if (Array.isArray(_data["rankings"])) {
                this.rankings = [] as any;
                for (let item of _data["rankings"])
                    this.rankings!.push(StandingVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StandingsVm {
        data = typeof data === 'object' ? data : {};
        let result = new StandingsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standingType"] = this.standingType;
        if (Array.isArray(this.rankings)) {
            data["rankings"] = [];
            for (let item of this.rankings)
                data["rankings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStandingsVm {
    standingType: StandingTypeEnum;
    rankings: StandingVm[] | undefined;
}

export enum StandingTypeEnum {
    Group = 1400,
    Knockout = 1401,
    Competition = 1402,
}

export class StandingVm implements IStandingVm {
    id!: number;
    competitionId!: number;
    competition!: string | undefined;
    team!: string | undefined;
    teamId!: number;
    played!: number;
    drawn!: number;
    won!: number;
    lost!: number;
    goalsScored!: number;
    goalsConceded!: number;
    goalsDiff!: number;
    points!: number;
    rank!: number;

    constructor(data?: IStandingVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.competitionId = _data["competitionId"];
            this.competition = _data["competition"];
            this.team = _data["team"];
            this.teamId = _data["teamId"];
            this.played = _data["played"];
            this.drawn = _data["drawn"];
            this.won = _data["won"];
            this.lost = _data["lost"];
            this.goalsScored = _data["goalsScored"];
            this.goalsConceded = _data["goalsConceded"];
            this.goalsDiff = _data["goalsDiff"];
            this.points = _data["points"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): StandingVm {
        data = typeof data === 'object' ? data : {};
        let result = new StandingVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["competitionId"] = this.competitionId;
        data["competition"] = this.competition;
        data["team"] = this.team;
        data["teamId"] = this.teamId;
        data["played"] = this.played;
        data["drawn"] = this.drawn;
        data["won"] = this.won;
        data["lost"] = this.lost;
        data["goalsScored"] = this.goalsScored;
        data["goalsConceded"] = this.goalsConceded;
        data["goalsDiff"] = this.goalsDiff;
        data["points"] = this.points;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IStandingVm {
    id: number;
    competitionId: number;
    competition: string | undefined;
    team: string | undefined;
    teamId: number;
    played: number;
    drawn: number;
    won: number;
    lost: number;
    goalsScored: number;
    goalsConceded: number;
    goalsDiff: number;
    points: number;
    rank: number;
}

export class CreateCompetitionTeamCommand implements ICreateCompetitionTeamCommand {
    description!: string | undefined;
    isDisqualified!: boolean;
    isSeed!: boolean;
    competitionId!: number;
    teamId!: number;

    constructor(data?: ICreateCompetitionTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.isDisqualified = _data["isDisqualified"];
            this.isSeed = _data["isSeed"];
            this.competitionId = _data["competitionId"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): CreateCompetitionTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["isDisqualified"] = this.isDisqualified;
        data["isSeed"] = this.isSeed;
        data["competitionId"] = this.competitionId;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface ICreateCompetitionTeamCommand {
    description: string | undefined;
    isDisqualified: boolean;
    isSeed: boolean;
    competitionId: number;
    teamId: number;
}

export class UpdateCompetitionTeamCommandOfCompetitionTeam extends CreateCompetitionTeamCommand implements IUpdateCompetitionTeamCommandOfCompetitionTeam {
    id!: number;

    constructor(data?: IUpdateCompetitionTeamCommandOfCompetitionTeam) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionTeamCommandOfCompetitionTeam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionTeamCommandOfCompetitionTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionTeamCommandOfCompetitionTeam extends ICreateCompetitionTeamCommand {
    id: number;
}

export class CompetitionTypeVm implements ICompetitionTypeVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    code!: string | undefined;

    constructor(data?: ICompetitionTypeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CompetitionTypeVm {
        data = typeof data === 'object' ? data : {};
        let result = new CompetitionTypeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ICompetitionTypeVm {
    id: number;
    name: string;
    nameUniversal: string;
    description: string | undefined;
    code: string | undefined;
}

export class CreateCompetitionTypeCommandOfCompetitionType implements ICreateCompetitionTypeCommandOfCompetitionType {
    name!: string;
    nameUniversal!: string;
    description!: string | undefined;
    code!: string | undefined;

    constructor(data?: ICreateCompetitionTypeCommandOfCompetitionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.description = _data["description"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateCompetitionTypeCommandOfCompetitionType {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompetitionTypeCommandOfCompetitionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["description"] = this.description;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateCompetitionTypeCommandOfCompetitionType {
    name: string;
    nameUniversal: string;
    description: string | undefined;
    code: string | undefined;
}

export class UpdateCompetitionTypeCommandOfCompetitionType extends CreateCompetitionTypeCommandOfCompetitionType implements IUpdateCompetitionTypeCommandOfCompetitionType {
    id!: number;

    constructor(data?: IUpdateCompetitionTypeCommandOfCompetitionType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCompetitionTypeCommandOfCompetitionType {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompetitionTypeCommandOfCompetitionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCompetitionTypeCommandOfCompetitionType extends ICreateCompetitionTypeCommandOfCompetitionType {
    id: number;
}

export class CountryVm implements ICountryVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICountryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CountryVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICountryVm {
    id: number;
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class CountryDetailVm extends CountryVm implements ICountryDetailVm {
    cities!: CityVm[];

    constructor(data?: ICountryDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["cities"])) {
                this.cities = [] as any;
                for (let item of _data["cities"])
                    this.cities!.push(CityVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            for (let item of this.cities)
                data["cities"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICountryDetailVm extends ICountryVm {
    cities: CityVm[];
}

export class CreateCountryCommandOfCountry implements ICreateCountryCommandOfCountry {
    name!: string;
    nameUniversal!: string;
    code!: string | undefined;

    constructor(data?: ICreateCountryCommandOfCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateCountryCommandOfCountry {
    name: string;
    nameUniversal: string;
    code: string | undefined;
}

export class UpdateCountryCommandOfCountry extends CreateCountryCommandOfCountry implements IUpdateCountryCommandOfCountry {
    id!: number;

    constructor(data?: IUpdateCountryCommandOfCountry) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCountryCommandOfCountry {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCountryCommandOfCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateCountryCommandOfCountry extends ICreateCountryCommandOfCountry {
    id: number;
}

export class EventLightVm implements IEventLightVm {
    id!: number;
    matchId!: number;
    type!: string | undefined;
    periodId!: number;
    period!: string | undefined;
    minute!: number;
    seconds!: number;
    shootoutOrder?: number;
    shot!: EventShotLightVm | undefined;
    exclusion!: EventExclusionLightVm | undefined;
    turnover!: EventTurnoverLightVm | undefined;
    swimoff!: EventSwimoffLightVm | undefined;
    card!: EventCardLightVm | undefined;
    timeout!: EventTimeoutLightVm | undefined;
    challenge!: EventChallengeLightVm | undefined;
    goalkeeperChange!: EventGoalkeeperChangeLightVm | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;
    typeId!: number;
    clientEventKey!: string | undefined;
    timeoutId!: number | undefined;
    swimoffId!: number | undefined;
    cardId!: number | undefined;
    turnoverId!: number | undefined;
    exclusionId!: number | undefined;
    shotId!: number | undefined;
    challengeId!: number | undefined;
    goalkeeperChangeId!: number | undefined;

    constructor(data?: IEventLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.type = _data["type"];
            this.periodId = _data["periodId"];
            this.period = _data["period"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.shootoutOrder = _data["shootoutOrder"];
            this.shot = _data["shot"] ? EventShotLightVm.fromJS(_data["shot"]) : <any>undefined;
            this.exclusion = _data["exclusion"] ? EventExclusionLightVm.fromJS(_data["exclusion"]) : <any>undefined;
            this.turnover = _data["turnover"] ? EventTurnoverLightVm.fromJS(_data["turnover"]) : <any>undefined;
            this.swimoff = _data["swimoff"] ? EventSwimoffLightVm.fromJS(_data["swimoff"]) : <any>undefined;
            this.card = _data["card"] ? EventCardLightVm.fromJS(_data["card"]) : <any>undefined;
            this.timeout = _data["timeout"] ? EventTimeoutLightVm.fromJS(_data["timeout"]) : <any>undefined;
            this.challenge = _data["challenge"] ? EventChallengeLightVm.fromJS(_data["challenge"]) : <any>undefined;
            this.goalkeeperChange = _data["goalkeeperChange"] ? EventGoalkeeperChangeLightVm.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
            this.typeId = _data["typeId"];
            this.clientEventKey = _data["clientEventKey"];
            this.timeoutId = _data["timeoutId"];
            this.swimoffId = _data["swimoffId"];
            this.cardId = _data["cardId"];
            this.turnoverId = _data["turnoverId"];
            this.exclusionId = _data["exclusionId"];
            this.shotId = _data["shotId"];
            this.challengeId = _data["challengeId"];
            this.goalkeeperChangeId = _data["goalkeeperChangeId"];
        }
    }

    static fromJS(data: any): EventLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["type"] = this.type;
        data["periodId"] = this.periodId;
        data["period"] = this.period;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["shootoutOrder"] = this.shootoutOrder;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        data["typeId"] = this.typeId;
        data["clientEventKey"] = this.clientEventKey;
        data["timeoutId"] = this.timeoutId;
        data["swimoffId"] = this.swimoffId;
        data["cardId"] = this.cardId;
        data["turnoverId"] = this.turnoverId;
        data["exclusionId"] = this.exclusionId;
        data["shotId"] = this.shotId;
        data["challengeId"] = this.challengeId;
        data["goalkeeperChangeId"] = this.goalkeeperChangeId;
        return data;
    }
}

export interface IEventLightVm {
    id: number;
    matchId: number;
    type: string | undefined;
    periodId: number;
    period: string | undefined;
    minute: number;
    seconds: number;
    shootoutOrder?: number;
    shot: EventShotLightVm | undefined;
    exclusion: EventExclusionLightVm | undefined;
    turnover: EventTurnoverLightVm | undefined;
    swimoff: EventSwimoffLightVm | undefined;
    card: EventCardLightVm | undefined;
    timeout: EventTimeoutLightVm | undefined;
    challenge: EventChallengeLightVm | undefined;
    goalkeeperChange: EventGoalkeeperChangeLightVm | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
    typeId: number;
    clientEventKey: string | undefined;
    timeoutId: number | undefined;
    swimoffId: number | undefined;
    cardId: number | undefined;
    turnoverId: number | undefined;
    exclusionId: number | undefined;
    shotId: number | undefined;
    challengeId: number | undefined;
    goalkeeperChangeId: number | undefined;
}

export class EventShotLightVm implements IEventShotLightVm {
    teamId!: number;
    type!: string | undefined;
    takenById!: number;
    blockedById!: number | undefined;
    assistedById!: number | undefined;
    savedById!: number | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;
    id!: number;
    typeId!: number;

    constructor(data?: IEventShotLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.takenById = _data["takenById"];
            this.blockedById = _data["blockedById"];
            this.assistedById = _data["assistedById"];
            this.savedById = _data["savedById"];
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
            this.id = _data["id"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): EventShotLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventShotLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["takenById"] = this.takenById;
        data["blockedById"] = this.blockedById;
        data["assistedById"] = this.assistedById;
        data["savedById"] = this.savedById;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface IEventShotLightVm {
    teamId: number;
    type: string | undefined;
    takenById: number;
    blockedById: number | undefined;
    assistedById: number | undefined;
    savedById: number | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
    id: number;
    typeId: number;
}

export class EventExclusionLightVm implements IEventExclusionLightVm {
    teamId!: number;
    type!: string | undefined;
    excludedPlayerId!: number | undefined;
    fouledPlayerId!: number | undefined;
    assistedById!: number | undefined;
    locationX!: number | undefined;
    locationY!: number | undefined;
    isDoubleExclusion!: boolean;
    isPenaltyExclusion!: boolean;
    excludedCoachId!: number | undefined;
    id!: number;
    typeId!: number;

    constructor(data?: IEventExclusionLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.assistedById = _data["assistedById"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.isDoubleExclusion = _data["isDoubleExclusion"];
            this.isPenaltyExclusion = _data["isPenaltyExclusion"];
            this.excludedCoachId = _data["excludedCoachId"];
            this.id = _data["id"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): EventExclusionLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventExclusionLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["assistedById"] = this.assistedById;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["isDoubleExclusion"] = this.isDoubleExclusion;
        data["isPenaltyExclusion"] = this.isPenaltyExclusion;
        data["excludedCoachId"] = this.excludedCoachId;
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface IEventExclusionLightVm {
    teamId: number;
    type: string | undefined;
    excludedPlayerId: number | undefined;
    fouledPlayerId: number | undefined;
    assistedById: number | undefined;
    locationX: number | undefined;
    locationY: number | undefined;
    isDoubleExclusion: boolean;
    isPenaltyExclusion: boolean;
    excludedCoachId: number | undefined;
    id: number;
    typeId: number;
}

export class EventTurnoverLightVm implements IEventTurnoverLightVm {
    teamId!: number;
    type!: string | undefined;
    lostPossesionPlayerId!: number | undefined;
    wonPossesionPlayerId!: number | undefined;
    id!: number;
    typeId!: number;

    constructor(data?: IEventTurnoverLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.type = _data["type"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
            this.id = _data["id"];
            this.typeId = _data["typeId"];
        }
    }

    static fromJS(data: any): EventTurnoverLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTurnoverLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["type"] = this.type;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        return data;
    }
}

export interface IEventTurnoverLightVm {
    teamId: number;
    type: string | undefined;
    lostPossesionPlayerId: number | undefined;
    wonPossesionPlayerId: number | undefined;
    id: number;
    typeId: number;
}

export class EventSwimoffLightVm implements IEventSwimoffLightVm {
    winnerTeamId!: number | undefined;
    winnerSwimmerId!: number | undefined;
    homeTeamSwimmerId!: number | undefined;
    awayTeamSwimmerId!: number | undefined;
    id!: number;

    constructor(data?: IEventSwimoffLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerSwimmerId = _data["winnerSwimmerId"];
            this.homeTeamSwimmerId = _data["homeTeamSwimmerId"];
            this.awayTeamSwimmerId = _data["awayTeamSwimmerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventSwimoffLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventSwimoffLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        data["homeTeamSwimmerId"] = this.homeTeamSwimmerId;
        data["awayTeamSwimmerId"] = this.awayTeamSwimmerId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventSwimoffLightVm {
    winnerTeamId: number | undefined;
    winnerSwimmerId: number | undefined;
    homeTeamSwimmerId: number | undefined;
    awayTeamSwimmerId: number | undefined;
    id: number;
}

export class EventCardLightVm implements IEventCardLightVm {
    teamId!: number;
    cardedPlayerId!: number | undefined;
    type!: string | undefined;
    typeId!: number;
    cardedCoachId!: number | undefined;
    id!: number;

    constructor(data?: IEventCardLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.cardedPlayerId = _data["cardedPlayerId"];
            this.type = _data["type"];
            this.typeId = _data["typeId"];
            this.cardedCoachId = _data["cardedCoachId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventCardLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventCardLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["cardedPlayerId"] = this.cardedPlayerId;
        data["type"] = this.type;
        data["typeId"] = this.typeId;
        data["cardedCoachId"] = this.cardedCoachId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventCardLightVm {
    teamId: number;
    cardedPlayerId: number | undefined;
    type: string | undefined;
    typeId: number;
    cardedCoachId: number | undefined;
    id: number;
}

export class EventTimeoutLightVm implements IEventTimeoutLightVm {
    teamId!: number;
    id!: number;

    constructor(data?: IEventTimeoutLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventTimeoutLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimeoutLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventTimeoutLightVm {
    teamId: number;
    id: number;
}

export class EventChallengeLightVm implements IEventChallengeLightVm {
    teamId!: number;
    isSuccessful!: boolean;
    id!: number;

    constructor(data?: IEventChallengeLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventChallengeLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventChallengeLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventChallengeLightVm {
    teamId: number;
    isSuccessful: boolean;
    id: number;
}

export class EventGoalkeeperChangeLightVm implements IEventGoalkeeperChangeLightVm {
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;
    id!: number;

    constructor(data?: IEventGoalkeeperChangeLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EventGoalkeeperChangeLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventGoalkeeperChangeLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEventGoalkeeperChangeLightVm {
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
    id: number;
}

export class EventVm implements IEventVm {
    id!: number;
    periodId!: EventPeriodEnum;
    period!: string;
    minute!: number;
    seconds!: number;
    shootoutOrder?: number;
    matchId!: number;
    match!: MatchVm;
    typeId!: EventTypeEnum;
    type!: string;
    timeoutId!: number | undefined;
    timeout!: EventTimeoutVm | undefined;
    swimoffId!: number | undefined;
    swimoff!: EventSwimoffVm | undefined;
    cardId!: number | undefined;
    card!: EventCardVm | undefined;
    turnoverId!: number | undefined;
    turnover!: EventTurnoverVm | undefined;
    exclusionId!: number | undefined;
    exclusion!: EventExclusionVm | undefined;
    shotId!: number | undefined;
    shot!: EventShotVm | undefined;
    challengeId!: number | undefined;
    challenge!: EventChallengeVm | undefined;
    goalkeeperChangeId!: number | undefined;
    goalkeeperChange!: EventGoalkeeperChangeVm | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;
    clientEventKey!: string | undefined;

    constructor(data?: IEventVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.periodId = _data["periodId"];
            this.period = _data["period"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.shootoutOrder = _data["shootoutOrder"];
            this.matchId = _data["matchId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.timeoutId = _data["timeoutId"];
            this.timeout = _data["timeout"] ? EventTimeoutVm.fromJS(_data["timeout"]) : <any>undefined;
            this.swimoffId = _data["swimoffId"];
            this.swimoff = _data["swimoff"] ? EventSwimoffVm.fromJS(_data["swimoff"]) : <any>undefined;
            this.cardId = _data["cardId"];
            this.card = _data["card"] ? EventCardVm.fromJS(_data["card"]) : <any>undefined;
            this.turnoverId = _data["turnoverId"];
            this.turnover = _data["turnover"] ? EventTurnoverVm.fromJS(_data["turnover"]) : <any>undefined;
            this.exclusionId = _data["exclusionId"];
            this.exclusion = _data["exclusion"] ? EventExclusionVm.fromJS(_data["exclusion"]) : <any>undefined;
            this.shotId = _data["shotId"];
            this.shot = _data["shot"] ? EventShotVm.fromJS(_data["shot"]) : <any>undefined;
            this.challengeId = _data["challengeId"];
            this.challenge = _data["challenge"] ? EventChallengeVm.fromJS(_data["challenge"]) : <any>undefined;
            this.goalkeeperChangeId = _data["goalkeeperChangeId"];
            this.goalkeeperChange = _data["goalkeeperChange"] ? EventGoalkeeperChangeVm.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
            this.clientEventKey = _data["clientEventKey"];
        }
    }

    static fromJS(data: any): EventVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["periodId"] = this.periodId;
        data["period"] = this.period;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["shootoutOrder"] = this.shootoutOrder;
        data["matchId"] = this.matchId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["timeoutId"] = this.timeoutId;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["swimoffId"] = this.swimoffId;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["cardId"] = this.cardId;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["turnoverId"] = this.turnoverId;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["exclusionId"] = this.exclusionId;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["shotId"] = this.shotId;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["challengeId"] = this.challengeId;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["goalkeeperChangeId"] = this.goalkeeperChangeId;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        data["clientEventKey"] = this.clientEventKey;
        return data;
    }
}

export interface IEventVm {
    id: number;
    periodId: EventPeriodEnum;
    period: string;
    minute: number;
    seconds: number;
    shootoutOrder?: number;
    matchId: number;
    match: MatchVm;
    typeId: EventTypeEnum;
    type: string;
    timeoutId: number | undefined;
    timeout: EventTimeoutVm | undefined;
    swimoffId: number | undefined;
    swimoff: EventSwimoffVm | undefined;
    cardId: number | undefined;
    card: EventCardVm | undefined;
    turnoverId: number | undefined;
    turnover: EventTurnoverVm | undefined;
    exclusionId: number | undefined;
    exclusion: EventExclusionVm | undefined;
    shotId: number | undefined;
    shot: EventShotVm | undefined;
    challengeId: number | undefined;
    challenge: EventChallengeVm | undefined;
    goalkeeperChangeId: number | undefined;
    goalkeeperChange: EventGoalkeeperChangeVm | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
    clientEventKey: string | undefined;
}

export enum EventPeriodEnum {
    First_Period = 1200,
    Second_Period = 1201,
    Third_Period = 1202,
    Fourth_Period = 1203,
    Overtime = 1204,
}

export enum EventTypeEnum {
    Timeout = 700,
    Swim_Off = 701,
    Card = 702,
    Turnover = 703,
    Exclusion = 704,
    Shot = 705,
    Challenge = 706,
    Goalkeeper_Change = 707,
}

export class EventTimeoutVm implements IEventTimeoutVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;

    constructor(data?: IEventTimeoutVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTimeoutVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTimeoutVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTimeoutVm {
    id: number;
    teamId: number;
    team: TeamVm;
}

export class EventSwimoffVm implements IEventSwimoffVm {
    id!: number;
    homeTeamSwimmerId!: number | undefined;
    homeTeamSwimmer!: EventMatchPlayerVm | undefined;
    awayTeamSwimmerId!: number | undefined;
    awayTeamSwimmer!: EventMatchPlayerVm | undefined;
    winnerTeamId!: number | undefined;
    winnerTeam!: TeamVm | undefined;
    winnerSwimmerId!: number | undefined;
    winnerSwimmer!: EventMatchPlayerVm | undefined;

    constructor(data?: IEventSwimoffVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamSwimmerId = _data["homeTeamSwimmerId"];
            this.homeTeamSwimmer = _data["homeTeamSwimmer"] ? EventMatchPlayerVm.fromJS(_data["homeTeamSwimmer"]) : <any>undefined;
            this.awayTeamSwimmerId = _data["awayTeamSwimmerId"];
            this.awayTeamSwimmer = _data["awayTeamSwimmer"] ? EventMatchPlayerVm.fromJS(_data["awayTeamSwimmer"]) : <any>undefined;
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerTeam = _data["winnerTeam"] ? TeamVm.fromJS(_data["winnerTeam"]) : <any>undefined;
            this.winnerSwimmerId = _data["winnerSwimmerId"];
            this.winnerSwimmer = _data["winnerSwimmer"] ? EventMatchPlayerVm.fromJS(_data["winnerSwimmer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventSwimoffVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventSwimoffVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamSwimmerId"] = this.homeTeamSwimmerId;
        data["homeTeamSwimmer"] = this.homeTeamSwimmer ? this.homeTeamSwimmer.toJSON() : <any>undefined;
        data["awayTeamSwimmerId"] = this.awayTeamSwimmerId;
        data["awayTeamSwimmer"] = this.awayTeamSwimmer ? this.awayTeamSwimmer.toJSON() : <any>undefined;
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerTeam"] = this.winnerTeam ? this.winnerTeam.toJSON() : <any>undefined;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        data["winnerSwimmer"] = this.winnerSwimmer ? this.winnerSwimmer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventSwimoffVm {
    id: number;
    homeTeamSwimmerId: number | undefined;
    homeTeamSwimmer: EventMatchPlayerVm | undefined;
    awayTeamSwimmerId: number | undefined;
    awayTeamSwimmer: EventMatchPlayerVm | undefined;
    winnerTeamId: number | undefined;
    winnerTeam: TeamVm | undefined;
    winnerSwimmerId: number | undefined;
    winnerSwimmer: EventMatchPlayerVm | undefined;
}

export class EventMatchPlayerVm implements IEventMatchPlayerVm {
    id!: number | undefined;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: IEventMatchPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): EventMatchPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventMatchPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface IEventMatchPlayerVm {
    id: number | undefined;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class EventCardVm implements IEventCardVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: CardTypeEnum;
    type!: string;
    cardedPlayerId!: number | undefined;
    cardedPlayer!: EventMatchPlayerVm | undefined;
    cardedCoachId!: number | undefined;
    cardedCoach!: EventMatchCoachVm | undefined;

    constructor(data?: IEventCardVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.cardedPlayerId = _data["cardedPlayerId"];
            this.cardedPlayer = _data["cardedPlayer"] ? EventMatchPlayerVm.fromJS(_data["cardedPlayer"]) : <any>undefined;
            this.cardedCoachId = _data["cardedCoachId"];
            this.cardedCoach = _data["cardedCoach"] ? EventMatchCoachVm.fromJS(_data["cardedCoach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventCardVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventCardVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["cardedPlayerId"] = this.cardedPlayerId;
        data["cardedPlayer"] = this.cardedPlayer ? this.cardedPlayer.toJSON() : <any>undefined;
        data["cardedCoachId"] = this.cardedCoachId;
        data["cardedCoach"] = this.cardedCoach ? this.cardedCoach.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventCardVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: CardTypeEnum;
    type: string;
    cardedPlayerId: number | undefined;
    cardedPlayer: EventMatchPlayerVm | undefined;
    cardedCoachId: number | undefined;
    cardedCoach: EventMatchCoachVm | undefined;
}

export enum CardTypeEnum {
    Yellow = 800,
    Red = 801,
}

export class EventMatchCoachVm implements IEventMatchCoachVm {
    id!: number | undefined;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;

    constructor(data?: IEventMatchCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): EventMatchCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventMatchCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IEventMatchCoachVm {
    id: number | undefined;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
}

export class EventTurnoverVm implements IEventTurnoverVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: TurnoverTypeEnum;
    type!: string;
    lostPossesionPlayerId!: number | undefined;
    lostPossesionPlayer!: EventMatchPlayerVm;
    wonPossesionPlayerId!: number | undefined;
    wonPossesionPlayer!: EventMatchPlayerVm | undefined;

    constructor(data?: IEventTurnoverVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.lostPossesionPlayer = _data["lostPossesionPlayer"] ? EventMatchPlayerVm.fromJS(_data["lostPossesionPlayer"]) : <any>undefined;
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
            this.wonPossesionPlayer = _data["wonPossesionPlayer"] ? EventMatchPlayerVm.fromJS(_data["wonPossesionPlayer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventTurnoverVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventTurnoverVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["lostPossesionPlayer"] = this.lostPossesionPlayer ? this.lostPossesionPlayer.toJSON() : <any>undefined;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        data["wonPossesionPlayer"] = this.wonPossesionPlayer ? this.wonPossesionPlayer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventTurnoverVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: TurnoverTypeEnum;
    type: string;
    lostPossesionPlayerId: number | undefined;
    lostPossesionPlayer: EventMatchPlayerVm;
    wonPossesionPlayerId: number | undefined;
    wonPossesionPlayer: EventMatchPlayerVm | undefined;
}

export enum TurnoverTypeEnum {
    Lost_Ball = 900,
    Offensive_Foul = 901,
    Ball_Under = 902,
    Clock_Expired = 903,
}

export class EventExclusionVm implements IEventExclusionVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: ExclusionTypeEnum;
    type!: string;
    excludedPlayerId!: number | undefined;
    excludedPlayer!: EventMatchPlayerVm | undefined;
    excludedCoachId!: number | undefined;
    excludedCoach!: EventMatchCoachVm | undefined;
    fouledPlayerId!: number | undefined;
    fouledPlayer!: EventMatchPlayerVm | undefined;
    assistedById!: number | undefined;
    assistedBy!: EventMatchPlayerVm | undefined;
    isPenaltyExclusion!: boolean;
    isDoubleExclusion!: boolean;
    locationX!: number | undefined;
    locationY!: number | undefined;

    constructor(data?: IEventExclusionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.excludedPlayer = _data["excludedPlayer"] ? EventMatchPlayerVm.fromJS(_data["excludedPlayer"]) : <any>undefined;
            this.excludedCoachId = _data["excludedCoachId"];
            this.excludedCoach = _data["excludedCoach"] ? EventMatchCoachVm.fromJS(_data["excludedCoach"]) : <any>undefined;
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.fouledPlayer = _data["fouledPlayer"] ? EventMatchPlayerVm.fromJS(_data["fouledPlayer"]) : <any>undefined;
            this.assistedById = _data["assistedById"];
            this.assistedBy = _data["assistedBy"] ? EventMatchPlayerVm.fromJS(_data["assistedBy"]) : <any>undefined;
            this.isPenaltyExclusion = _data["isPenaltyExclusion"];
            this.isDoubleExclusion = _data["isDoubleExclusion"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
        }
    }

    static fromJS(data: any): EventExclusionVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventExclusionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["excludedPlayer"] = this.excludedPlayer ? this.excludedPlayer.toJSON() : <any>undefined;
        data["excludedCoachId"] = this.excludedCoachId;
        data["excludedCoach"] = this.excludedCoach ? this.excludedCoach.toJSON() : <any>undefined;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["fouledPlayer"] = this.fouledPlayer ? this.fouledPlayer.toJSON() : <any>undefined;
        data["assistedById"] = this.assistedById;
        data["assistedBy"] = this.assistedBy ? this.assistedBy.toJSON() : <any>undefined;
        data["isPenaltyExclusion"] = this.isPenaltyExclusion;
        data["isDoubleExclusion"] = this.isDoubleExclusion;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        return data;
    }
}

export interface IEventExclusionVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: ExclusionTypeEnum;
    type: string;
    excludedPlayerId: number | undefined;
    excludedPlayer: EventMatchPlayerVm | undefined;
    excludedCoachId: number | undefined;
    excludedCoach: EventMatchCoachVm | undefined;
    fouledPlayerId: number | undefined;
    fouledPlayer: EventMatchPlayerVm | undefined;
    assistedById: number | undefined;
    assistedBy: EventMatchPlayerVm | undefined;
    isPenaltyExclusion: boolean;
    isDoubleExclusion: boolean;
    locationX: number | undefined;
    locationY: number | undefined;
}

export enum ExclusionTypeEnum {
    Exclusion = 1000,
    Suspension = 1001,
    Brutality = 1002,
    Penalty = 1003,
}

export class EventShotVm implements IEventShotVm {
    id!: number;
    teamId!: number;
    team!: TeamVm;
    typeId!: ShotTypeEnum;
    type!: string;
    takenById!: number;
    takenBy!: EventMatchPlayerVm;
    blockedById!: number | undefined;
    blockedBy!: EventMatchPlayerVm | undefined;
    assistedById!: number | undefined;
    assistedBy!: EventMatchPlayerVm | undefined;
    savedById!: number | undefined;
    savedBy!: EventMatchPlayerVm | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;

    constructor(data?: IEventShotVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.takenById = _data["takenById"];
            this.takenBy = _data["takenBy"] ? EventMatchPlayerVm.fromJS(_data["takenBy"]) : <any>undefined;
            this.blockedById = _data["blockedById"];
            this.blockedBy = _data["blockedBy"] ? EventMatchPlayerVm.fromJS(_data["blockedBy"]) : <any>undefined;
            this.assistedById = _data["assistedById"];
            this.assistedBy = _data["assistedBy"] ? EventMatchPlayerVm.fromJS(_data["assistedBy"]) : <any>undefined;
            this.savedById = _data["savedById"];
            this.savedBy = _data["savedBy"] ? EventMatchPlayerVm.fromJS(_data["savedBy"]) : <any>undefined;
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
        }
    }

    static fromJS(data: any): EventShotVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventShotVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["takenById"] = this.takenById;
        data["takenBy"] = this.takenBy ? this.takenBy.toJSON() : <any>undefined;
        data["blockedById"] = this.blockedById;
        data["blockedBy"] = this.blockedBy ? this.blockedBy.toJSON() : <any>undefined;
        data["assistedById"] = this.assistedById;
        data["assistedBy"] = this.assistedBy ? this.assistedBy.toJSON() : <any>undefined;
        data["savedById"] = this.savedById;
        data["savedBy"] = this.savedBy ? this.savedBy.toJSON() : <any>undefined;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        return data;
    }
}

export interface IEventShotVm {
    id: number;
    teamId: number;
    team: TeamVm;
    typeId: ShotTypeEnum;
    type: string;
    takenById: number;
    takenBy: EventMatchPlayerVm;
    blockedById: number | undefined;
    blockedBy: EventMatchPlayerVm | undefined;
    assistedById: number | undefined;
    assistedBy: EventMatchPlayerVm | undefined;
    savedById: number | undefined;
    savedBy: EventMatchPlayerVm | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
}

export enum ShotTypeEnum {
    Regular_Attack = 1100,
    Penalty = 1101,
    Power_Play = 1102,
    Penalty_Shootout = 1103,
}

export class EventChallengeVm implements IEventChallengeVm {
    id!: number;
    teamId!: number;
    isSuccessful!: boolean;
    team!: TeamVm;

    constructor(data?: IEventChallengeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EventChallengeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventChallengeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventChallengeVm {
    id: number;
    teamId: number;
    isSuccessful: boolean;
    team: TeamVm;
}

export class EventGoalkeeperChangeVm implements IEventGoalkeeperChangeVm {
    id!: number;
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;

    constructor(data?: IEventGoalkeeperChangeVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
        }
    }

    static fromJS(data: any): EventGoalkeeperChangeVm {
        data = typeof data === 'object' ? data : {};
        let result = new EventGoalkeeperChangeVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        return data;
    }
}

export interface IEventGoalkeeperChangeVm {
    id: number;
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
}

export class ReorderShootoutCommand implements IReorderShootoutCommand {
    eventIds!: number[];
    expectedRevision!: number;
    constructor(data?: IReorderShootoutCommand) {
        if (data) { this.eventIds = data.eventIds; this.expectedRevision = data.expectedRevision; }
    }
    init(_data?: any) {
        if (_data) { this.eventIds = _data["eventIds"]; this.expectedRevision = _data["expectedRevision"]; }
    }
    static fromJS(data: any): ReorderShootoutCommand {
        const result = new ReorderShootoutCommand(); result.init(data); return result;
    }
    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventIds"] = this.eventIds;
        data["expectedRevision"] = this.expectedRevision;
        return data;
    }
}
export interface IReorderShootoutCommand {
    eventIds: number[];
    expectedRevision: number;
}

export class CreateEventCommand implements ICreateEventCommand {
    matchId!: number;
    typeId!: EventTypeEnum;
    periodId!: EventPeriodEnum;
    minute!: number;
    seconds!: number;
    shootoutAfterEventId?: number;
    isShootout?: boolean;
    card!: CardRequest;
    exclusion!: ExclusionRequest;
    shot!: ShotRequest;
    swimoff!: SwimoffRequest;
    timeout!: TimeoutRequest;
    challenge!: ChallengeRequest;
    turnover!: TurnoverRequest;
    goalkeeperChange!: GoalkeeperChangeRequest | undefined;
    activeHomeGoalkeeperMatchPlayerId!: number | undefined;
    activeAwayGoalkeeperMatchPlayerId!: number | undefined;
    refereeMistake!: number | undefined;
    clientEventKey!: string | undefined;

    constructor(data?: ICreateEventCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.card = new CardRequest();
            this.exclusion = new ExclusionRequest();
            this.shot = new ShotRequest();
            this.swimoff = new SwimoffRequest();
            this.timeout = new TimeoutRequest();
            this.challenge = new ChallengeRequest();
            this.turnover = new TurnoverRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.typeId = _data["typeId"];
            this.periodId = _data["periodId"];
            this.minute = _data["minute"];
            this.seconds = _data["seconds"];
            this.shootoutAfterEventId = _data["shootoutAfterEventId"];
            this.isShootout = _data["isShootout"];
            this.card = _data["card"] ? CardRequest.fromJS(_data["card"]) : new CardRequest();
            this.exclusion = _data["exclusion"] ? ExclusionRequest.fromJS(_data["exclusion"]) : new ExclusionRequest();
            this.shot = _data["shot"] ? ShotRequest.fromJS(_data["shot"]) : new ShotRequest();
            this.swimoff = _data["swimoff"] ? SwimoffRequest.fromJS(_data["swimoff"]) : new SwimoffRequest();
            this.timeout = _data["timeout"] ? TimeoutRequest.fromJS(_data["timeout"]) : new TimeoutRequest();
            this.challenge = _data["challenge"] ? ChallengeRequest.fromJS(_data["challenge"]) : new ChallengeRequest();
            this.turnover = _data["turnover"] ? TurnoverRequest.fromJS(_data["turnover"]) : new TurnoverRequest();
            this.goalkeeperChange = _data["goalkeeperChange"] ? GoalkeeperChangeRequest.fromJS(_data["goalkeeperChange"]) : <any>undefined;
            this.activeHomeGoalkeeperMatchPlayerId = _data["activeHomeGoalkeeperMatchPlayerId"];
            this.activeAwayGoalkeeperMatchPlayerId = _data["activeAwayGoalkeeperMatchPlayerId"];
            this.refereeMistake = _data["refereeMistake"];
            this.clientEventKey = _data["clientEventKey"];
        }
    }

    static fromJS(data: any): CreateEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["typeId"] = this.typeId;
        data["periodId"] = this.periodId;
        data["minute"] = this.minute;
        data["seconds"] = this.seconds;
        data["shootoutAfterEventId"] = this.shootoutAfterEventId;
        data["isShootout"] = this.isShootout;
        data["card"] = this.card ? this.card.toJSON() : <any>undefined;
        data["exclusion"] = this.exclusion ? this.exclusion.toJSON() : <any>undefined;
        data["shot"] = this.shot ? this.shot.toJSON() : <any>undefined;
        data["swimoff"] = this.swimoff ? this.swimoff.toJSON() : <any>undefined;
        data["timeout"] = this.timeout ? this.timeout.toJSON() : <any>undefined;
        data["challenge"] = this.challenge ? this.challenge.toJSON() : <any>undefined;
        data["turnover"] = this.turnover ? this.turnover.toJSON() : <any>undefined;
        data["goalkeeperChange"] = this.goalkeeperChange ? this.goalkeeperChange.toJSON() : <any>undefined;
        data["activeHomeGoalkeeperMatchPlayerId"] = this.activeHomeGoalkeeperMatchPlayerId;
        data["activeAwayGoalkeeperMatchPlayerId"] = this.activeAwayGoalkeeperMatchPlayerId;
        data["refereeMistake"] = this.refereeMistake;
        data["clientEventKey"] = this.clientEventKey;
        return data;
    }
}

export interface ICreateEventCommand {
    matchId: number;
    typeId: EventTypeEnum;
    periodId: EventPeriodEnum;
    minute: number;
    seconds: number;
    shootoutAfterEventId?: number;
    isShootout?: boolean;
    card: CardRequest;
    exclusion: ExclusionRequest;
    shot: ShotRequest;
    swimoff: SwimoffRequest;
    timeout: TimeoutRequest;
    challenge: ChallengeRequest;
    turnover: TurnoverRequest;
    goalkeeperChange: GoalkeeperChangeRequest | undefined;
    activeHomeGoalkeeperMatchPlayerId: number | undefined;
    activeAwayGoalkeeperMatchPlayerId: number | undefined;
    refereeMistake: number | undefined;
    clientEventKey: string | undefined;
}

export class CardRequest implements ICardRequest {
    id!: number;
    teamId!: number;
    typeId!: CardTypeEnum;
    cardedPlayerId!: number | undefined;
    cardedCoachId!: number | undefined;

    constructor(data?: ICardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.cardedPlayerId = _data["cardedPlayerId"];
            this.cardedCoachId = _data["cardedCoachId"];
        }
    }

    static fromJS(data: any): CardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["cardedPlayerId"] = this.cardedPlayerId;
        data["cardedCoachId"] = this.cardedCoachId;
        return data;
    }
}

export interface ICardRequest {
    id: number;
    teamId: number;
    typeId: CardTypeEnum;
    cardedPlayerId: number | undefined;
    cardedCoachId: number | undefined;
}

export class ExclusionRequest implements IExclusionRequest {
    id!: number;
    teamId!: number;
    typeId!: ExclusionTypeEnum;
    excludedPlayerId!: number | undefined;
    excludedCoachId!: number | undefined;
    fouledPlayerId!: number | undefined;
    assistedById!: number | undefined;
    isPenaltyExclusion!: boolean;
    isDoubleExclusion!: boolean;
    locationX!: number | undefined;
    locationY!: number | undefined;

    constructor(data?: IExclusionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.excludedPlayerId = _data["excludedPlayerId"];
            this.excludedCoachId = _data["excludedCoachId"];
            this.fouledPlayerId = _data["fouledPlayerId"];
            this.assistedById = _data["assistedById"];
            this.isPenaltyExclusion = _data["isPenaltyExclusion"];
            this.isDoubleExclusion = _data["isDoubleExclusion"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
        }
    }

    static fromJS(data: any): ExclusionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["excludedPlayerId"] = this.excludedPlayerId;
        data["excludedCoachId"] = this.excludedCoachId;
        data["fouledPlayerId"] = this.fouledPlayerId;
        data["assistedById"] = this.assistedById;
        data["isPenaltyExclusion"] = this.isPenaltyExclusion;
        data["isDoubleExclusion"] = this.isDoubleExclusion;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        return data;
    }
}

export interface IExclusionRequest {
    id: number;
    teamId: number;
    typeId: ExclusionTypeEnum;
    excludedPlayerId: number | undefined;
    excludedCoachId: number | undefined;
    fouledPlayerId: number | undefined;
    assistedById: number | undefined;
    isPenaltyExclusion: boolean;
    isDoubleExclusion: boolean;
    locationX: number | undefined;
    locationY: number | undefined;
}

export class ShotRequest implements IShotRequest {
    id!: number;
    teamId!: number;
    typeId!: ShotTypeEnum;
    takenById!: number;
    blockedById!: number | undefined;
    assistedById!: number | undefined;
    savedById!: number | undefined;
    isGoal!: boolean;
    isFastBreak!: boolean;
    isDirectFromFoul!: boolean;
    shotTechnique!: number | undefined;
    fakeCount!: number;
    locationX!: number | undefined;
    locationY!: number | undefined;
    targetX!: number | undefined;
    targetY!: number | undefined;

    constructor(data?: IShotRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.takenById = _data["takenById"];
            this.blockedById = _data["blockedById"];
            this.assistedById = _data["assistedById"];
            this.savedById = _data["savedById"];
            this.isGoal = _data["isGoal"];
            this.isFastBreak = _data["isFastBreak"];
            this.isDirectFromFoul = _data["isDirectFromFoul"];
            this.shotTechnique = _data["shotTechnique"];
            this.fakeCount = _data["fakeCount"];
            this.locationX = _data["locationX"];
            this.locationY = _data["locationY"];
            this.targetX = _data["targetX"];
            this.targetY = _data["targetY"];
        }
    }

    static fromJS(data: any): ShotRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShotRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["takenById"] = this.takenById;
        data["blockedById"] = this.blockedById;
        data["assistedById"] = this.assistedById;
        data["savedById"] = this.savedById;
        data["isGoal"] = this.isGoal;
        data["isFastBreak"] = this.isFastBreak;
        data["isDirectFromFoul"] = this.isDirectFromFoul;
        data["shotTechnique"] = this.shotTechnique;
        data["fakeCount"] = this.fakeCount;
        data["locationX"] = this.locationX;
        data["locationY"] = this.locationY;
        data["targetX"] = this.targetX;
        data["targetY"] = this.targetY;
        return data;
    }
}

export interface IShotRequest {
    id: number;
    teamId: number;
    typeId: ShotTypeEnum;
    takenById: number;
    blockedById: number | undefined;
    assistedById: number | undefined;
    savedById: number | undefined;
    isGoal: boolean;
    isFastBreak: boolean;
    isDirectFromFoul: boolean;
    shotTechnique: number | undefined;
    fakeCount: number;
    locationX: number | undefined;
    locationY: number | undefined;
    targetX: number | undefined;
    targetY: number | undefined;
}

export class SwimoffRequest implements ISwimoffRequest {
    id!: number;
    homeTeamSwimmerId!: number;
    awayTeamSwimmerId!: number;
    winnerTeamId!: number | undefined;
    winnerSwimmerId!: number | undefined;

    constructor(data?: ISwimoffRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamSwimmerId = _data["homeTeamSwimmerId"];
            this.awayTeamSwimmerId = _data["awayTeamSwimmerId"];
            this.winnerTeamId = _data["winnerTeamId"];
            this.winnerSwimmerId = _data["winnerSwimmerId"];
        }
    }

    static fromJS(data: any): SwimoffRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwimoffRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamSwimmerId"] = this.homeTeamSwimmerId;
        data["awayTeamSwimmerId"] = this.awayTeamSwimmerId;
        data["winnerTeamId"] = this.winnerTeamId;
        data["winnerSwimmerId"] = this.winnerSwimmerId;
        return data;
    }
}

export interface ISwimoffRequest {
    id: number;
    homeTeamSwimmerId: number;
    awayTeamSwimmerId: number;
    winnerTeamId: number | undefined;
    winnerSwimmerId: number | undefined;
}

export class TimeoutRequest implements ITimeoutRequest {
    id!: number;
    teamId!: number;

    constructor(data?: ITimeoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
        }
    }

    static fromJS(data: any): TimeoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TimeoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        return data;
    }
}

export interface ITimeoutRequest {
    id: number;
    teamId: number;
}

export class ChallengeRequest implements IChallengeRequest {
    id!: number;
    teamId!: number;
    isSuccessful!: boolean;

    constructor(data?: IChallengeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.isSuccessful = _data["isSuccessful"];
        }
    }

    static fromJS(data: any): ChallengeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["isSuccessful"] = this.isSuccessful;
        return data;
    }
}

export interface IChallengeRequest {
    id: number;
    teamId: number;
    isSuccessful: boolean;
}

export class TurnoverRequest implements ITurnoverRequest {
    id!: number;
    teamId!: number;
    typeId!: TurnoverTypeEnum;
    lostPossesionPlayerId!: number;
    wonPossesionPlayerId!: number | undefined;

    constructor(data?: ITurnoverRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.typeId = _data["typeId"];
            this.lostPossesionPlayerId = _data["lostPossesionPlayerId"];
            this.wonPossesionPlayerId = _data["wonPossesionPlayerId"];
        }
    }

    static fromJS(data: any): TurnoverRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["typeId"] = this.typeId;
        data["lostPossesionPlayerId"] = this.lostPossesionPlayerId;
        data["wonPossesionPlayerId"] = this.wonPossesionPlayerId;
        return data;
    }
}

export interface ITurnoverRequest {
    id: number;
    teamId: number;
    typeId: TurnoverTypeEnum;
    lostPossesionPlayerId: number;
    wonPossesionPlayerId: number | undefined;
}

export class GoalkeeperChangeRequest implements IGoalkeeperChangeRequest {
    id!: number;
    teamId!: number;
    newGoalkeeperMatchPlayerId!: number;
    previousGoalkeeperMatchPlayerId!: number | undefined;

    constructor(data?: IGoalkeeperChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.newGoalkeeperMatchPlayerId = _data["newGoalkeeperMatchPlayerId"];
            this.previousGoalkeeperMatchPlayerId = _data["previousGoalkeeperMatchPlayerId"];
        }
    }

    static fromJS(data: any): GoalkeeperChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GoalkeeperChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["newGoalkeeperMatchPlayerId"] = this.newGoalkeeperMatchPlayerId;
        data["previousGoalkeeperMatchPlayerId"] = this.previousGoalkeeperMatchPlayerId;
        return data;
    }
}

export interface IGoalkeeperChangeRequest {
    id: number;
    teamId: number;
    newGoalkeeperMatchPlayerId: number;
    previousGoalkeeperMatchPlayerId: number | undefined;
}

export class UpdateEventCommand extends CreateEventCommand implements IUpdateEventCommand {
    id!: number;

    constructor(data?: IUpdateEventCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateEventCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEventCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEventCommand extends ICreateEventCommand {
    id: number;
}

export class ExternalSourceCatalogRefreshVm implements IExternalSourceCatalogRefreshVm {
    gamesListed!: number;
    payloadsFetched!: number;
    upserted!: number;
    errors!: string[] | undefined;

    constructor(data?: IExternalSourceCatalogRefreshVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gamesListed = _data["gamesListed"];
            this.payloadsFetched = _data["payloadsFetched"];
            this.upserted = _data["upserted"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalSourceCatalogRefreshVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSourceCatalogRefreshVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gamesListed"] = this.gamesListed;
        data["payloadsFetched"] = this.payloadsFetched;
        data["upserted"] = this.upserted;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IExternalSourceCatalogRefreshVm {
    gamesListed: number;
    payloadsFetched: number;
    upserted: number;
    errors: string[] | undefined;
}

export class RefreshExternalSourceCatalogCommand implements IRefreshExternalSourceCatalogCommand {
    event?: string;
    source!: ExternalSourceEnum;
    competitionId!: number;

    constructor(data?: IRefreshExternalSourceCatalogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.source = _data["source"];
            this.competitionId = _data["competitionId"];
        }
    }

    static fromJS(data: any): RefreshExternalSourceCatalogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshExternalSourceCatalogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["source"] = this.source;
        data["competitionId"] = this.competitionId;
        return data;
    }
}

export interface IRefreshExternalSourceCatalogCommand {
    event?: string;
    source: ExternalSourceEnum;
    competitionId: number;
}

export enum ExternalSourceEnum {
    Mvlsz = 1,
    /** Legacy men's Microplus source for historical season imports; use source 4 for current-season integrations. */
    Eurocup = 2,
    /** Legacy men's Microplus source for historical season imports; use source 4 for current-season integrations. */
    ChampionsLeague = 3,
    Microplus = 4,
}

export class EurocupPlayerNameDobBackfillVm implements IEurocupPlayerNameDobBackfillVm {
    dryRun!: boolean;
    applied!: number;
    items!: EurocupPlayerNameDobBackfillItemVm[] | undefined;

    constructor(data?: IEurocupPlayerNameDobBackfillVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dryRun = _data["dryRun"];
            this.applied = _data["applied"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EurocupPlayerNameDobBackfillItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EurocupPlayerNameDobBackfillVm {
        data = typeof data === 'object' ? data : {};
        let result = new EurocupPlayerNameDobBackfillVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun;
        data["applied"] = this.applied;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEurocupPlayerNameDobBackfillVm {
    dryRun: boolean;
    applied: number;
    items: EurocupPlayerNameDobBackfillItemVm[] | undefined;
}

export class EurocupPlayerNameDobBackfillItemVm implements IEurocupPlayerNameDobBackfillItemVm {
    externalSourceEntityId!: number;
    sourceKey!: string | undefined;
    displayName!: string | undefined;
    birthDate!: Date | undefined;
    season!: string | undefined;
    arenaPlayerId!: number;
    matchedSourceKey!: string | undefined;
    teamOrClub!: string | undefined;
    arenaPlayerDisplayName!: string | undefined;
    arenaPlayerBirthDate!: Date | undefined;

    constructor(data?: IEurocupPlayerNameDobBackfillItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalSourceEntityId = _data["externalSourceEntityId"];
            this.sourceKey = _data["sourceKey"];
            this.displayName = _data["displayName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.season = _data["season"];
            this.arenaPlayerId = _data["arenaPlayerId"];
            this.matchedSourceKey = _data["matchedSourceKey"];
            this.teamOrClub = _data["teamOrClub"];
            this.arenaPlayerDisplayName = _data["arenaPlayerDisplayName"];
            this.arenaPlayerBirthDate = _data["arenaPlayerBirthDate"] ? new Date(_data["arenaPlayerBirthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EurocupPlayerNameDobBackfillItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new EurocupPlayerNameDobBackfillItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalSourceEntityId"] = this.externalSourceEntityId;
        data["sourceKey"] = this.sourceKey;
        data["displayName"] = this.displayName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["season"] = this.season;
        data["arenaPlayerId"] = this.arenaPlayerId;
        data["matchedSourceKey"] = this.matchedSourceKey;
        data["teamOrClub"] = this.teamOrClub;
        data["arenaPlayerDisplayName"] = this.arenaPlayerDisplayName;
        data["arenaPlayerBirthDate"] = this.arenaPlayerBirthDate ? this.arenaPlayerBirthDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEurocupPlayerNameDobBackfillItemVm {
    externalSourceEntityId: number;
    sourceKey: string | undefined;
    displayName: string | undefined;
    birthDate: Date | undefined;
    season: string | undefined;
    arenaPlayerId: number;
    matchedSourceKey: string | undefined;
    teamOrClub: string | undefined;
    arenaPlayerDisplayName: string | undefined;
    arenaPlayerBirthDate: Date | undefined;
}

export class BackfillEurocupPlayerNameDobMapsCommand implements IBackfillEurocupPlayerNameDobMapsCommand {
    dryRun!: boolean;
    externalSourceEntityIds!: number[] | undefined;

    constructor(data?: IBackfillEurocupPlayerNameDobMapsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dryRun = _data["dryRun"];
            if (Array.isArray(_data["externalSourceEntityIds"])) {
                this.externalSourceEntityIds = [] as any;
                for (let item of _data["externalSourceEntityIds"])
                    this.externalSourceEntityIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BackfillEurocupPlayerNameDobMapsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BackfillEurocupPlayerNameDobMapsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dryRun"] = this.dryRun;
        if (Array.isArray(this.externalSourceEntityIds)) {
            data["externalSourceEntityIds"] = [];
            for (let item of this.externalSourceEntityIds)
                data["externalSourceEntityIds"].push(item);
        }
        return data;
    }
}

export interface IBackfillEurocupPlayerNameDobMapsCommand {
    dryRun: boolean;
    externalSourceEntityIds: number[] | undefined;
}

export class ImportHungaryGameResultVm implements IImportHungaryGameResultVm {
    matchId!: number | undefined;
    startDate!: Date | undefined;
    created!: boolean;
    refused!: boolean;
    filledEvents!: boolean;
    alreadyImported!: boolean;
    hungaryStatus!: string | undefined;
    missing!: string[] | undefined;
    eventsWritten!: number;
    eventsSkipped!: number;
    homeScore!: number | undefined;
    awayScore!: number | undefined;
    note!: string | undefined;

    constructor(data?: IImportHungaryGameResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.created = _data["created"];
            this.refused = _data["refused"];
            this.filledEvents = _data["filledEvents"];
            this.alreadyImported = _data["alreadyImported"];
            this.hungaryStatus = _data["hungaryStatus"];
            if (Array.isArray(_data["missing"])) {
                this.missing = [] as any;
                for (let item of _data["missing"])
                    this.missing!.push(item);
            }
            this.eventsWritten = _data["eventsWritten"];
            this.eventsSkipped = _data["eventsSkipped"];
            this.homeScore = _data["homeScore"];
            this.awayScore = _data["awayScore"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ImportHungaryGameResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHungaryGameResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["created"] = this.created;
        data["refused"] = this.refused;
        data["filledEvents"] = this.filledEvents;
        data["alreadyImported"] = this.alreadyImported;
        data["hungaryStatus"] = this.hungaryStatus;
        if (Array.isArray(this.missing)) {
            data["missing"] = [];
            for (let item of this.missing)
                data["missing"].push(item);
        }
        data["eventsWritten"] = this.eventsWritten;
        data["eventsSkipped"] = this.eventsSkipped;
        data["homeScore"] = this.homeScore;
        data["awayScore"] = this.awayScore;
        data["note"] = this.note;
        return data;
    }
}

export interface IImportHungaryGameResultVm {
    matchId: number | undefined;
    startDate: Date | undefined;
    created: boolean;
    refused: boolean;
    filledEvents: boolean;
    alreadyImported: boolean;
    hungaryStatus: string | undefined;
    missing: string[] | undefined;
    eventsWritten: number;
    eventsSkipped: number;
    homeScore: number | undefined;
    awayScore: number | undefined;
    note: string | undefined;
}

export class ImportHungaryGameCommand implements IImportHungaryGameCommand {
    gameId!: number;
    phase!: HungaryImportPhase;
    replaceEvents!: boolean;

    constructor(data?: IImportHungaryGameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gameId = _data["gameId"];
            this.phase = _data["phase"];
            this.replaceEvents = _data["replaceEvents"];
        }
    }

    static fromJS(data: any): ImportHungaryGameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportHungaryGameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gameId"] = this.gameId;
        data["phase"] = this.phase;
        data["replaceEvents"] = this.replaceEvents;
        return data;
    }
}

export interface IImportHungaryGameCommand {
    gameId: number;
    phase: HungaryImportPhase;
    replaceEvents: boolean;
}

export enum HungaryImportPhase {
    Manual = 0,
    Scheduled = 1,
    Live = 2,
    Finished = 3,
}

export class WatchedHungaryCompetitionVm implements IWatchedHungaryCompetitionVm {
    sourceId!: number;
    arenaCompetitionId!: number;
    displayName!: string | undefined;

    constructor(data?: IWatchedHungaryCompetitionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.arenaCompetitionId = _data["arenaCompetitionId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): WatchedHungaryCompetitionVm {
        data = typeof data === 'object' ? data : {};
        let result = new WatchedHungaryCompetitionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["arenaCompetitionId"] = this.arenaCompetitionId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IWatchedHungaryCompetitionVm {
    sourceId: number;
    arenaCompetitionId: number;
    displayName: string | undefined;
}

export class HungaryCatalogVm implements IHungaryCatalogVm {
    seasons!: MvlszSeasonOptionVm[] | undefined;
    competitions!: MvlszCompetitionOptionVm[] | undefined;

    constructor(data?: IHungaryCatalogVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["seasons"])) {
                this.seasons = [] as any;
                for (let item of _data["seasons"])
                    this.seasons!.push(MvlszSeasonOptionVm.fromJS(item));
            }
            if (Array.isArray(_data["competitions"])) {
                this.competitions = [] as any;
                for (let item of _data["competitions"])
                    this.competitions!.push(MvlszCompetitionOptionVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HungaryCatalogVm {
        data = typeof data === 'object' ? data : {};
        let result = new HungaryCatalogVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.seasons)) {
            data["seasons"] = [];
            for (let item of this.seasons)
                data["seasons"].push(item.toJSON());
        }
        if (Array.isArray(this.competitions)) {
            data["competitions"] = [];
            for (let item of this.competitions)
                data["competitions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHungaryCatalogVm {
    seasons: MvlszSeasonOptionVm[] | undefined;
    competitions: MvlszCompetitionOptionVm[] | undefined;
}

export class MvlszSeasonOptionVm implements IMvlszSeasonOptionVm {
    id!: number;
    name!: string | undefined;
    isActual!: boolean;

    constructor(data?: IMvlszSeasonOptionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActual = _data["isActual"];
        }
    }

    static fromJS(data: any): MvlszSeasonOptionVm {
        data = typeof data === 'object' ? data : {};
        let result = new MvlszSeasonOptionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActual"] = this.isActual;
        return data;
    }
}

export interface IMvlszSeasonOptionVm {
    id: number;
    name: string | undefined;
    isActual: boolean;
}

export class MvlszCompetitionOptionVm implements IMvlszCompetitionOptionVm {
    id!: number;
    name!: string | undefined;
    shortName!: string | undefined;
    seasonName!: string | undefined;

    constructor(data?: IMvlszCompetitionOptionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.seasonName = _data["seasonName"];
        }
    }

    static fromJS(data: any): MvlszCompetitionOptionVm {
        data = typeof data === 'object' ? data : {};
        let result = new MvlszCompetitionOptionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["seasonName"] = this.seasonName;
        return data;
    }
}

export interface IMvlszCompetitionOptionVm {
    id: number;
    name: string | undefined;
    shortName: string | undefined;
    seasonName: string | undefined;
}

export class HungaryGamesListVm implements IHungaryGamesListVm {
    competitionId!: number;
    watched!: boolean;
    games!: MvlszPublicGame[] | undefined;

    constructor(data?: IHungaryGamesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.watched = _data["watched"];
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(MvlszPublicGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HungaryGamesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new HungaryGamesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["watched"] = this.watched;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHungaryGamesListVm {
    competitionId: number;
    watched: boolean;
    games: MvlszPublicGame[] | undefined;
}

export class MvlszPublicGame implements IMvlszPublicGame {
    id!: number;
    status!: string | undefined;
    start!: Date | undefined;
    competitionId!: number;
    homeTeamSourceId!: number;
    awayTeamSourceId!: number;
    homeCompetitionTeamId!: number;
    awayCompetitionTeamId!: number;
    homeName!: string | undefined;
    awayName!: string | undefined;
    venue!: string | undefined;
    homeScore!: number | undefined;
    awayScore!: number | undefined;

    constructor(data?: IMvlszPublicGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.competitionId = _data["competitionId"];
            this.homeTeamSourceId = _data["homeTeamSourceId"];
            this.awayTeamSourceId = _data["awayTeamSourceId"];
            this.homeCompetitionTeamId = _data["homeCompetitionTeamId"];
            this.awayCompetitionTeamId = _data["awayCompetitionTeamId"];
            this.homeName = _data["homeName"];
            this.awayName = _data["awayName"];
            this.venue = _data["venue"];
            this.homeScore = _data["homeScore"];
            this.awayScore = _data["awayScore"];
        }
    }

    static fromJS(data: any): MvlszPublicGame {
        data = typeof data === 'object' ? data : {};
        let result = new MvlszPublicGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["competitionId"] = this.competitionId;
        data["homeTeamSourceId"] = this.homeTeamSourceId;
        data["awayTeamSourceId"] = this.awayTeamSourceId;
        data["homeCompetitionTeamId"] = this.homeCompetitionTeamId;
        data["awayCompetitionTeamId"] = this.awayCompetitionTeamId;
        data["homeName"] = this.homeName;
        data["awayName"] = this.awayName;
        data["venue"] = this.venue;
        data["homeScore"] = this.homeScore;
        data["awayScore"] = this.awayScore;
        return data;
    }
}

export interface IMvlszPublicGame {
    id: number;
    status: string | undefined;
    start: Date | undefined;
    competitionId: number;
    homeTeamSourceId: number;
    awayTeamSourceId: number;
    homeCompetitionTeamId: number;
    awayCompetitionTeamId: number;
    homeName: string | undefined;
    awayName: string | undefined;
    venue: string | undefined;
    homeScore: number | undefined;
    awayScore: number | undefined;
}

export class ExternalSourceEntityVm implements IExternalSourceEntityVm {
    id!: number;
    source!: number;
    entityType!: number;
    sourceId!: number;
    parentSourceId!: number | undefined;
    parentDisplayName!: string | undefined;
    parentMapped!: boolean;
    parentArenaEntityId!: number | undefined;
    clubMapped!: boolean;
    hasSuggestion!: boolean;
    displayName!: string | undefined;
    firstName!: string | undefined;
    lastName!: string | undefined;
    shortName!: string | undefined;
    birthDate!: Date | undefined;
    registrationNumber!: string | undefined;
    extraJson!: string | undefined;
    arenaEntityId!: number | undefined;
    syncMatches!: boolean;
    arenaDisplayName!: string | undefined;
    mappingNeedsConfirm!: boolean;
    alreadyMappedFrom!: string[] | undefined;
    lastSeenUtc!: Date;

    constructor(data?: IExternalSourceEntityVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"];
            this.entityType = _data["entityType"];
            this.sourceId = _data["sourceId"];
            this.parentSourceId = _data["parentSourceId"];
            this.parentDisplayName = _data["parentDisplayName"];
            this.parentMapped = _data["parentMapped"];
            this.parentArenaEntityId = _data["parentArenaEntityId"];
            this.clubMapped = _data["clubMapped"];
            this.hasSuggestion = _data["hasSuggestion"];
            this.displayName = _data["displayName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.shortName = _data["shortName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.registrationNumber = _data["registrationNumber"];
            this.extraJson = _data["extraJson"];
            this.arenaEntityId = _data["arenaEntityId"];
            this.syncMatches = _data["syncMatches"];
            this.arenaDisplayName = _data["arenaDisplayName"];
            this.mappingNeedsConfirm = _data["mappingNeedsConfirm"];
            if (Array.isArray(_data["alreadyMappedFrom"])) {
                this.alreadyMappedFrom = [] as any;
                for (let item of _data["alreadyMappedFrom"])
                    this.alreadyMappedFrom!.push(item);
            }
            this.lastSeenUtc = _data["lastSeenUtc"] ? new Date(_data["lastSeenUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalSourceEntityVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSourceEntityVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source;
        data["entityType"] = this.entityType;
        data["sourceId"] = this.sourceId;
        data["parentSourceId"] = this.parentSourceId;
        data["parentDisplayName"] = this.parentDisplayName;
        data["parentMapped"] = this.parentMapped;
        data["parentArenaEntityId"] = this.parentArenaEntityId;
        data["clubMapped"] = this.clubMapped;
        data["hasSuggestion"] = this.hasSuggestion;
        data["displayName"] = this.displayName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["shortName"] = this.shortName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["registrationNumber"] = this.registrationNumber;
        data["extraJson"] = this.extraJson;
        data["arenaEntityId"] = this.arenaEntityId;
        data["syncMatches"] = this.syncMatches;
        data["arenaDisplayName"] = this.arenaDisplayName;
        data["mappingNeedsConfirm"] = this.mappingNeedsConfirm;
        if (Array.isArray(this.alreadyMappedFrom)) {
            data["alreadyMappedFrom"] = [];
            for (let item of this.alreadyMappedFrom)
                data["alreadyMappedFrom"].push(item);
        }
        data["lastSeenUtc"] = this.lastSeenUtc ? this.lastSeenUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExternalSourceEntityVm {
    id: number;
    source: number;
    entityType: number;
    sourceId: number;
    parentSourceId: number | undefined;
    parentDisplayName: string | undefined;
    parentMapped: boolean;
    parentArenaEntityId: number | undefined;
    clubMapped: boolean;
    hasSuggestion: boolean;
    displayName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    shortName: string | undefined;
    birthDate: Date | undefined;
    registrationNumber: string | undefined;
    extraJson: string | undefined;
    arenaEntityId: number | undefined;
    syncMatches: boolean;
    arenaDisplayName: string | undefined;
    mappingNeedsConfirm: boolean;
    alreadyMappedFrom: string[] | undefined;
    lastSeenUtc: Date;
}

export class SetExternalSourceSyncMatchesCommand implements ISetExternalSourceSyncMatchesCommand {
    id!: number;
    syncMatches!: boolean;

    constructor(data?: ISetExternalSourceSyncMatchesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.syncMatches = _data["syncMatches"];
        }
    }

    static fromJS(data: any): SetExternalSourceSyncMatchesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetExternalSourceSyncMatchesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["syncMatches"] = this.syncMatches;
        return data;
    }
}

export interface ISetExternalSourceSyncMatchesCommand {
    id: number;
    syncMatches: boolean;
}

export class EurocupGamesListVm implements IEurocupGamesListVm {
    season!: number;
    watched!: boolean;
    error!: string | undefined;
    games!: EurocupPublicGame[] | undefined;

    constructor(data?: IEurocupGamesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.watched = _data["watched"];
            this.error = _data["error"];
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(EurocupPublicGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EurocupGamesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new EurocupGamesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["watched"] = this.watched;
        data["error"] = this.error;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEurocupGamesListVm {
    season: number;
    watched: boolean;
    error: string | undefined;
    games: EurocupPublicGame[] | undefined;
}

export class EurocupPublicGame implements IEurocupPublicGame {
    matchKey!: string | undefined;
    status!: string | undefined;
    arenaStatus!: string | undefined;
    start!: Date | undefined;
    startIsPlaceholder!: boolean;
    homeCode!: string | undefined;
    awayCode!: string | undefined;
    homeName!: string | undefined;
    awayName!: string | undefined;
    venue!: string | undefined;
    homeScore!: number | undefined;
    awayScore!: number | undefined;

    constructor(data?: IEurocupPublicGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchKey = _data["matchKey"];
            this.status = _data["status"];
            this.arenaStatus = _data["arenaStatus"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.startIsPlaceholder = _data["startIsPlaceholder"];
            this.homeCode = _data["homeCode"];
            this.awayCode = _data["awayCode"];
            this.homeName = _data["homeName"];
            this.awayName = _data["awayName"];
            this.venue = _data["venue"];
            this.homeScore = _data["homeScore"];
            this.awayScore = _data["awayScore"];
        }
    }

    static fromJS(data: any): EurocupPublicGame {
        data = typeof data === 'object' ? data : {};
        let result = new EurocupPublicGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchKey"] = this.matchKey;
        data["status"] = this.status;
        data["arenaStatus"] = this.arenaStatus;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["startIsPlaceholder"] = this.startIsPlaceholder;
        data["homeCode"] = this.homeCode;
        data["awayCode"] = this.awayCode;
        data["homeName"] = this.homeName;
        data["awayName"] = this.awayName;
        data["venue"] = this.venue;
        data["homeScore"] = this.homeScore;
        data["awayScore"] = this.awayScore;
        return data;
    }
}

export interface IEurocupPublicGame {
    matchKey: string | undefined;
    status: string | undefined;
    arenaStatus: string | undefined;
    start: Date | undefined;
    startIsPlaceholder: boolean;
    homeCode: string | undefined;
    awayCode: string | undefined;
    homeName: string | undefined;
    awayName: string | undefined;
    venue: string | undefined;
    homeScore: number | undefined;
    awayScore: number | undefined;
}

export class ImportEurocupGameCommand implements IImportEurocupGameCommand {
    season!: string | undefined;
    matchKey!: string | undefined;
    phase!: number;
    replaceEvents!: boolean;

    constructor(data?: IImportEurocupGameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.matchKey = _data["matchKey"];
            this.phase = _data["phase"];
            this.replaceEvents = _data["replaceEvents"];
        }
    }

    static fromJS(data: any): ImportEurocupGameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportEurocupGameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["matchKey"] = this.matchKey;
        data["phase"] = this.phase;
        data["replaceEvents"] = this.replaceEvents;
        return data;
    }
}

export interface IImportEurocupGameCommand {
    season: string | undefined;
    matchKey: string | undefined;
    phase: number;
    replaceEvents: boolean;
}

export class ChampionsLeagueGamesListVm implements IChampionsLeagueGamesListVm {
    season!: number;
    watched!: boolean;
    error!: string | undefined;
    games!: ChampionsLeaguePublicGame[] | undefined;

    constructor(data?: IChampionsLeagueGamesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.watched = _data["watched"];
            this.error = _data["error"];
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(ChampionsLeaguePublicGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChampionsLeagueGamesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new ChampionsLeagueGamesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["watched"] = this.watched;
        data["error"] = this.error;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChampionsLeagueGamesListVm {
    season: number;
    watched: boolean;
    error: string | undefined;
    games: ChampionsLeaguePublicGame[] | undefined;
}

export class ChampionsLeaguePublicGame implements IChampionsLeaguePublicGame {
    matchKey!: string | undefined;
    status!: string | undefined;
    arenaStatus!: string | undefined;
    start!: Date | undefined;
    startIsPlaceholder!: boolean;
    homeCode!: string | undefined;
    awayCode!: string | undefined;
    homeName!: string | undefined;
    awayName!: string | undefined;
    venue!: string | undefined;
    homeScore!: number | undefined;
    awayScore!: number | undefined;
    competitionKey!: string | undefined;
    roundName!: string | undefined;

    constructor(data?: IChampionsLeaguePublicGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchKey = _data["matchKey"];
            this.status = _data["status"];
            this.arenaStatus = _data["arenaStatus"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.startIsPlaceholder = _data["startIsPlaceholder"];
            this.homeCode = _data["homeCode"];
            this.awayCode = _data["awayCode"];
            this.homeName = _data["homeName"];
            this.awayName = _data["awayName"];
            this.venue = _data["venue"];
            this.homeScore = _data["homeScore"];
            this.awayScore = _data["awayScore"];
            this.competitionKey = _data["competitionKey"];
            this.roundName = _data["roundName"];
        }
    }

    static fromJS(data: any): ChampionsLeaguePublicGame {
        data = typeof data === 'object' ? data : {};
        let result = new ChampionsLeaguePublicGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchKey"] = this.matchKey;
        data["status"] = this.status;
        data["arenaStatus"] = this.arenaStatus;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["startIsPlaceholder"] = this.startIsPlaceholder;
        data["homeCode"] = this.homeCode;
        data["awayCode"] = this.awayCode;
        data["homeName"] = this.homeName;
        data["awayName"] = this.awayName;
        data["venue"] = this.venue;
        data["homeScore"] = this.homeScore;
        data["awayScore"] = this.awayScore;
        data["competitionKey"] = this.competitionKey;
        data["roundName"] = this.roundName;
        return data;
    }
}

export interface IChampionsLeaguePublicGame {
    matchKey: string | undefined;
    status: string | undefined;
    arenaStatus: string | undefined;
    start: Date | undefined;
    startIsPlaceholder: boolean;
    homeCode: string | undefined;
    awayCode: string | undefined;
    homeName: string | undefined;
    awayName: string | undefined;
    venue: string | undefined;
    homeScore: number | undefined;
    awayScore: number | undefined;
    competitionKey: string | undefined;
    roundName: string | undefined;
}

export class ImportChampionsLeagueGameCommand implements IImportChampionsLeagueGameCommand {
    season!: string | undefined;
    matchKey!: string | undefined;
    phase!: number;
    replaceEvents!: boolean;

    constructor(data?: IImportChampionsLeagueGameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.season = _data["season"];
            this.matchKey = _data["matchKey"];
            this.phase = _data["phase"];
            this.replaceEvents = _data["replaceEvents"];
        }
    }

    static fromJS(data: any): ImportChampionsLeagueGameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportChampionsLeagueGameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["season"] = this.season;
        data["matchKey"] = this.matchKey;
        data["phase"] = this.phase;
        data["replaceEvents"] = this.replaceEvents;
        return data;
    }
}

export interface IImportChampionsLeagueGameCommand {
    season: string | undefined;
    matchKey: string | undefined;
    phase: number;
    replaceEvents: boolean;
}

export class MicroplusGamesListVm implements IMicroplusGamesListVm {
    event!: string | undefined;
    qualificationCutoverDate!: Date | undefined;

    season!: number;
    watched!: boolean;
    error!: string | undefined;
    games!: MicroplusPublicGame[] | undefined;

    constructor(data?: IMicroplusGamesListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.qualificationCutoverDate = _data["qualificationCutoverDate"] ? new Date(_data["qualificationCutoverDate"].toString()) : undefined;

            this.season = _data["season"];
            this.watched = _data["watched"];
            this.error = _data["error"];
            if (Array.isArray(_data["games"])) {
                this.games = [] as any;
                for (let item of _data["games"])
                    this.games!.push(MicroplusPublicGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MicroplusGamesListVm {
        data = typeof data === 'object' ? data : {};
        let result = new MicroplusGamesListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["qualificationCutoverDate"] = this.qualificationCutoverDate;

        data["season"] = this.season;
        data["watched"] = this.watched;
        data["error"] = this.error;
        if (Array.isArray(this.games)) {
            data["games"] = [];
            for (let item of this.games)
                data["games"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMicroplusGamesListVm {
    event: string | undefined;
    qualificationCutoverDate: Date | undefined;

    season: number;
    watched: boolean;
    error: string | undefined;
    games: MicroplusPublicGame[] | undefined;
}

export class MicroplusPublicGame implements IMicroplusPublicGame {
    event!: string | undefined;
    phase!: string | undefined;
    isQualification!: boolean;
    arenaCompetitionId!: number | undefined;

    matchKey!: string | undefined;
    status!: string | undefined;
    arenaStatus!: string | undefined;
    start!: Date | undefined;
    startIsPlaceholder!: boolean;
    homeCode!: string | undefined;
    awayCode!: string | undefined;
    homeName!: string | undefined;
    awayName!: string | undefined;
    venue!: string | undefined;
    homeScore!: number | undefined;
    awayScore!: number | undefined;
    competitionKey!: string | undefined;
    roundName!: string | undefined;

    constructor(data?: IMicroplusPublicGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];
            this.phase = _data["phase"];
            this.isQualification = _data["isQualification"];
            this.arenaCompetitionId = _data["arenaCompetitionId"];

            this.matchKey = _data["matchKey"];
            this.status = _data["status"];
            this.arenaStatus = _data["arenaStatus"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>undefined;
            this.startIsPlaceholder = _data["startIsPlaceholder"];
            this.homeCode = _data["homeCode"];
            this.awayCode = _data["awayCode"];
            this.homeName = _data["homeName"];
            this.awayName = _data["awayName"];
            this.venue = _data["venue"];
            this.homeScore = _data["homeScore"];
            this.awayScore = _data["awayScore"];
            this.competitionKey = _data["competitionKey"];
            this.roundName = _data["roundName"];
        }
    }

    static fromJS(data: any): MicroplusPublicGame {
        data = typeof data === 'object' ? data : {};
        let result = new MicroplusPublicGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["phase"] = this.phase;
        data["isQualification"] = this.isQualification;
        data["arenaCompetitionId"] = this.arenaCompetitionId;

        data["matchKey"] = this.matchKey;
        data["status"] = this.status;
        data["arenaStatus"] = this.arenaStatus;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        data["startIsPlaceholder"] = this.startIsPlaceholder;
        data["homeCode"] = this.homeCode;
        data["awayCode"] = this.awayCode;
        data["homeName"] = this.homeName;
        data["awayName"] = this.awayName;
        data["venue"] = this.venue;
        data["homeScore"] = this.homeScore;
        data["awayScore"] = this.awayScore;
        data["competitionKey"] = this.competitionKey;
        data["roundName"] = this.roundName;
        return data;
    }
}

export interface IMicroplusPublicGame {
    event: string | undefined;
    phase: string | undefined;
    isQualification: boolean;
    arenaCompetitionId: number | undefined;

    matchKey: string | undefined;
    status: string | undefined;
    arenaStatus: string | undefined;
    start: Date | undefined;
    startIsPlaceholder: boolean;
    homeCode: string | undefined;
    awayCode: string | undefined;
    homeName: string | undefined;
    awayName: string | undefined;
    venue: string | undefined;
    homeScore: number | undefined;
    awayScore: number | undefined;
    competitionKey: string | undefined;
    roundName: string | undefined;
}

export class ImportMicroplusGameCommand implements IImportMicroplusGameCommand {
    event!: string | undefined;

    season!: string | undefined;
    matchKey!: string | undefined;
    phase!: number;
    replaceEvents!: boolean;

    constructor(data?: IImportMicroplusGameCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"];

            this.season = _data["season"];
            this.matchKey = _data["matchKey"];
            this.phase = _data["phase"];
            this.replaceEvents = _data["replaceEvents"];
        }
    }

    static fromJS(data: any): ImportMicroplusGameCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ImportMicroplusGameCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;

        data["season"] = this.season;
        data["matchKey"] = this.matchKey;
        data["phase"] = this.phase;
        data["replaceEvents"] = this.replaceEvents;
        return data;
    }
}

export interface IImportMicroplusGameCommand {
    event: string | undefined;

    season: string | undefined;
    matchKey: string | undefined;
    phase: number;
    replaceEvents: boolean;
}

export class MicroplusWatchedEventVm implements IMicroplusWatchedEventVm {
    event!: string | undefined;
    season!: string | undefined;
    arenaCompetitionId!: number | undefined;
    qualificationCompetitionId!: number | undefined;

    constructor(data?: IMicroplusWatchedEventVm) { if (data) Object.assign(this, data); }
    init(data?: any) { if (data) Object.assign(this, data); }
    static fromJS(data: any): MicroplusWatchedEventVm {
        const result = new MicroplusWatchedEventVm();
        result.init(data);
        return result;
    }
    toJSON() { return { ...this }; }
}
export interface IMicroplusWatchedEventVm {
    event: string | undefined;
    season: string | undefined;
    arenaCompetitionId: number | undefined;
    qualificationCompetitionId: number | undefined;
}

export class ExternalSourceEntitySearchVm implements IExternalSourceEntitySearchVm {
    pageItems!: ExternalSourceEntityVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;
    mappedCount!: number;
    catalogCount!: number;

    constructor(data?: IExternalSourceEntitySearchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(ExternalSourceEntityVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
            this.mappedCount = _data["mappedCount"];
            this.catalogCount = _data["catalogCount"];
        }
    }

    static fromJS(data: any): ExternalSourceEntitySearchVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSourceEntitySearchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        data["mappedCount"] = this.mappedCount;
        data["catalogCount"] = this.catalogCount;
        return data;
    }
}

export interface IExternalSourceEntitySearchVm {
    pageItems: ExternalSourceEntityVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
    mappedCount: number;
    catalogCount: number;
}

export enum ExternalSourceEntityTypeEnum {
    Competition = 1,
    Club = 2,
    Team = 3,
    Player = 4,
}

export class ArenaEntityCandidateVm implements IArenaEntityCandidateVm {
    id!: number;
    displayName!: string | undefined;
    detail!: string | undefined;

    constructor(data?: IArenaEntityCandidateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.detail = _data["detail"];
        }
    }

    static fromJS(data: any): ArenaEntityCandidateVm {
        data = typeof data === 'object' ? data : {};
        let result = new ArenaEntityCandidateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["detail"] = this.detail;
        return data;
    }
}

export interface IArenaEntityCandidateVm {
    id: number;
    displayName: string | undefined;
    detail: string | undefined;
}

export class ExternalSourceSuggestionVm implements IExternalSourceSuggestionVm {
    arenaEntityId!: number;
    displayName!: string | undefined;
    detail!: string | undefined;
    score!: number;
    scoreReason!: string | undefined;

    constructor(data?: IExternalSourceSuggestionVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.arenaEntityId = _data["arenaEntityId"];
            this.displayName = _data["displayName"];
            this.detail = _data["detail"];
            this.score = _data["score"];
            this.scoreReason = _data["scoreReason"];
        }
    }

    static fromJS(data: any): ExternalSourceSuggestionVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSourceSuggestionVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["arenaEntityId"] = this.arenaEntityId;
        data["displayName"] = this.displayName;
        data["detail"] = this.detail;
        data["score"] = this.score;
        data["scoreReason"] = this.scoreReason;
        return data;
    }
}

export interface IExternalSourceSuggestionVm {
    arenaEntityId: number;
    displayName: string | undefined;
    detail: string | undefined;
    score: number;
    scoreReason: string | undefined;
}

export class MapExternalSourceEntityCommand implements IMapExternalSourceEntityCommand {
    id!: number;
    arenaEntityId!: number;
    confirmSharedArenaTeam!: boolean;
    allowShared!: boolean;

    constructor(data?: IMapExternalSourceEntityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.arenaEntityId = _data["arenaEntityId"];
            this.confirmSharedArenaTeam = _data["confirmSharedArenaTeam"];
            this.allowShared = _data["allowShared"];
        }
    }

    static fromJS(data: any): MapExternalSourceEntityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MapExternalSourceEntityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["arenaEntityId"] = this.arenaEntityId;
        data["confirmSharedArenaTeam"] = this.confirmSharedArenaTeam;
        data["allowShared"] = this.allowShared;
        return data;
    }
}

export interface IMapExternalSourceEntityCommand {
    id: number;
    arenaEntityId: number;
    confirmSharedArenaTeam: boolean;
    allowShared: boolean;
}

export class CreateMappedClubCommand implements ICreateMappedClubCommand {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;
    shortName!: string | undefined;
    federationId!: number | undefined;
    countryId!: number | undefined;

    constructor(data?: ICreateMappedClubCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.federationId = _data["federationId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateMappedClubCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedClubCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["federationId"] = this.federationId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateMappedClubCommand {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
    shortName: string | undefined;
    federationId: number | undefined;
    countryId: number | undefined;
}

export class CreateMappedTeamCommand implements ICreateMappedTeamCommand {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;
    shortName!: string | undefined;
    categoryId!: number;
    countryId!: number | undefined;

    constructor(data?: ICreateMappedTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.categoryId = _data["categoryId"];
            this.countryId = _data["countryId"];
        }
    }

    static fromJS(data: any): CreateMappedTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["categoryId"] = this.categoryId;
        data["countryId"] = this.countryId;
        return data;
    }
}

export interface ICreateMappedTeamCommand {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
    shortName: string | undefined;
    categoryId: number;
    countryId: number | undefined;
}

export class CreateMappedPlayerCommand implements ICreateMappedPlayerCommand {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: Date;
    dominantHand!: string | undefined;
    competitionSourceId!: number;
    allowWithoutSquad!: boolean;

    constructor(data?: ICreateMappedPlayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.dominantHand = _data["dominantHand"];
            this.competitionSourceId = _data["competitionSourceId"];
            this.allowWithoutSquad = _data["allowWithoutSquad"];
        }
    }

    static fromJS(data: any): CreateMappedPlayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedPlayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["dominantHand"] = this.dominantHand;
        data["competitionSourceId"] = this.competitionSourceId;
        data["allowWithoutSquad"] = this.allowWithoutSquad;
        return data;
    }
}

export interface ICreateMappedPlayerCommand {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    birthDate: Date;
    dominantHand: string | undefined;
    competitionSourceId: number;
    allowWithoutSquad: boolean;
}

export class CreateMappedPlayersResultVm implements ICreateMappedPlayersResultVm {
    created!: number;
    skipped!: number;
    failures!: CreateMappedPlayerFailureVm[] | undefined;

    constructor(data?: ICreateMappedPlayersResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["failures"])) {
                this.failures = [] as any;
                for (let item of _data["failures"])
                    this.failures!.push(CreateMappedPlayerFailureVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMappedPlayersResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedPlayersResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.failures)) {
            data["failures"] = [];
            for (let item of this.failures)
                data["failures"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateMappedPlayersResultVm {
    created: number;
    skipped: number;
    failures: CreateMappedPlayerFailureVm[] | undefined;
}

export class CreateMappedPlayerFailureVm implements ICreateMappedPlayerFailureVm {
    id!: number;
    displayName!: string | undefined;
    reason!: string | undefined;

    constructor(data?: ICreateMappedPlayerFailureVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreateMappedPlayerFailureVm {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedPlayerFailureVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ICreateMappedPlayerFailureVm {
    id: number;
    displayName: string | undefined;
    reason: string | undefined;
}

export class CreateMappedPlayersCommand implements ICreateMappedPlayersCommand {
    ids!: number[] | undefined;
    competitionSourceId!: number;

    constructor(data?: ICreateMappedPlayersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.competitionSourceId = _data["competitionSourceId"];
        }
    }

    static fromJS(data: any): CreateMappedPlayersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedPlayersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["competitionSourceId"] = this.competitionSourceId;
        return data;
    }
}

export interface ICreateMappedPlayersCommand {
    ids: number[] | undefined;
    competitionSourceId: number;
}

export class CreateMappedCompetitionCommand implements ICreateMappedCompetitionCommand {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;
    shortName!: string | undefined;
    season!: string | undefined;
    federationId!: number;
    countryId!: number | undefined;
    categoryId!: number | undefined;

    constructor(data?: ICreateMappedCompetitionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.season = _data["season"];
            this.federationId = _data["federationId"];
            this.countryId = _data["countryId"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): CreateMappedCompetitionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMappedCompetitionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["season"] = this.season;
        data["federationId"] = this.federationId;
        data["countryId"] = this.countryId;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ICreateMappedCompetitionCommand {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
    shortName: string | undefined;
    season: string | undefined;
    federationId: number;
    countryId: number | undefined;
    categoryId: number | undefined;
}

export class FederationOfficialVm implements IFederationOfficialVm {
    id!: number;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    officialId!: number;
    official!: OfficialVm;
    federationId!: number;
    federation!: string;
    roles!: FederationOfficialRoleVm[];

    constructor(data?: IFederationOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.officialId = _data["officialId"];
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(FederationOfficialRoleVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FederationOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["officialId"] = this.officialId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFederationOfficialVm {
    id: number;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    officialId: number;
    official: OfficialVm;
    federationId: number;
    federation: string;
    roles: FederationOfficialRoleVm[];
}

export class FederationOfficialRoleVm implements IFederationOfficialRoleVm {
    id!: number;
    roleId!: OfficialRoleEnum;
    role!: string;

    constructor(data?: IFederationOfficialRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): FederationOfficialRoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationOfficialRoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["role"] = this.role;
        return data;
    }
}

export interface IFederationOfficialRoleVm {
    id: number;
    roleId: OfficialRoleEnum;
    role: string;
}

export enum OfficialRoleEnum {
    Referee = 600,
    Delegate = 601,
    Secretary = 602,
    Timekeeper = 603,
    Director = 604,
    Goal_Referee = 605,
    VAR = 606,
}

export class CreateFederationOfficialCommandOfFederationOfficial implements ICreateFederationOfficialCommandOfFederationOfficial {
    federationId!: number;
    officialId!: number;
    roles!: OfficialRoleEnum[];
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: ICreateFederationOfficialCommandOfFederationOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.federationId = _data["federationId"];
            this.officialId = _data["officialId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFederationOfficialCommandOfFederationOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFederationOfficialCommandOfFederationOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["federationId"] = this.federationId;
        data["officialId"] = this.officialId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateFederationOfficialCommandOfFederationOfficial {
    federationId: number;
    officialId: number;
    roles: OfficialRoleEnum[];
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class UpdateFederationOfficialCommand implements IUpdateFederationOfficialCommand {
    id!: number;
    roles!: OfficialRoleEnum[] | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;

    constructor(data?: IUpdateFederationOfficialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFederationOfficialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFederationOfficialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateFederationOfficialCommand {
    id: number;
    roles: OfficialRoleEnum[] | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
}

export class FederationVm implements IFederationVm {
    id!: number;
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date;
    activeTo!: Date | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    president!: string | undefined;
    secretary!: string | undefined;
    isPro!: boolean;
    countryId!: number;
    country!: string;
    cityId!: number | undefined;
    city!: string | undefined;

    constructor(data?: IFederationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.president = _data["president"];
            this.secretary = _data["secretary"];
            this.isPro = _data["isPro"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): FederationVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["president"] = this.president;
        data["secretary"] = this.secretary;
        data["isPro"] = this.isPro;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        return data;
    }
}

export interface IFederationVm {
    id: number;
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date;
    activeTo: Date | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    president: string | undefined;
    secretary: string | undefined;
    isPro: boolean;
    countryId: number;
    country: string;
    cityId: number | undefined;
    city: string | undefined;
}

export class PaginatedListOfFederationVm implements IPaginatedListOfFederationVm {
    pageItems!: FederationVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfFederationVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(FederationVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfFederationVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfFederationVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfFederationVm {
    pageItems: FederationVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class FederationDetailVm extends FederationVm implements IFederationDetailVm {
    logo!: string | undefined;
    clubs!: ClubVm[];
    competitions!: CompetitionVm[];
    officials!: FederationOfficialVm[];
    categories!: FederationCategoryVm[];

    constructor(data?: IFederationDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubVm.fromJS(item));
            }
            if (Array.isArray(_data["competitions"])) {
                this.competitions = [] as any;
                for (let item of _data["competitions"])
                    this.competitions!.push(CompetitionVm.fromJS(item));
            }
            if (Array.isArray(_data["officials"])) {
                this.officials = [] as any;
                for (let item of _data["officials"])
                    this.officials!.push(FederationOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(FederationCategoryVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FederationDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.competitions)) {
            data["competitions"] = [];
            for (let item of this.competitions)
                data["competitions"].push(item.toJSON());
        }
        if (Array.isArray(this.officials)) {
            data["officials"] = [];
            for (let item of this.officials)
                data["officials"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFederationDetailVm extends IFederationVm {
    logo: string | undefined;
    clubs: ClubVm[];
    competitions: CompetitionVm[];
    officials: FederationOfficialVm[];
    categories: FederationCategoryVm[];
}

export class FederationCategoryVm implements IFederationCategoryVm {
    id!: number;
    federationId!: number;
    federation!: string;
    categoryId!: number;
    category!: string;

    constructor(data?: IFederationCategoryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): FederationCategoryVm {
        data = typeof data === 'object' ? data : {};
        let result = new FederationCategoryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        return data;
    }
}

export interface IFederationCategoryVm {
    id: number;
    federationId: number;
    federation: string;
    categoryId: number;
    category: string;
}

export class CreateFederationCommandOfFederation implements ICreateFederationCommandOfFederation {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date;
    activeTo!: Date | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    president!: string | undefined;
    secretary!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    countryId!: number;
    cityId!: number | undefined;
    categories!: number[] | undefined;

    constructor(data?: ICreateFederationCommandOfFederation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.president = _data["president"];
            this.secretary = _data["secretary"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateFederationCommandOfFederation {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFederationCommandOfFederation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["president"] = this.president;
        data["secretary"] = this.secretary;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data;
    }
}

export interface ICreateFederationCommandOfFederation {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date;
    activeTo: Date | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    president: string | undefined;
    secretary: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    countryId: number;
    cityId: number | undefined;
    categories: number[] | undefined;
}

export class UpdateFederationCommand extends CreateFederationCommandOfFederation implements IUpdateFederationCommand {
    id!: number;

    constructor(data?: IUpdateFederationCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateFederationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFederationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateFederationCommand extends ICreateFederationCommandOfFederation {
    id: number;
}

export class CreateMatchCoachCommandOfMatchCoach implements ICreateMatchCoachCommandOfMatchCoach {
    id!: number;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;

    constructor(data?: ICreateMatchCoachCommandOfMatchCoach) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateMatchCoachCommandOfMatchCoach {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchCoachCommandOfMatchCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateMatchCoachCommandOfMatchCoach {
    id: number;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
}

export class UpdateMatchCoachCommandOfMatchCoach extends CreateMatchCoachCommandOfMatchCoach implements IUpdateMatchCoachCommandOfMatchCoach {

    constructor(data?: IUpdateMatchCoachCommandOfMatchCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchCoachCommandOfMatchCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchCoachCommandOfMatchCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchCoachCommandOfMatchCoach extends ICreateMatchCoachCommandOfMatchCoach {
}

export class PaginatedListOfMatchVm implements IPaginatedListOfMatchVm {
    pageItems!: MatchVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfMatchVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(MatchVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfMatchVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfMatchVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfMatchVm {
    pageItems: MatchVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PaginationFilterOfMatchFilter implements IPaginationFilterOfMatchFilter {
    filter!: MatchFilter | undefined;
    pageIndex!: number | undefined;
    pageSize!: number | undefined;
    sortBy!: string | undefined;
    sortOrder!: string | undefined;

    constructor(data?: IPaginationFilterOfMatchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? MatchFilter.fromJS(_data["filter"]) : <any>undefined;
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.sortBy = _data["sortBy"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): PaginationFilterOfMatchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationFilterOfMatchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["sortBy"] = this.sortBy;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IPaginationFilterOfMatchFilter {
    filter: MatchFilter | undefined;
    pageIndex: number | undefined;
    pageSize: number | undefined;
    sortBy: string | undefined;
    sortOrder: string | undefined;
}

export class MatchFilter implements IMatchFilter {
    homeTeamDisplayName!: string | undefined;
    awayTeamDisplayName!: string | undefined;
    competitionId!: number | undefined;
    involvingTeamId!: number | undefined;
    involvingTeamId2!: number | undefined;
    involvingClubId!: number | undefined;
    id!: number | undefined;
    venue!: string | undefined;
    competitionStage!: string | undefined;
    round!: string | undefined;
    status!: string | undefined;
    startDate!: FilterItemOfDateTime[] | undefined;

    constructor(data?: IMatchFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.competitionId = _data["competitionId"];
            this.involvingTeamId = _data["involvingTeamId"];
            this.involvingTeamId2 = _data["involvingTeamId2"];
            this.involvingClubId = _data["involvingClubId"];
            this.id = _data["id"];
            this.venue = _data["venue"];
            this.competitionStage = _data["competitionStage"];
            this.round = _data["round"];
            this.status = _data["status"];
            if (Array.isArray(_data["startDate"])) {
                this.startDate = [] as any;
                for (let item of _data["startDate"])
                    this.startDate!.push(FilterItemOfDateTime.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchFilter {
        data = typeof data === 'object' ? data : {};
        let result = new MatchFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["competitionId"] = this.competitionId;
        data["involvingTeamId"] = this.involvingTeamId;
        data["involvingTeamId2"] = this.involvingTeamId2;
        data["involvingClubId"] = this.involvingClubId;
        data["id"] = this.id;
        data["venue"] = this.venue;
        data["competitionStage"] = this.competitionStage;
        data["round"] = this.round;
        data["status"] = this.status;
        if (Array.isArray(this.startDate)) {
            data["startDate"] = [];
            for (let item of this.startDate)
                data["startDate"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchFilter {
    homeTeamDisplayName: string | undefined;
    awayTeamDisplayName: string | undefined;
    competitionId: number | undefined;
    involvingTeamId: number | undefined;
    involvingTeamId2: number | undefined;
    involvingClubId: number | undefined;
    id: number | undefined;
    venue: string | undefined;
    competitionStage: string | undefined;
    round: string | undefined;
    status: string | undefined;
    startDate: FilterItemOfDateTime[] | undefined;
}

export class FilterItemOfDateTime implements IFilterItemOfDateTime {
    value!: Date;
    operation!: string | undefined;

    constructor(data?: IFilterItemOfDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): FilterItemOfDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new FilterItemOfDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["operation"] = this.operation;
        return data;
    }
}

export interface IFilterItemOfDateTime {
    value: Date;
    operation: string | undefined;
}

export class MatchAnalysisVm implements IMatchAnalysisVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string | undefined;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    competitionId!: number;
    competitionDisplayName!: string | undefined;
    startDate!: Date;
    statusId!: number;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    players!: MatchAnalysisPlayerVm[] | undefined;
    events!: EventLightVm[] | undefined;

    constructor(data?: IMatchAnalysisVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(MatchAnalysisPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(EventLightVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MatchAnalysisVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchAnalysisVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMatchAnalysisVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string | undefined;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    competitionId: number;
    competitionDisplayName: string | undefined;
    startDate: Date;
    statusId: number;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    players: MatchAnalysisPlayerVm[] | undefined;
    events: EventLightVm[] | undefined;
}

export class MatchAnalysisPlayerVm implements IMatchAnalysisPlayerVm {
    id!: number;
    playerId!: number;
    teamId!: number;
    capNumber!: number;
    name!: string | undefined;
    surname!: string | undefined;

    constructor(data?: IMatchAnalysisPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.capNumber = _data["capNumber"];
            this.name = _data["name"];
            this.surname = _data["surname"];
        }
    }

    static fromJS(data: any): MatchAnalysisPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchAnalysisPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["capNumber"] = this.capNumber;
        data["name"] = this.name;
        data["surname"] = this.surname;
        return data;
    }
}

export interface IMatchAnalysisPlayerVm {
    id: number;
    playerId: number;
    teamId: number;
    capNumber: number;
    name: string | undefined;
    surname: string | undefined;
}

export class GetMatchAnalysisQuery implements IGetMatchAnalysisQuery {
    matchIds!: number[] | undefined;

    constructor(data?: IGetMatchAnalysisQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matchIds"])) {
                this.matchIds = [] as any;
                for (let item of _data["matchIds"])
                    this.matchIds!.push(item);
            }
        }
    }

    static fromJS(data: any): GetMatchAnalysisQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchAnalysisQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matchIds)) {
            data["matchIds"] = [];
            for (let item of this.matchIds)
                data["matchIds"].push(item);
        }
        return data;
    }
}

export interface IGetMatchAnalysisQuery {
    matchIds: number[] | undefined;
}

export class ChangedFeedListVm implements IChangedFeedListVm {
    items!: ChangedFeedItemVm[] | undefined;
    serverTimeUtc!: Date;

    constructor(data?: IChangedFeedListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChangedFeedItemVm.fromJS(item));
            }
            this.serverTimeUtc = _data["serverTimeUtc"] ? new Date(_data["serverTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangedFeedListVm {
        data = typeof data === 'object' ? data : {};
        let result = new ChangedFeedListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["serverTimeUtc"] = this.serverTimeUtc ? this.serverTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangedFeedListVm {
    items: ChangedFeedItemVm[] | undefined;
    serverTimeUtc: Date;
}

export class ChangedFeedItemVm implements IChangedFeedItemVm {
    id!: number;
    lastModifiedUtc!: Date;
    isDeleted!: boolean;
    birthDate!: Date | undefined;

    constructor(data?: IChangedFeedItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangedFeedItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new ChangedFeedItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangedFeedItemVm {
    id: number;
    lastModifiedUtc: Date;
    birthDate: Date | undefined;
    isDeleted: boolean;
}

export class MatchChangedListVm implements IMatchChangedListVm {
    matches!: MatchChangedItemVm[] | undefined;
    serverTimeUtc!: Date;

    constructor(data?: IMatchChangedListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchChangedItemVm.fromJS(item));
            }
            this.serverTimeUtc = _data["serverTimeUtc"] ? new Date(_data["serverTimeUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchChangedListVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchChangedListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        data["serverTimeUtc"] = this.serverTimeUtc ? this.serverTimeUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMatchChangedListVm {
    matches: MatchChangedItemVm[] | undefined;
    serverTimeUtc: Date;
}

export class MatchChangedItemVm implements IMatchChangedItemVm {
    id!: number;
    competitionId!: number;
    statusId!: number;
    syncLocked!: boolean;
    startDate!: Date;
    lineupStamp!: string | undefined;
    lastModifiedUtc!: Date;
    revision!: number;
    isDeleted!: boolean;
    previousCompetitionId!: number | undefined;

    constructor(data?: IMatchChangedItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.competitionId = _data["competitionId"];
            this.statusId = _data["statusId"];
            this.syncLocked = _data["syncLocked"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.lineupStamp = _data["lineupStamp"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.revision = _data["revision"];
            this.isDeleted = _data["isDeleted"];
            this.previousCompetitionId = _data["previousCompetitionId"];
        }
    }

    static fromJS(data: any): MatchChangedItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchChangedItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["competitionId"] = this.competitionId;
        data["statusId"] = this.statusId;
        data["syncLocked"] = this.syncLocked;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["lineupStamp"] = this.lineupStamp;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["revision"] = this.revision;
        data["isDeleted"] = this.isDeleted;
        data["previousCompetitionId"] = this.previousCompetitionId;
        return data;
    }
}

export interface IMatchChangedItemVm {
    id: number;
    competitionId: number;
    statusId: number;
    syncLocked: boolean;
    startDate: Date;
    lineupStamp: string | undefined;
    lastModifiedUtc: Date;
    revision: number;
    isDeleted: boolean;
    previousCompetitionId: number | undefined;
}

export class MatchDetailVm extends MatchVm implements IMatchDetailVm {
    competition!: CompetitionVm | undefined;
    homeTeam!: TeamVm | undefined;
    awayTeam!: TeamVm | undefined;
    competitionLogo!: string | undefined;
    federationLogo!: string | undefined;
    officials!: MatchOfficialVm[] | undefined;
    coaches!: MatchCoachVm[] | undefined;
    players!: MatchPlayerVm[] | undefined;
    hungaryGameId!: number | undefined;
    eurocupMatchKey!: string | undefined;
    championsLeagueMatchKey!: string | undefined;
    microplusMatchKey?: string;

    constructor(data?: IMatchDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.competition = _data["competition"] ? CompetitionVm.fromJS(_data["competition"]) : <any>undefined;
            this.homeTeam = _data["homeTeam"] ? TeamVm.fromJS(_data["homeTeam"]) : <any>undefined;
            this.awayTeam = _data["awayTeam"] ? TeamVm.fromJS(_data["awayTeam"]) : <any>undefined;
            this.competitionLogo = _data["competitionLogo"];
            this.federationLogo = _data["federationLogo"];
            if (Array.isArray(_data["officials"])) {
                this.officials = [] as any;
                for (let item of _data["officials"])
                    this.officials!.push(MatchOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(MatchCoachVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(MatchPlayerVm.fromJS(item));
            }
            this.hungaryGameId = _data["hungaryGameId"];
            this.eurocupMatchKey = _data["eurocupMatchKey"];
            this.championsLeagueMatchKey = _data["championsLeagueMatchKey"];
            this.microplusMatchKey = _data["microplusMatchKey"];
        }
    }

    static fromJS(data: any): MatchDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competition"] = this.competition ? this.competition.toJSON() : <any>undefined;
        data["homeTeam"] = this.homeTeam ? this.homeTeam.toJSON() : <any>undefined;
        data["awayTeam"] = this.awayTeam ? this.awayTeam.toJSON() : <any>undefined;
        data["competitionLogo"] = this.competitionLogo;
        data["federationLogo"] = this.federationLogo;
        if (Array.isArray(this.officials)) {
            data["officials"] = [];
            for (let item of this.officials)
                data["officials"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        data["hungaryGameId"] = this.hungaryGameId;
        data["eurocupMatchKey"] = this.eurocupMatchKey;
        data["championsLeagueMatchKey"] = this.championsLeagueMatchKey;
        data["microplusMatchKey"] = this.microplusMatchKey;
        super.toJSON(data);
        return data;
    }
}

export interface IMatchDetailVm extends IMatchVm {
    competition: CompetitionVm | undefined;
    homeTeam: TeamVm | undefined;
    awayTeam: TeamVm | undefined;
    competitionLogo: string | undefined;
    federationLogo: string | undefined;
    officials: MatchOfficialVm[] | undefined;
    coaches: MatchCoachVm[] | undefined;
    players: MatchPlayerVm[] | undefined;
    hungaryGameId: number | undefined;
    eurocupMatchKey: string | undefined;
    championsLeagueMatchKey: string | undefined;
    microplusMatchKey?: string;
}

export class MatchOfficialVm implements IMatchOfficialVm {
    id!: number | undefined;
    matchId!: number;
    officialId!: number;
    roleId!: OfficialRoleEnum;
    match!: MatchVm;
    official!: OfficialVm;
    role!: string;
    confirmed!: boolean;

    constructor(data?: IMatchOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.officialId = _data["officialId"];
            this.roleId = _data["roleId"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.role = _data["role"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): MatchOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["officialId"] = this.officialId;
        data["roleId"] = this.roleId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IMatchOfficialVm {
    id: number | undefined;
    matchId: number;
    officialId: number;
    roleId: OfficialRoleEnum;
    match: MatchVm;
    official: OfficialVm;
    role: string;
    confirmed: boolean;
}

export class MatchPlayerVm implements IMatchPlayerVm {
    id!: number | undefined;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;
    position!: string;
    match!: MatchVm;
    player!: PlayerVm;
    team!: TeamVm;

    constructor(data?: IMatchPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.position = _data["position"];
            this.match = _data["match"] ? MatchVm.fromJS(_data["match"]) : <any>undefined;
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["position"] = this.position;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchPlayerVm {
    id: number | undefined;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
    position: string;
    match: MatchVm;
    player: PlayerVm;
    team: TeamVm;
}

export class LatestFinishedMatchLineupVm implements ILatestFinishedMatchLineupVm {
    homePlayers!: MatchPlayerLineupCopyItemVm[] | undefined;
    awayPlayers!: MatchPlayerLineupCopyItemVm[] | undefined;

    constructor(data?: ILatestFinishedMatchLineupVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["homePlayers"])) {
                this.homePlayers = [] as any;
                for (let item of _data["homePlayers"])
                    this.homePlayers!.push(MatchPlayerLineupCopyItemVm.fromJS(item));
            }
            if (Array.isArray(_data["awayPlayers"])) {
                this.awayPlayers = [] as any;
                for (let item of _data["awayPlayers"])
                    this.awayPlayers!.push(MatchPlayerLineupCopyItemVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LatestFinishedMatchLineupVm {
        data = typeof data === 'object' ? data : {};
        let result = new LatestFinishedMatchLineupVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.homePlayers)) {
            data["homePlayers"] = [];
            for (let item of this.homePlayers)
                data["homePlayers"].push(item.toJSON());
        }
        if (Array.isArray(this.awayPlayers)) {
            data["awayPlayers"] = [];
            for (let item of this.awayPlayers)
                data["awayPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILatestFinishedMatchLineupVm {
    homePlayers: MatchPlayerLineupCopyItemVm[] | undefined;
    awayPlayers: MatchPlayerLineupCopyItemVm[] | undefined;
}

export class MatchPlayerLineupCopyItemVm implements IMatchPlayerLineupCopyItemVm {
    number!: number;
    capNumber!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: IMatchPlayerLineupCopyItemVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): MatchPlayerLineupCopyItemVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchPlayerLineupCopyItemVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface IMatchPlayerLineupCopyItemVm {
    number: number;
    capNumber: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class CreateMatchCommandOfMatch implements ICreateMatchCommandOfMatch {
    competitionId!: number;
    homeTeamId!: number;
    awayTeamId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;
    matchSegmentId!: MatchSegmentEnum;
    statusId!: MatchStatusEnum;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    disciplinaryNote!: string | undefined;

    constructor(data?: ICreateMatchCommandOfMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.competitionId = _data["competitionId"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamId = _data["awayTeamId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.statusId = _data["statusId"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): CreateMatchCommandOfMatch {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchCommandOfMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["competitionId"] = this.competitionId;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamId"] = this.awayTeamId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["matchSegmentId"] = this.matchSegmentId;
        data["statusId"] = this.statusId;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface ICreateMatchCommandOfMatch {
    competitionId: number;
    homeTeamId: number;
    awayTeamId: number;
    countryId: number | undefined;
    cityId: number | undefined;
    matchSegmentId: MatchSegmentEnum;
    statusId: MatchStatusEnum;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    startDate: Date;
    endDate: Date | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    disciplinaryNote: string | undefined;
}

export class UpdateMatchCommand implements IUpdateMatchCommand {
    id!: number;
    competitionId!: number;
    homeTeamId!: number;
    awayTeamId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;
    matchSegmentId!: MatchSegmentEnum;
    statusId!: MatchStatusEnum;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    disciplinaryNote!: string | undefined;

    constructor(data?: IUpdateMatchCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.competitionId = _data["competitionId"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamId = _data["awayTeamId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.statusId = _data["statusId"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): UpdateMatchCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["competitionId"] = this.competitionId;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamId"] = this.awayTeamId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        data["matchSegmentId"] = this.matchSegmentId;
        data["statusId"] = this.statusId;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface IUpdateMatchCommand {
    id: number;
    competitionId: number;
    homeTeamId: number;
    awayTeamId: number;
    countryId: number | undefined;
    cityId: number | undefined;
    matchSegmentId: MatchSegmentEnum;
    statusId: MatchStatusEnum;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    startDate: Date;
    endDate: Date | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    disciplinaryNote: string | undefined;
}

export class DeleteMatchEventsResultVm implements IDeleteMatchEventsResultVm {
    matchId!: number;
    deletedCount!: number;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;

    constructor(data?: IDeleteMatchEventsResultVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.deletedCount = _data["deletedCount"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
        }
    }

    static fromJS(data: any): DeleteMatchEventsResultVm {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteMatchEventsResultVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["deletedCount"] = this.deletedCount;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        return data;
    }
}

export interface IDeleteMatchEventsResultVm {
    matchId: number;
    deletedCount: number;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
}

export class MatchSyncLockVm implements IMatchSyncLockVm {
    matchId!: number;
    syncLocked!: boolean;

    constructor(data?: IMatchSyncLockVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.syncLocked = _data["syncLocked"];
        }
    }

    static fromJS(data: any): MatchSyncLockVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchSyncLockVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["syncLocked"] = this.syncLocked;
        return data;
    }
}

export interface IMatchSyncLockVm {
    matchId: number;
    syncLocked: boolean;
}

export class SetMatchSyncLockRequest implements ISetMatchSyncLockRequest {
    locked!: boolean;

    constructor(data?: ISetMatchSyncLockRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locked = _data["locked"];
        }
    }

    static fromJS(data: any): SetMatchSyncLockRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetMatchSyncLockRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locked"] = this.locked;
        return data;
    }
}

export interface ISetMatchSyncLockRequest {
    locked: boolean;
}

export class ReimportMatchJobVm implements IReimportMatchJobVm {
    jobId!: string;
    matchId!: number;
    status!: string | undefined;
    eventsWritten!: number;
    error!: string | undefined;

    constructor(data?: IReimportMatchJobVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.matchId = _data["matchId"];
            this.status = _data["status"];
            this.eventsWritten = _data["eventsWritten"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ReimportMatchJobVm {
        data = typeof data === 'object' ? data : {};
        let result = new ReimportMatchJobVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["matchId"] = this.matchId;
        data["status"] = this.status;
        data["eventsWritten"] = this.eventsWritten;
        data["error"] = this.error;
        return data;
    }
}

export interface IReimportMatchJobVm {
    jobId: string;
    matchId: number;
    status: string | undefined;
    eventsWritten: number;
    error: string | undefined;
}

export class CreateOrUpdateMatchOfficialsCommand implements ICreateOrUpdateMatchOfficialsCommand {
    matchId!: number;
    matchOfficials!: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;

    constructor(data?: ICreateOrUpdateMatchOfficialsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchOfficials"])) {
                this.matchOfficials = [] as any;
                for (let item of _data["matchOfficials"])
                    this.matchOfficials!.push(CreateMatchOfficialCommandOfMatchOfficial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchOfficialsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchOfficialsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchOfficials)) {
            data["matchOfficials"] = [];
            for (let item of this.matchOfficials)
                data["matchOfficials"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchOfficialsCommand {
    matchId: number;
    matchOfficials: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
}

export class CreateMatchOfficialCommandOfMatchOfficial implements ICreateMatchOfficialCommandOfMatchOfficial {
    id!: number;
    matchId!: number;
    officialId!: number;
    roleId!: OfficialRoleEnum;

    constructor(data?: ICreateMatchOfficialCommandOfMatchOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.officialId = _data["officialId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateMatchOfficialCommandOfMatchOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchOfficialCommandOfMatchOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["officialId"] = this.officialId;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateMatchOfficialCommandOfMatchOfficial {
    id: number;
    matchId: number;
    officialId: number;
    roleId: OfficialRoleEnum;
}

export class CreateOrUpdateMatchPlayersCommand implements ICreateOrUpdateMatchPlayersCommand {
    matchId!: number;
    matchPlayers!: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;

    constructor(data?: ICreateOrUpdateMatchPlayersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchPlayers"])) {
                this.matchPlayers = [] as any;
                for (let item of _data["matchPlayers"])
                    this.matchPlayers!.push(CreateMatchPlayerCommandOfMatchPlayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchPlayersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchPlayersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchPlayers)) {
            data["matchPlayers"] = [];
            for (let item of this.matchPlayers)
                data["matchPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchPlayersCommand {
    matchId: number;
    matchPlayers: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;
}

export class CreateMatchPlayerCommandOfMatchPlayer implements ICreateMatchPlayerCommandOfMatchPlayer {
    id!: number;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;

    constructor(data?: ICreateMatchPlayerCommandOfMatchPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
        }
    }

    static fromJS(data: any): CreateMatchPlayerCommandOfMatchPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMatchPlayerCommandOfMatchPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        return data;
    }
}

export interface ICreateMatchPlayerCommandOfMatchPlayer {
    id: number;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
}

export class CreateOrUpdateMatchCoachesCommand implements ICreateOrUpdateMatchCoachesCommand {
    matchId!: number;
    matchCoaches!: CreateMatchCoachCommandOfMatchCoach[] | undefined;

    constructor(data?: ICreateOrUpdateMatchCoachesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchCoaches"])) {
                this.matchCoaches = [] as any;
                for (let item of _data["matchCoaches"])
                    this.matchCoaches!.push(CreateMatchCoachCommandOfMatchCoach.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateMatchCoachesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMatchCoachesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchCoaches)) {
            data["matchCoaches"] = [];
            for (let item of this.matchCoaches)
                data["matchCoaches"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateMatchCoachesCommand {
    matchId: number;
    matchCoaches: CreateMatchCoachCommandOfMatchCoach[] | undefined;
}

export class UpdateMatchLogCommand implements IUpdateMatchLogCommand {
    matchId!: number;
    matchCoaches!: CreateMatchCoachCommandOfMatchCoach[] | undefined;
    matchOfficials!: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
    matchPlayers!: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;

    constructor(data?: IUpdateMatchLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            if (Array.isArray(_data["matchCoaches"])) {
                this.matchCoaches = [] as any;
                for (let item of _data["matchCoaches"])
                    this.matchCoaches!.push(CreateMatchCoachCommandOfMatchCoach.fromJS(item));
            }
            if (Array.isArray(_data["matchOfficials"])) {
                this.matchOfficials = [] as any;
                for (let item of _data["matchOfficials"])
                    this.matchOfficials!.push(CreateMatchOfficialCommandOfMatchOfficial.fromJS(item));
            }
            if (Array.isArray(_data["matchPlayers"])) {
                this.matchPlayers = [] as any;
                for (let item of _data["matchPlayers"])
                    this.matchPlayers!.push(CreateMatchPlayerCommandOfMatchPlayer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMatchLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        if (Array.isArray(this.matchCoaches)) {
            data["matchCoaches"] = [];
            for (let item of this.matchCoaches)
                data["matchCoaches"].push(item.toJSON());
        }
        if (Array.isArray(this.matchOfficials)) {
            data["matchOfficials"] = [];
            for (let item of this.matchOfficials)
                data["matchOfficials"].push(item.toJSON());
        }
        if (Array.isArray(this.matchPlayers)) {
            data["matchPlayers"] = [];
            for (let item of this.matchPlayers)
                data["matchPlayers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateMatchLogCommand {
    matchId: number;
    matchCoaches: CreateMatchCoachCommandOfMatchCoach[] | undefined;
    matchOfficials: CreateMatchOfficialCommandOfMatchOfficial[] | undefined;
    matchPlayers: CreateMatchPlayerCommandOfMatchPlayer[] | undefined;
}

export class UpdateMatchDisciplinaryNoteCommand implements IUpdateMatchDisciplinaryNoteCommand {
    matchId!: number;
    disciplinaryNote!: string | undefined;

    constructor(data?: IUpdateMatchDisciplinaryNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.disciplinaryNote = _data["disciplinaryNote"];
        }
    }

    static fromJS(data: any): UpdateMatchDisciplinaryNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchDisciplinaryNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["disciplinaryNote"] = this.disciplinaryNote;
        return data;
    }
}

export interface IUpdateMatchDisciplinaryNoteCommand {
    matchId: number;
    disciplinaryNote: string | undefined;
}

export class ConfirmMatchLogCommand implements IConfirmMatchLogCommand {
    matchOfficialId!: number;
    pin!: string;

    constructor(data?: IConfirmMatchLogCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchOfficialId = _data["matchOfficialId"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): ConfirmMatchLogCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmMatchLogCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchOfficialId"] = this.matchOfficialId;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IConfirmMatchLogCommand {
    matchOfficialId: number;
    pin: string;
}

export class UpdateMatchOfficialCommandOfMatchOfficial extends CreateMatchOfficialCommandOfMatchOfficial implements IUpdateMatchOfficialCommandOfMatchOfficial {

    constructor(data?: IUpdateMatchOfficialCommandOfMatchOfficial) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchOfficialCommandOfMatchOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchOfficialCommandOfMatchOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchOfficialCommandOfMatchOfficial extends ICreateMatchOfficialCommandOfMatchOfficial {
}

export class UpdateMatchPlayerCommandOfMatchPlayer extends CreateMatchPlayerCommandOfMatchPlayer implements IUpdateMatchPlayerCommandOfMatchPlayer {

    constructor(data?: IUpdateMatchPlayerCommandOfMatchPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateMatchPlayerCommandOfMatchPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMatchPlayerCommandOfMatchPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateMatchPlayerCommandOfMatchPlayer extends ICreateMatchPlayerCommandOfMatchPlayer {
}

export class PaginatedListOfOfficialVm implements IPaginatedListOfOfficialVm {
    pageItems!: OfficialVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(OfficialVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfOfficialVm {
    pageItems: OfficialVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class OfficialDetailVm implements IOfficialDetailVm {
    id!: number;
    title!: string | undefined;
    personId!: number;
    person!: PersonVm;
    federations!: FederationOfficialVm[];
    matches!: MatchOfficialVm[];

    constructor(data?: IOfficialDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["federations"])) {
                this.federations = [] as any;
                for (let item of _data["federations"])
                    this.federations!.push(FederationOfficialVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchOfficialVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OfficialDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.federations)) {
            data["federations"] = [];
            for (let item of this.federations)
                data["federations"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfficialDetailVm {
    id: number;
    title: string | undefined;
    personId: number;
    person: PersonVm;
    federations: FederationOfficialVm[];
    matches: MatchOfficialVm[];
}

export class CreateOfficialCommand implements ICreateOfficialCommand {
    title!: string | undefined;
    personId!: number;
    federations!: CreateFederationOfficialCommandOfFederationOfficial[];

    constructor(data?: ICreateOfficialCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.federations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.personId = _data["personId"];
            if (Array.isArray(_data["federations"])) {
                this.federations = [] as any;
                for (let item of _data["federations"])
                    this.federations!.push(CreateFederationOfficialCommandOfFederationOfficial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOfficialCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfficialCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["personId"] = this.personId;
        if (Array.isArray(this.federations)) {
            data["federations"] = [];
            for (let item of this.federations)
                data["federations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOfficialCommand {
    title: string | undefined;
    personId: number;
    federations: CreateFederationOfficialCommandOfFederationOfficial[];
}

export class UpdateOfficialCommandOfOfficial implements IUpdateOfficialCommandOfOfficial {
    id!: number;
    title!: string | undefined;

    constructor(data?: IUpdateOfficialCommandOfOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateOfficialCommandOfOfficial {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficialCommandOfOfficial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateOfficialCommandOfOfficial {
    id: number;
    title: string | undefined;
}

export class UpdateOfficialPinCommand implements IUpdateOfficialPinCommand {
    id!: number;
    pin!: string;

    constructor(data?: IUpdateOfficialPinCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pin = _data["pin"];
        }
    }

    static fromJS(data: any): UpdateOfficialPinCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOfficialPinCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pin"] = this.pin;
        return data;
    }
}

export interface IUpdateOfficialPinCommand {
    id: number;
    pin: string;
}

export class CreatePersonCommandOfPerson implements ICreatePersonCommandOfPerson {
    name!: string;
    surname!: string;
    birthDate!: Date;
    nationality!: string | undefined;
    address!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    photo!: string | undefined;
    countryOfBirthId!: number | undefined;
    cityOfBirthId!: number | undefined;
    playerId!: number | undefined;
    coachId!: number | undefined;
    officialId!: number | undefined;
    official!: CreateOfficialCommand | undefined;
    player!: CreatePlayerCommand | undefined;
    coach!: CreateCoachCommand | undefined;

    constructor(data?: ICreatePersonCommandOfPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.nationality = _data["nationality"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.photo = _data["photo"];
            this.countryOfBirthId = _data["countryOfBirthId"];
            this.cityOfBirthId = _data["cityOfBirthId"];
            this.playerId = _data["playerId"];
            this.coachId = _data["coachId"];
            this.officialId = _data["officialId"];
            this.official = _data["official"] ? CreateOfficialCommand.fromJS(_data["official"]) : <any>undefined;
            this.player = _data["player"] ? CreatePlayerCommand.fromJS(_data["player"]) : <any>undefined;
            this.coach = _data["coach"] ? CreateCoachCommand.fromJS(_data["coach"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreatePersonCommandOfPerson {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonCommandOfPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["nationality"] = this.nationality;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["photo"] = this.photo;
        data["countryOfBirthId"] = this.countryOfBirthId;
        data["cityOfBirthId"] = this.cityOfBirthId;
        data["playerId"] = this.playerId;
        data["coachId"] = this.coachId;
        data["officialId"] = this.officialId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePersonCommandOfPerson {
    name: string;
    surname: string;
    birthDate: Date;
    nationality: string | undefined;
    address: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    photo: string | undefined;
    countryOfBirthId: number | undefined;
    cityOfBirthId: number | undefined;
    playerId: number | undefined;
    coachId: number | undefined;
    officialId: number | undefined;
    official: CreateOfficialCommand | undefined;
    player: CreatePlayerCommand | undefined;
    coach: CreateCoachCommand | undefined;
}

export class CreatePlayerCommand implements ICreatePlayerCommand {
    personId!: number;
    primaryPositionId!: PlayerPositionEnum | undefined;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    clubs!: CreateClubPlayerCommandOfClubPlayer[] | undefined;
    teams!: CreateTeamPlayerCommandOfTeamPlayer[] | undefined;
    allowWithoutSquad!: boolean;

    constructor(data?: ICreatePlayerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personId = _data["personId"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(CreateClubPlayerCommandOfClubPlayer.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(CreateTeamPlayerCommandOfTeamPlayer.fromJS(item));
            }
            this.allowWithoutSquad = _data["allowWithoutSquad"];
        }
    }

    static fromJS(data: any): CreatePlayerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlayerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personId"] = this.personId;
        data["primaryPositionId"] = this.primaryPositionId;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        data["allowWithoutSquad"] = this.allowWithoutSquad;
        return data;
    }
}

export interface ICreatePlayerCommand {
    personId: number;
    primaryPositionId: PlayerPositionEnum | undefined;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    clubs: CreateClubPlayerCommandOfClubPlayer[] | undefined;
    teams: CreateTeamPlayerCommandOfTeamPlayer[] | undefined;
    allowWithoutSquad: boolean;
}

export class CreateTeamPlayerCommandOfTeamPlayer implements ICreateTeamPlayerCommandOfTeamPlayer {
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    capNumber!: number | undefined;

    constructor(data?: ICreateTeamPlayerCommandOfTeamPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.capNumber = _data["capNumber"];
        }
    }

    static fromJS(data: any): CreateTeamPlayerCommandOfTeamPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamPlayerCommandOfTeamPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["capNumber"] = this.capNumber;
        return data;
    }
}

export interface ICreateTeamPlayerCommandOfTeamPlayer {
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    capNumber: number | undefined;
}

export class MergePersonCommand implements IMergePersonCommand {
    id!: number;
    targetPersonId!: number;

    constructor(data?: IMergePersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetPersonId = _data["targetPersonId"];
        }
    }

    static fromJS(data: any): MergePersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MergePersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetPersonId"] = this.targetPersonId;
        return data;
    }
}

export interface IMergePersonCommand {
    id: number;
    targetPersonId: number;
}

export class UpdatePersonCommandOfPerson extends CreatePersonCommandOfPerson implements IUpdatePersonCommandOfPerson {
    id!: number;

    constructor(data?: IUpdatePersonCommandOfPerson) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePersonCommandOfPerson {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonCommandOfPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdatePersonCommandOfPerson extends ICreatePersonCommandOfPerson {
    id: number;
}

export class PaginatedListOfPlayerVm implements IPaginatedListOfPlayerVm {
    pageItems!: PlayerVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(PlayerVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfPlayerVm {
    pageItems: PlayerVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class PlayerLightProfileVm implements IPlayerLightProfileVm {
    id!: number;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    personId!: number;
    person!: PersonVm;
    matches!: PlayerMatchLightRowVm[];

    constructor(data?: IPlayerLightProfileVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(PlayerMatchLightRowVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerLightProfileVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerLightProfileVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerLightProfileVm {
    id: number;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    personId: number;
    person: PersonVm;
    matches: PlayerMatchLightRowVm[];
}

export class PlayerMatchLightRowVm implements IPlayerMatchLightRowVm {
    matchId!: number;
    match!: MatchLightVm;

    constructor(data?: IPlayerMatchLightRowVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.match = _data["match"] ? MatchLightVm.fromJS(_data["match"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerMatchLightRowVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerMatchLightRowVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["match"] = this.match ? this.match.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerMatchLightRowVm {
    matchId: number;
    match: MatchLightVm;
}

export class MatchLightVm implements IMatchLightVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    federationId!: number;
    federationDisplayName!: string;
    competitionId!: number;
    competitionDisplayName!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string | undefined;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    statusId!: MatchStatusEnum;
    status!: string;
    matchSegmentId!: MatchSegmentEnum;
    matchSegment!: string;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;

    constructor(data?: IMatchLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.federationId = _data["federationId"];
            this.federationDisplayName = _data["federationDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegment = _data["matchSegment"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
        }
    }

    static fromJS(data: any): MatchLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["federationId"] = this.federationId;
        data["federationDisplayName"] = this.federationDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegment"] = this.matchSegment;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        return data;
    }
}

export interface IMatchLightVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    federationId: number;
    federationDisplayName: string;
    competitionId: number;
    competitionDisplayName: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string | undefined;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    startDate: Date;
    endDate: Date | undefined;
    statusId: MatchStatusEnum;
    status: string;
    matchSegmentId: MatchSegmentEnum;
    matchSegment: string;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
}

export class PlayerDetailVm implements IPlayerDetailVm {
    id!: number;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;
    primaryPositionId!: PlayerPositionEnum | undefined;
    primaryPosition!: string | undefined;
    personId!: number;
    person!: PersonVm;
    clubs!: ClubPlayerVm[];
    teams!: TeamPlayerVm[];
    matches!: MatchPlayerVm[];

    constructor(data?: IPlayerDetailVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.primaryPosition = _data["primaryPosition"];
            this.personId = _data["personId"];
            this.person = _data["person"] ? PersonVm.fromJS(_data["person"]) : <any>undefined;
            if (Array.isArray(_data["clubs"])) {
                this.clubs = [] as any;
                for (let item of _data["clubs"])
                    this.clubs!.push(ClubPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["teams"])) {
                this.teams = [] as any;
                for (let item of _data["teams"])
                    this.teams!.push(TeamPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(MatchPlayerVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        data["primaryPositionId"] = this.primaryPositionId;
        data["primaryPosition"] = this.primaryPosition;
        data["personId"] = this.personId;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        if (Array.isArray(this.clubs)) {
            data["clubs"] = [];
            for (let item of this.clubs)
                data["clubs"].push(item.toJSON());
        }
        if (Array.isArray(this.teams)) {
            data["teams"] = [];
            for (let item of this.teams)
                data["teams"].push(item.toJSON());
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlayerDetailVm {
    id: number;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
    primaryPositionId: PlayerPositionEnum | undefined;
    primaryPosition: string | undefined;
    personId: number;
    person: PersonVm;
    clubs: ClubPlayerVm[];
    teams: TeamPlayerVm[];
    matches: MatchPlayerVm[];
}

export class TeamPlayerVm implements ITeamPlayerVm {
    id!: number | undefined;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    capNumber!: number | undefined;
    player!: PlayerVm;
    team!: TeamVm;
    position!: string | undefined;

    constructor(data?: ITeamPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.capNumber = _data["capNumber"];
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
            this.team = _data["team"] ? TeamVm.fromJS(_data["team"]) : <any>undefined;
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): TeamPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["capNumber"] = this.capNumber;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        data["team"] = this.team ? this.team.toJSON() : <any>undefined;
        data["position"] = this.position;
        return data;
    }
}

export interface ITeamPlayerVm {
    id: number | undefined;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    capNumber: number | undefined;
    player: PlayerVm;
    team: TeamVm;
    position: string | undefined;
}

export class PlayerExtendedVm extends PlayerVm implements IPlayerExtendedVm {
    photo!: string | undefined;

    constructor(data?: IPlayerExtendedVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.photo = _data["photo"];
        }
    }

    static fromJS(data: any): PlayerExtendedVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerExtendedVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photo"] = this.photo;
        super.toJSON(data);
        return data;
    }
}

export interface IPlayerExtendedVm extends IPlayerVm {
    photo: string | undefined;
}

export class UpdatePlayerCommandOfPlayer implements IUpdatePlayerCommandOfPlayer {
    id!: number;
    primaryPositionId!: PlayerPositionEnum | undefined;
    height!: string | undefined;
    weight!: string | undefined;
    dominantHand!: string | undefined;

    constructor(data?: IUpdatePlayerCommandOfPlayer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.primaryPositionId = _data["primaryPositionId"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.dominantHand = _data["dominantHand"];
        }
    }

    static fromJS(data: any): UpdatePlayerCommandOfPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlayerCommandOfPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["primaryPositionId"] = this.primaryPositionId;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["dominantHand"] = this.dominantHand;
        return data;
    }
}

export interface IUpdatePlayerCommandOfPlayer {
    id: number;
    primaryPositionId: PlayerPositionEnum | undefined;
    height: string | undefined;
    weight: string | undefined;
    dominantHand: string | undefined;
}

export class PlayerStatsVm implements IPlayerStatsVm {
    shots!: ShotStatsVm | undefined;
    swimoffs!: SwimoffStatsVm | undefined;
    turnovers!: TurnoverStatsVm | undefined;
    exclusions!: ExclusionStatsVm | undefined;

    constructor(data?: IPlayerStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shots = _data["shots"] ? ShotStatsVm.fromJS(_data["shots"]) : <any>undefined;
            this.swimoffs = _data["swimoffs"] ? SwimoffStatsVm.fromJS(_data["swimoffs"]) : <any>undefined;
            this.turnovers = _data["turnovers"] ? TurnoverStatsVm.fromJS(_data["turnovers"]) : <any>undefined;
            this.exclusions = _data["exclusions"] ? ExclusionStatsVm.fromJS(_data["exclusions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PlayerStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new PlayerStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shots"] = this.shots ? this.shots.toJSON() : <any>undefined;
        data["swimoffs"] = this.swimoffs ? this.swimoffs.toJSON() : <any>undefined;
        data["turnovers"] = this.turnovers ? this.turnovers.toJSON() : <any>undefined;
        data["exclusions"] = this.exclusions ? this.exclusions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlayerStatsVm {
    shots: ShotStatsVm | undefined;
    swimoffs: SwimoffStatsVm | undefined;
    turnovers: TurnoverStatsVm | undefined;
    exclusions: ExclusionStatsVm | undefined;
}

export class ShotStatsVm implements IShotStatsVm {
    totalShots!: number;
    goalsScored!: number;
    goalsMissed!: number;
    goalsActionScored!: number;
    goalsActionMissed!: number;
    goalsPowerplayScored!: number;
    goalsPowerplayMissed!: number;
    goalsPenaltyScored!: number;
    goalsPenaltyMissed!: number;
    goalsFastBreakScored!: number;
    goalsFastBreakMissed!: number;
    goalsDirectFromFoulScored!: number;
    goalsDirectFromFoulMissed!: number;
    blocked!: number;
    saved!: number;
    assisted!: number;

    constructor(data?: IShotStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalShots = _data["totalShots"];
            this.goalsScored = _data["goalsScored"];
            this.goalsMissed = _data["goalsMissed"];
            this.goalsActionScored = _data["goalsActionScored"];
            this.goalsActionMissed = _data["goalsActionMissed"];
            this.goalsPowerplayScored = _data["goalsPowerplayScored"];
            this.goalsPowerplayMissed = _data["goalsPowerplayMissed"];
            this.goalsPenaltyScored = _data["goalsPenaltyScored"];
            this.goalsPenaltyMissed = _data["goalsPenaltyMissed"];
            this.goalsFastBreakScored = _data["goalsFastBreakScored"];
            this.goalsFastBreakMissed = _data["goalsFastBreakMissed"];
            this.goalsDirectFromFoulScored = _data["goalsDirectFromFoulScored"];
            this.goalsDirectFromFoulMissed = _data["goalsDirectFromFoulMissed"];
            this.blocked = _data["blocked"];
            this.saved = _data["saved"];
            this.assisted = _data["assisted"];
        }
    }

    static fromJS(data: any): ShotStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ShotStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalShots"] = this.totalShots;
        data["goalsScored"] = this.goalsScored;
        data["goalsMissed"] = this.goalsMissed;
        data["goalsActionScored"] = this.goalsActionScored;
        data["goalsActionMissed"] = this.goalsActionMissed;
        data["goalsPowerplayScored"] = this.goalsPowerplayScored;
        data["goalsPowerplayMissed"] = this.goalsPowerplayMissed;
        data["goalsPenaltyScored"] = this.goalsPenaltyScored;
        data["goalsPenaltyMissed"] = this.goalsPenaltyMissed;
        data["goalsFastBreakScored"] = this.goalsFastBreakScored;
        data["goalsFastBreakMissed"] = this.goalsFastBreakMissed;
        data["goalsDirectFromFoulScored"] = this.goalsDirectFromFoulScored;
        data["goalsDirectFromFoulMissed"] = this.goalsDirectFromFoulMissed;
        data["blocked"] = this.blocked;
        data["saved"] = this.saved;
        data["assisted"] = this.assisted;
        return data;
    }
}

export interface IShotStatsVm {
    totalShots: number;
    goalsScored: number;
    goalsMissed: number;
    goalsActionScored: number;
    goalsActionMissed: number;
    goalsPowerplayScored: number;
    goalsPowerplayMissed: number;
    goalsPenaltyScored: number;
    goalsPenaltyMissed: number;
    goalsFastBreakScored: number;
    goalsFastBreakMissed: number;
    goalsDirectFromFoulScored: number;
    goalsDirectFromFoulMissed: number;
    blocked: number;
    saved: number;
    assisted: number;
}

export class SwimoffStatsVm implements ISwimoffStatsVm {
    totalWins!: number;
    totalLoses!: number;

    constructor(data?: ISwimoffStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWins = _data["totalWins"];
            this.totalLoses = _data["totalLoses"];
        }
    }

    static fromJS(data: any): SwimoffStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SwimoffStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWins"] = this.totalWins;
        data["totalLoses"] = this.totalLoses;
        return data;
    }
}

export interface ISwimoffStatsVm {
    totalWins: number;
    totalLoses: number;
}

export class TurnoverStatsVm implements ITurnoverStatsVm {
    totalTurnoversWon!: number;
    totalTurnoversLost!: number;
    lostBallTurnoversWon!: number;
    lostBallTurnoversLost!: number;
    offensiveFoulTurnoversWon!: number;
    offensiveFoulTurnoversLost!: number;
    ballUnderTurnoversWon!: number;
    ballUnderTurnoversLost!: number;
    clockExpiredTurnoversWon!: number;
    clockExpiredTurnoversLost!: number;

    constructor(data?: ITurnoverStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalTurnoversWon = _data["totalTurnoversWon"];
            this.totalTurnoversLost = _data["totalTurnoversLost"];
            this.lostBallTurnoversWon = _data["lostBallTurnoversWon"];
            this.lostBallTurnoversLost = _data["lostBallTurnoversLost"];
            this.offensiveFoulTurnoversWon = _data["offensiveFoulTurnoversWon"];
            this.offensiveFoulTurnoversLost = _data["offensiveFoulTurnoversLost"];
            this.ballUnderTurnoversWon = _data["ballUnderTurnoversWon"];
            this.ballUnderTurnoversLost = _data["ballUnderTurnoversLost"];
            this.clockExpiredTurnoversWon = _data["clockExpiredTurnoversWon"];
            this.clockExpiredTurnoversLost = _data["clockExpiredTurnoversLost"];
        }
    }

    static fromJS(data: any): TurnoverStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new TurnoverStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalTurnoversWon"] = this.totalTurnoversWon;
        data["totalTurnoversLost"] = this.totalTurnoversLost;
        data["lostBallTurnoversWon"] = this.lostBallTurnoversWon;
        data["lostBallTurnoversLost"] = this.lostBallTurnoversLost;
        data["offensiveFoulTurnoversWon"] = this.offensiveFoulTurnoversWon;
        data["offensiveFoulTurnoversLost"] = this.offensiveFoulTurnoversLost;
        data["ballUnderTurnoversWon"] = this.ballUnderTurnoversWon;
        data["ballUnderTurnoversLost"] = this.ballUnderTurnoversLost;
        data["clockExpiredTurnoversWon"] = this.clockExpiredTurnoversWon;
        data["clockExpiredTurnoversLost"] = this.clockExpiredTurnoversLost;
        return data;
    }
}

export interface ITurnoverStatsVm {
    totalTurnoversWon: number;
    totalTurnoversLost: number;
    lostBallTurnoversWon: number;
    lostBallTurnoversLost: number;
    offensiveFoulTurnoversWon: number;
    offensiveFoulTurnoversLost: number;
    ballUnderTurnoversWon: number;
    ballUnderTurnoversLost: number;
    clockExpiredTurnoversWon: number;
    clockExpiredTurnoversLost: number;
}

export class ExclusionStatsVm implements IExclusionStatsVm {
    totalExclusions!: number;
    exclusions!: number;
    suspensions!: number;
    brutalities!: number;
    penalties!: number;
    totalExclusionsDrawn!: number;
    exclusionsDrawn!: number;
    suspensionsDrawn!: number;
    brutalitiesDrawn!: number;
    penaltiesDrawn!: number;

    constructor(data?: IExclusionStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalExclusions = _data["totalExclusions"];
            this.exclusions = _data["exclusions"];
            this.suspensions = _data["suspensions"];
            this.brutalities = _data["brutalities"];
            this.penalties = _data["penalties"];
            this.totalExclusionsDrawn = _data["totalExclusionsDrawn"];
            this.exclusionsDrawn = _data["exclusionsDrawn"];
            this.suspensionsDrawn = _data["suspensionsDrawn"];
            this.brutalitiesDrawn = _data["brutalitiesDrawn"];
            this.penaltiesDrawn = _data["penaltiesDrawn"];
        }
    }

    static fromJS(data: any): ExclusionStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ExclusionStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalExclusions"] = this.totalExclusions;
        data["exclusions"] = this.exclusions;
        data["suspensions"] = this.suspensions;
        data["brutalities"] = this.brutalities;
        data["penalties"] = this.penalties;
        data["totalExclusionsDrawn"] = this.totalExclusionsDrawn;
        data["exclusionsDrawn"] = this.exclusionsDrawn;
        data["suspensionsDrawn"] = this.suspensionsDrawn;
        data["brutalitiesDrawn"] = this.brutalitiesDrawn;
        data["penaltiesDrawn"] = this.penaltiesDrawn;
        return data;
    }
}

export interface IExclusionStatsVm {
    totalExclusions: number;
    exclusions: number;
    suspensions: number;
    brutalities: number;
    penalties: number;
    totalExclusionsDrawn: number;
    exclusionsDrawn: number;
    suspensionsDrawn: number;
    brutalitiesDrawn: number;
    penaltiesDrawn: number;
}

export class MatchMessage implements IMatchMessage {
    messageType!: MatchHubMessageTypeEnum;
    event!: EventVm | undefined;

    constructor(data?: IMatchMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageType = _data["messageType"];
            this.event = _data["event"] ? EventVm.fromJS(_data["event"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchMessage {
        data = typeof data === 'object' ? data : {};
        let result = new MatchMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageType"] = this.messageType;
        data["event"] = this.event ? this.event.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchMessage {
    messageType: MatchHubMessageTypeEnum;
    event: EventVm | undefined;
}

export enum MatchHubMessageTypeEnum {
    CreateEvent = 1300,
    UpdateEvent = 1301,
    DeleteEvent = 1302,
    MatchFinished = 1303,
    MatchUpdated = 1304,
}

export class UpdateTeamCoachCommandOfTeamCoach extends CreateTeamCoachCommandOfTeamCoach implements IUpdateTeamCoachCommandOfTeamCoach {
    id!: number;

    constructor(data?: IUpdateTeamCoachCommandOfTeamCoach) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamCoachCommandOfTeamCoach {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCoachCommandOfTeamCoach();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamCoachCommandOfTeamCoach extends ICreateTeamCoachCommandOfTeamCoach {
    id: number;
}

export class UpdateTeamPlayerCommandOfTeamPlayer extends CreateTeamPlayerCommandOfTeamPlayer implements IUpdateTeamPlayerCommandOfTeamPlayer {
    id!: number;

    constructor(data?: IUpdateTeamPlayerCommandOfTeamPlayer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamPlayerCommandOfTeamPlayer {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamPlayerCommandOfTeamPlayer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamPlayerCommandOfTeamPlayer extends ICreateTeamPlayerCommandOfTeamPlayer {
    id: number;
}

export class PaginatedListOfTeamVm implements IPaginatedListOfTeamVm {
    pageItems!: TeamVm[] | undefined;
    currentPage!: number;
    pageSize!: number;
    totalPages!: number;
    totalItems!: number;

    constructor(data?: IPaginatedListOfTeamVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pageItems"])) {
                this.pageItems = [] as any;
                for (let item of _data["pageItems"])
                    this.pageItems!.push(TeamVm.fromJS(item));
            }
            this.currentPage = _data["currentPage"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): PaginatedListOfTeamVm {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTeamVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pageItems)) {
            data["pageItems"] = [];
            for (let item of this.pageItems)
                data["pageItems"].push(item.toJSON());
        }
        data["currentPage"] = this.currentPage;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IPaginatedListOfTeamVm {
    pageItems: TeamVm[] | undefined;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalItems: number;
}

export class TeamDetailVm extends TeamVm implements ITeamDetailVm {
    logo!: string | undefined;
    competitionTeams!: CompetitionTeamVm[];
    homeMatches!: MatchVm[];
    awayMatches!: MatchVm[];
    players!: TeamPlayerVm[];
    coaches!: TeamCoachVm[];

    constructor(data?: ITeamDetailVm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.logo = _data["logo"];
            if (Array.isArray(_data["competitionTeams"])) {
                this.competitionTeams = [] as any;
                for (let item of _data["competitionTeams"])
                    this.competitionTeams!.push(CompetitionTeamVm.fromJS(item));
            }
            if (Array.isArray(_data["homeMatches"])) {
                this.homeMatches = [] as any;
                for (let item of _data["homeMatches"])
                    this.homeMatches!.push(MatchVm.fromJS(item));
            }
            if (Array.isArray(_data["awayMatches"])) {
                this.awayMatches = [] as any;
                for (let item of _data["awayMatches"])
                    this.awayMatches!.push(MatchVm.fromJS(item));
            }
            if (Array.isArray(_data["players"])) {
                this.players = [] as any;
                for (let item of _data["players"])
                    this.players!.push(TeamPlayerVm.fromJS(item));
            }
            if (Array.isArray(_data["coaches"])) {
                this.coaches = [] as any;
                for (let item of _data["coaches"])
                    this.coaches!.push(TeamCoachVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamDetailVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDetailVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logo"] = this.logo;
        if (Array.isArray(this.competitionTeams)) {
            data["competitionTeams"] = [];
            for (let item of this.competitionTeams)
                data["competitionTeams"].push(item.toJSON());
        }
        if (Array.isArray(this.homeMatches)) {
            data["homeMatches"] = [];
            for (let item of this.homeMatches)
                data["homeMatches"].push(item.toJSON());
        }
        if (Array.isArray(this.awayMatches)) {
            data["awayMatches"] = [];
            for (let item of this.awayMatches)
                data["awayMatches"].push(item.toJSON());
        }
        if (Array.isArray(this.players)) {
            data["players"] = [];
            for (let item of this.players)
                data["players"].push(item.toJSON());
        }
        if (Array.isArray(this.coaches)) {
            data["coaches"] = [];
            for (let item of this.coaches)
                data["coaches"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ITeamDetailVm extends ITeamVm {
    logo: string | undefined;
    competitionTeams: CompetitionTeamVm[];
    homeMatches: MatchVm[];
    awayMatches: MatchVm[];
    players: TeamPlayerVm[];
    coaches: TeamCoachVm[];
}

export class TeamMissingShortNameVm implements ITeamMissingShortNameVm {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;

    constructor(data?: ITeamMissingShortNameVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
        }
    }

    static fromJS(data: any): TeamMissingShortNameVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMissingShortNameVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        return data;
    }
}

export interface ITeamMissingShortNameVm {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
}

export class TeamMinInfoDto implements ITeamMinInfoDto {
    id!: number;
    name!: string | undefined;
    nameUniversal!: string | undefined;
    shortName!: string | undefined;
    country!: string | undefined;
    city!: string | undefined;
    logo!: string | undefined;

    constructor(data?: ITeamMinInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.country = _data["country"];
            this.city = _data["city"];
            this.logo = _data["logo"];
        }
    }

    static fromJS(data: any): TeamMinInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMinInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["country"] = this.country;
        data["city"] = this.city;
        data["logo"] = this.logo;
        return data;
    }
}

export interface ITeamMinInfoDto {
    id: number;
    name: string | undefined;
    nameUniversal: string | undefined;
    shortName: string | undefined;
    country: string | undefined;
    city: string | undefined;
    logo: string | undefined;
}

export class CreateTeamCommandOfTeam implements ICreateTeamCommandOfTeam {
    name!: string;
    nameUniversal!: string;
    shortName!: string | undefined;
    description!: string | undefined;
    activeFrom!: Date | undefined;
    activeTo!: Date | undefined;
    venue!: string | undefined;
    address!: string | undefined;
    web!: string | undefined;
    email!: string | undefined;
    phone!: string | undefined;
    facebook!: string | undefined;
    youtube!: string | undefined;
    twitter!: string | undefined;
    instagram!: string | undefined;
    logo!: string | undefined;
    isPro!: boolean;
    clubId!: number;
    categoryId!: number;
    countryId!: number | undefined;
    cityId!: number | undefined;

    constructor(data?: ICreateTeamCommandOfTeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.nameUniversal = _data["nameUniversal"];
            this.shortName = _data["shortName"];
            this.description = _data["description"];
            this.activeFrom = _data["activeFrom"] ? new Date(_data["activeFrom"].toString()) : <any>undefined;
            this.activeTo = _data["activeTo"] ? new Date(_data["activeTo"].toString()) : <any>undefined;
            this.venue = _data["venue"];
            this.address = _data["address"];
            this.web = _data["web"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.facebook = _data["facebook"];
            this.youtube = _data["youtube"];
            this.twitter = _data["twitter"];
            this.instagram = _data["instagram"];
            this.logo = _data["logo"];
            this.isPro = _data["isPro"];
            this.clubId = _data["clubId"];
            this.categoryId = _data["categoryId"];
            this.countryId = _data["countryId"];
            this.cityId = _data["cityId"];
        }
    }

    static fromJS(data: any): CreateTeamCommandOfTeam {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCommandOfTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["nameUniversal"] = this.nameUniversal;
        data["shortName"] = this.shortName;
        data["description"] = this.description;
        data["activeFrom"] = this.activeFrom ? this.activeFrom.toISOString() : <any>undefined;
        data["activeTo"] = this.activeTo ? this.activeTo.toISOString() : <any>undefined;
        data["venue"] = this.venue;
        data["address"] = this.address;
        data["web"] = this.web;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["facebook"] = this.facebook;
        data["youtube"] = this.youtube;
        data["twitter"] = this.twitter;
        data["instagram"] = this.instagram;
        data["logo"] = this.logo;
        data["isPro"] = this.isPro;
        data["clubId"] = this.clubId;
        data["categoryId"] = this.categoryId;
        data["countryId"] = this.countryId;
        data["cityId"] = this.cityId;
        return data;
    }
}

export interface ICreateTeamCommandOfTeam {
    name: string;
    nameUniversal: string;
    shortName: string | undefined;
    description: string | undefined;
    activeFrom: Date | undefined;
    activeTo: Date | undefined;
    venue: string | undefined;
    address: string | undefined;
    web: string | undefined;
    email: string | undefined;
    phone: string | undefined;
    facebook: string | undefined;
    youtube: string | undefined;
    twitter: string | undefined;
    instagram: string | undefined;
    logo: string | undefined;
    isPro: boolean;
    clubId: number;
    categoryId: number;
    countryId: number | undefined;
    cityId: number | undefined;
}

export class UpdateTeamCommandOfTeam extends CreateTeamCommandOfTeam implements IUpdateTeamCommandOfTeam {
    id!: number;

    constructor(data?: IUpdateTeamCommandOfTeam) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTeamCommandOfTeam {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCommandOfTeam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTeamCommandOfTeam extends ICreateTeamCommandOfTeam {
    id: number;
}

export class TeamStatsVm implements ITeamStatsVm {
    shots!: ShotStatsVm | undefined;
    swimoffs!: SwimoffStatsVm | undefined;
    turnovers!: TurnoverStatsVm | undefined;
    exclusions!: ExclusionStatsVm | undefined;

    constructor(data?: ITeamStatsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shots = _data["shots"] ? ShotStatsVm.fromJS(_data["shots"]) : <any>undefined;
            this.swimoffs = _data["swimoffs"] ? SwimoffStatsVm.fromJS(_data["swimoffs"]) : <any>undefined;
            this.turnovers = _data["turnovers"] ? TurnoverStatsVm.fromJS(_data["turnovers"]) : <any>undefined;
            this.exclusions = _data["exclusions"] ? ExclusionStatsVm.fromJS(_data["exclusions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamStatsVm {
        data = typeof data === 'object' ? data : {};
        let result = new TeamStatsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shots"] = this.shots ? this.shots.toJSON() : <any>undefined;
        data["swimoffs"] = this.swimoffs ? this.swimoffs.toJSON() : <any>undefined;
        data["turnovers"] = this.turnovers ? this.turnovers.toJSON() : <any>undefined;
        data["exclusions"] = this.exclusions ? this.exclusions.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamStatsVm {
    shots: ShotStatsVm | undefined;
    swimoffs: SwimoffStatsVm | undefined;
    turnovers: TurnoverStatsVm | undefined;
    exclusions: ExclusionStatsVm | undefined;
}

export class UserVm implements IUserVm {
    id!: string;
    userName!: string;
    email!: string;
    phoneNumber!: string | undefined;
    federationId!: number | undefined;
    federation!: string | undefined;
    clubId!: number | undefined;
    club!: string | undefined;
    personId!: number | undefined;
    person!: string | undefined;
    emailConfirmed!: boolean;
    typeId!: RoleEnum[] | undefined;
    type!: string[];

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.federationId = _data["federationId"];
            this.federation = _data["federation"];
            this.clubId = _data["clubId"];
            this.club = _data["club"];
            this.personId = _data["personId"];
            this.person = _data["person"];
            this.emailConfirmed = _data["emailConfirmed"];
            if (Array.isArray(_data["typeId"])) {
                this.typeId = [] as any;
                for (let item of _data["typeId"])
                    this.typeId!.push(item);
            }
            if (Array.isArray(_data["type"])) {
                this.type = [] as any;
                for (let item of _data["type"])
                    this.type!.push(item);
            }
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["federationId"] = this.federationId;
        data["federation"] = this.federation;
        data["clubId"] = this.clubId;
        data["club"] = this.club;
        data["personId"] = this.personId;
        data["person"] = this.person;
        data["emailConfirmed"] = this.emailConfirmed;
        if (Array.isArray(this.typeId)) {
            data["typeId"] = [];
            for (let item of this.typeId)
                data["typeId"].push(item);
        }
        if (Array.isArray(this.type)) {
            data["type"] = [];
            for (let item of this.type)
                data["type"].push(item);
        }
        return data;
    }
}

export interface IUserVm {
    id: string;
    userName: string;
    email: string;
    phoneNumber: string | undefined;
    federationId: number | undefined;
    federation: string | undefined;
    clubId: number | undefined;
    club: string | undefined;
    personId: number | undefined;
    person: string | undefined;
    emailConfirmed: boolean;
    typeId: RoleEnum[] | undefined;
    type: string[];
}

export enum RoleEnum {
    Admin = 0,
    Federation = 1,
    Club = 2,
    Person = 3,
}

export class IdentityUserOfString implements IIdentityUserOfString {
    id!: string | undefined;
    userName!: string | undefined;
    normalizedUserName!: string | undefined;
    email!: string | undefined;
    normalizedEmail!: string | undefined;
    emailConfirmed!: boolean;
    passwordHash!: string | undefined;
    securityStamp!: string | undefined;
    concurrencyStamp!: string | undefined;
    phoneNumber!: string | undefined;
    phoneNumberConfirmed!: boolean;
    twoFactorEnabled!: boolean;
    lockoutEnd!: Date | undefined;
    lockoutEnabled!: boolean;
    accessFailedCount!: number;

    constructor(data?: IIdentityUserOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : <any>undefined;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUserOfString {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUserOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

export interface IIdentityUserOfString {
    id: string | undefined;
    userName: string | undefined;
    normalizedUserName: string | undefined;
    email: string | undefined;
    normalizedEmail: string | undefined;
    emailConfirmed: boolean;
    passwordHash: string | undefined;
    securityStamp: string | undefined;
    concurrencyStamp: string | undefined;
    phoneNumber: string | undefined;
    phoneNumberConfirmed: boolean;
    twoFactorEnabled: boolean;
    lockoutEnd: Date | undefined;
    lockoutEnabled: boolean;
    accessFailedCount: number;
}

export class IdentityUser extends IdentityUserOfString implements IIdentityUser {

    constructor(data?: IIdentityUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityUser {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityUser extends IIdentityUserOfString {
}

export class ApplicationUser extends IdentityUser implements IApplicationUser {

    constructor(data?: IApplicationUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser {
}

export class CreateUserCommand implements ICreateUserCommand {
    email!: string;
    typeId!: RoleEnum;
    federationId!: number;
    clubId!: number;
    personId!: number;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.typeId = _data["typeId"];
            this.federationId = _data["federationId"];
            this.clubId = _data["clubId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["typeId"] = this.typeId;
        data["federationId"] = this.federationId;
        data["clubId"] = this.clubId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface ICreateUserCommand {
    email: string;
    typeId: RoleEnum;
    federationId: number;
    clubId: number;
    personId: number;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    id!: string;
    typeId!: RoleEnum;
    federationId!: number;
    clubId!: number;
    personId!: number;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.typeId = _data["typeId"];
            this.federationId = _data["federationId"];
            this.clubId = _data["clubId"];
            this.personId = _data["personId"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["typeId"] = this.typeId;
        data["federationId"] = this.federationId;
        data["clubId"] = this.clubId;
        data["personId"] = this.personId;
        return data;
    }
}

export interface IUpdateUserCommand {
    id: string;
    typeId: RoleEnum;
    federationId: number;
    clubId: number;
    personId: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function changedFeed(
    http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> },
    baseUrl: string,
    path: string,
    since: string | null | undefined,
    limit: number | null | undefined,
    includeDeleted: boolean | null | undefined,
    afterId: number | null | undefined,
    parse: ((key: string, value: any) => any) | undefined,
    transformOptions: (options: RequestInit) => Promise<RequestInit>,
    transformResult: (url: string, response: Response, processor: (response: Response) => any) => Promise<any>
): Promise<ChangedFeedListVm> {
    let url_ = baseUrl + path + "?";
    if (since !== undefined && since !== null)
        url_ += "since=" + encodeURIComponent("" + since) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "limit=" + encodeURIComponent("" + limit) + "&";
    if (includeDeleted !== undefined && includeDeleted !== null)
        url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
    if (afterId !== undefined && afterId !== null)
        url_ += "afterId=" + encodeURIComponent("" + afterId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    };

    return transformOptions(options_).then(transformedOptions_ => {
        return http.fetch(url_, transformedOptions_);
    }).then((_response: Response) => {
        return transformResult(url_, _response, (response: Response) => {
            const status = response.status;
            let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
            if (status === 200) {
                return response.text().then((_responseText) => {
                    let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, parse);
                    return ChangedFeedListVm.fromJS(resultData200);
                });
            } else if (status !== 200 && status !== 204) {
                return response.text().then((_responseText) => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                });
            }
            return Promise.resolve<ChangedFeedListVm>(null as any);
        });
    });
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// 2026-03-23: One-time guard used to prevent infinite auth recovery redirects
// when stale tokens/cookies trigger repeated 401 responses after deploy/restart.
const AUTH_RECOVERY_FLAG = 'twa-auth-recovering';
export interface BackfillCompetitionTeamsRequest {
    scope?: "imports" | "all";
    dryRun?: boolean;
    competitionId?: number;
}

export interface BackfillCompetitionTeamItemVm {
    competitionId: number;
    teamId: number;
    action: "added" | "would-add" | "skipped-soft-deleted";
}

export interface BackfillCompetitionTeamsResultVm {
    dryRun: boolean;
    added: number;
    wouldAdd: number;
    skippedSoftDeleted: number;
    items: BackfillCompetitionTeamItemVm[];
}

export class MatchReadLightVm implements IMatchReadLightVm {
    id!: number;
    homeTeamId!: number;
    homeTeamDisplayName!: string;
    awayTeamId!: number;
    awayTeamDisplayName!: string | undefined;
    federationId!: number;
    federationDisplayName!: string;
    competitionId!: number;
    competitionDisplayName!: string;
    countryId!: number | undefined;
    country!: string | undefined;
    cityId!: number | undefined;
    city!: string | undefined;
    venue!: string | undefined;
    round!: string | undefined;
    number!: string | undefined;
    competitionStage!: string | undefined;
    matchSegmentLength!: number;
    shotClockMaxSeconds!: number;
    shotClockResetSeconds!: number;
    exclusionDurationSeconds!: number;
    brutalityDurationSeconds!: number;
    startDate!: Date;
    endDate!: Date | undefined;
    statusId!: MatchStatusEnum;
    status!: string;
    matchSegmentId!: MatchSegmentEnum;
    matchSegment!: string | undefined;
    homeTeamGoalsTotal!: number | undefined;
    awayTeamGoalsTotal!: number | undefined;
    homeTeamGoalsQ1!: number | undefined;
    awayTeamGoalsQ1!: number | undefined;
    homeTeamGoalsQ2!: number | undefined;
    awayTeamGoalsQ2!: number | undefined;
    homeTeamGoalsQ3!: number | undefined;
    awayTeamGoalsQ3!: number | undefined;
    homeTeamGoalsQ4!: number | undefined;
    awayTeamGoalsQ4!: number | undefined;
    homeTeamGoalsOT!: number | undefined;
    awayTeamGoalsOT!: number | undefined;
    disciplinaryNote!: string | undefined;
    syncLocked!: boolean;
    lastModifiedUtc!: Date | undefined;
    revision!: number | undefined;
    hungaryGameId!: number | undefined;
    eurocupMatchKey!: string | undefined;
    championsLeagueMatchKey!: string | undefined;
    microplusMatchKey?: string;
    previousCompetitionId!: number | undefined;
    currentPeriod!: string | undefined;
    lineupStamp!: string;

    constructor(data?: IMatchReadLightVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.homeTeamId = _data["homeTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamId = _data["awayTeamId"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.federationId = _data["federationId"];
            this.federationDisplayName = _data["federationDisplayName"];
            this.competitionId = _data["competitionId"];
            this.competitionDisplayName = _data["competitionDisplayName"];
            this.countryId = _data["countryId"];
            this.country = _data["country"];
            this.cityId = _data["cityId"];
            this.city = _data["city"];
            this.venue = _data["venue"];
            this.round = _data["round"];
            this.number = _data["number"];
            this.competitionStage = _data["competitionStage"];
            this.matchSegmentLength = _data["matchSegmentLength"];
            this.shotClockMaxSeconds = _data["shotClockMaxSeconds"];
            this.shotClockResetSeconds = _data["shotClockResetSeconds"];
            this.exclusionDurationSeconds = _data["exclusionDurationSeconds"];
            this.brutalityDurationSeconds = _data["brutalityDurationSeconds"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.matchSegmentId = _data["matchSegmentId"];
            this.matchSegment = _data["matchSegment"];
            this.homeTeamGoalsTotal = _data["homeTeamGoalsTotal"];
            this.awayTeamGoalsTotal = _data["awayTeamGoalsTotal"];
            this.homeTeamGoalsQ1 = _data["homeTeamGoalsQ1"];
            this.awayTeamGoalsQ1 = _data["awayTeamGoalsQ1"];
            this.homeTeamGoalsQ2 = _data["homeTeamGoalsQ2"];
            this.awayTeamGoalsQ2 = _data["awayTeamGoalsQ2"];
            this.homeTeamGoalsQ3 = _data["homeTeamGoalsQ3"];
            this.awayTeamGoalsQ3 = _data["awayTeamGoalsQ3"];
            this.homeTeamGoalsQ4 = _data["homeTeamGoalsQ4"];
            this.awayTeamGoalsQ4 = _data["awayTeamGoalsQ4"];
            this.homeTeamGoalsOT = _data["homeTeamGoalsOT"];
            this.awayTeamGoalsOT = _data["awayTeamGoalsOT"];
            this.disciplinaryNote = _data["disciplinaryNote"];
            this.syncLocked = _data["syncLocked"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.revision = _data["revision"];
            this.hungaryGameId = _data["hungaryGameId"];
            this.eurocupMatchKey = _data["eurocupMatchKey"];
            this.championsLeagueMatchKey = _data["championsLeagueMatchKey"];
            this.microplusMatchKey = _data["microplusMatchKey"];
            this.previousCompetitionId = _data["previousCompetitionId"];
            this.currentPeriod = _data["currentPeriod"];
            this.lineupStamp = _data["lineupStamp"];
        }
    }

    static fromJS(data: any): MatchReadLightVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchReadLightVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["homeTeamId"] = this.homeTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamId"] = this.awayTeamId;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["federationId"] = this.federationId;
        data["federationDisplayName"] = this.federationDisplayName;
        data["competitionId"] = this.competitionId;
        data["competitionDisplayName"] = this.competitionDisplayName;
        data["countryId"] = this.countryId;
        data["country"] = this.country;
        data["cityId"] = this.cityId;
        data["city"] = this.city;
        data["venue"] = this.venue;
        data["round"] = this.round;
        data["number"] = this.number;
        data["competitionStage"] = this.competitionStage;
        data["matchSegmentLength"] = this.matchSegmentLength;
        data["shotClockMaxSeconds"] = this.shotClockMaxSeconds;
        data["shotClockResetSeconds"] = this.shotClockResetSeconds;
        data["exclusionDurationSeconds"] = this.exclusionDurationSeconds;
        data["brutalityDurationSeconds"] = this.brutalityDurationSeconds;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["matchSegmentId"] = this.matchSegmentId;
        data["matchSegment"] = this.matchSegment;
        data["homeTeamGoalsTotal"] = this.homeTeamGoalsTotal;
        data["awayTeamGoalsTotal"] = this.awayTeamGoalsTotal;
        data["homeTeamGoalsQ1"] = this.homeTeamGoalsQ1;
        data["awayTeamGoalsQ1"] = this.awayTeamGoalsQ1;
        data["homeTeamGoalsQ2"] = this.homeTeamGoalsQ2;
        data["awayTeamGoalsQ2"] = this.awayTeamGoalsQ2;
        data["homeTeamGoalsQ3"] = this.homeTeamGoalsQ3;
        data["awayTeamGoalsQ3"] = this.awayTeamGoalsQ3;
        data["homeTeamGoalsQ4"] = this.homeTeamGoalsQ4;
        data["awayTeamGoalsQ4"] = this.awayTeamGoalsQ4;
        data["homeTeamGoalsOT"] = this.homeTeamGoalsOT;
        data["awayTeamGoalsOT"] = this.awayTeamGoalsOT;
        data["disciplinaryNote"] = this.disciplinaryNote;
        data["syncLocked"] = this.syncLocked;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["revision"] = this.revision;
        data["hungaryGameId"] = this.hungaryGameId;
        data["eurocupMatchKey"] = this.eurocupMatchKey;
        data["championsLeagueMatchKey"] = this.championsLeagueMatchKey;
        data["microplusMatchKey"] = this.microplusMatchKey;
        data["previousCompetitionId"] = this.previousCompetitionId;
        data["currentPeriod"] = this.currentPeriod;
        data["lineupStamp"] = this.lineupStamp;
        return data;
    }
}

export interface IMatchReadLightVm {
    id: number;
    homeTeamId: number;
    homeTeamDisplayName: string;
    awayTeamId: number;
    awayTeamDisplayName: string | undefined;
    federationId: number;
    federationDisplayName: string;
    competitionId: number;
    competitionDisplayName: string;
    countryId: number | undefined;
    country: string | undefined;
    cityId: number | undefined;
    city: string | undefined;
    venue: string | undefined;
    round: string | undefined;
    number: string | undefined;
    competitionStage: string | undefined;
    matchSegmentLength: number;
    shotClockMaxSeconds: number;
    shotClockResetSeconds: number;
    exclusionDurationSeconds: number;
    brutalityDurationSeconds: number;
    startDate: Date;
    endDate: Date | undefined;
    statusId: MatchStatusEnum;
    status: string;
    matchSegmentId: MatchSegmentEnum;
    matchSegment: string | undefined;
    homeTeamGoalsTotal: number | undefined;
    awayTeamGoalsTotal: number | undefined;
    homeTeamGoalsQ1: number | undefined;
    awayTeamGoalsQ1: number | undefined;
    homeTeamGoalsQ2: number | undefined;
    awayTeamGoalsQ2: number | undefined;
    homeTeamGoalsQ3: number | undefined;
    awayTeamGoalsQ3: number | undefined;
    homeTeamGoalsQ4: number | undefined;
    awayTeamGoalsQ4: number | undefined;
    homeTeamGoalsOT: number | undefined;
    awayTeamGoalsOT: number | undefined;
    disciplinaryNote: string | undefined;
    syncLocked: boolean;
    lastModifiedUtc: Date | undefined;
    revision: number | undefined;
    hungaryGameId: number | undefined;
    eurocupMatchKey: string | undefined;
    championsLeagueMatchKey: string | undefined;
    microplusMatchKey?: string;
    previousCompetitionId: number | undefined;
    currentPeriod: string | undefined;
    lineupStamp: string;
}

export class MatchLineupCoachVm implements IMatchLineupCoachVm {
    id!: number | undefined;
    matchId!: number;
    coachId!: number;
    teamId!: number;
    roleId!: CoachRoleEnum;
    coach!: CoachVm;
    role!: string;

    constructor(data?: IMatchLineupCoachVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.coachId = _data["coachId"];
            this.teamId = _data["teamId"];
            this.roleId = _data["roleId"];
            this.coach = _data["coach"] ? CoachVm.fromJS(_data["coach"]) : <any>undefined;
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): MatchLineupCoachVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLineupCoachVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["coachId"] = this.coachId;
        data["teamId"] = this.teamId;
        data["roleId"] = this.roleId;
        data["coach"] = this.coach ? this.coach.toJSON() : <any>undefined;
        data["role"] = this.role;
        return data;
    }
}

export interface IMatchLineupCoachVm {
    id: number | undefined;
    matchId: number;
    coachId: number;
    teamId: number;
    roleId: CoachRoleEnum;
    coach: CoachVm;
    role: string;
}

export class MatchLineupOfficialVm implements IMatchLineupOfficialVm {
    id!: number | undefined;
    matchId!: number;
    officialId!: number;
    roleId!: OfficialRoleEnum;
    official!: OfficialVm;
    role!: string;
    confirmed!: boolean;

    constructor(data?: IMatchLineupOfficialVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchId = _data["matchId"];
            this.officialId = _data["officialId"];
            this.roleId = _data["roleId"];
            this.official = _data["official"] ? OfficialVm.fromJS(_data["official"]) : <any>undefined;
            this.role = _data["role"];
            this.confirmed = _data["confirmed"];
        }
    }

    static fromJS(data: any): MatchLineupOfficialVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLineupOfficialVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchId"] = this.matchId;
        data["officialId"] = this.officialId;
        data["roleId"] = this.roleId;
        data["official"] = this.official ? this.official.toJSON() : <any>undefined;
        data["role"] = this.role;
        data["confirmed"] = this.confirmed;
        return data;
    }
}

export interface IMatchLineupOfficialVm {
    id: number | undefined;
    matchId: number;
    officialId: number;
    roleId: OfficialRoleEnum;
    official: OfficialVm;
    role: string;
    confirmed: boolean;
}

export class MatchLineupPlayerVm implements IMatchLineupPlayerVm {
    id!: number | undefined;
    number!: number;
    capNumber!: number;
    matchId!: number;
    playerId!: number;
    teamId!: number;
    positionId!: PlayerPositionEnum;
    position!: string;
    player!: PlayerVm;

    constructor(data?: IMatchLineupPlayerVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.number = _data["number"];
            this.capNumber = _data["capNumber"];
            this.matchId = _data["matchId"];
            this.playerId = _data["playerId"];
            this.teamId = _data["teamId"];
            this.positionId = _data["positionId"];
            this.position = _data["position"];
            this.player = _data["player"] ? PlayerVm.fromJS(_data["player"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MatchLineupPlayerVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLineupPlayerVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["number"] = this.number;
        data["capNumber"] = this.capNumber;
        data["matchId"] = this.matchId;
        data["playerId"] = this.playerId;
        data["teamId"] = this.teamId;
        data["positionId"] = this.positionId;
        data["position"] = this.position;
        data["player"] = this.player ? this.player.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMatchLineupPlayerVm {
    id: number | undefined;
    number: number;
    capNumber: number;
    matchId: number;
    playerId: number;
    teamId: number;
    positionId: PlayerPositionEnum;
    position: string;
    player: PlayerVm;
}

export class MatchLineupVm implements IMatchLineupVm {
    matchId!: number;
    homeTeamId!: number;
    awayTeamId!: number;
    homeTeamDisplayName!: string | undefined;
    awayTeamDisplayName!: string | undefined;
    homeTeam!: TeamVm;
    awayTeam!: TeamVm;
    lineupStamp!: string;
    players!: MatchLineupPlayerVm[];
    coaches!: MatchLineupCoachVm[];
    officials!: MatchLineupOfficialVm[];

    constructor(data?: IMatchLineupVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchId = _data["matchId"];
            this.homeTeamId = _data["homeTeamId"];
            this.awayTeamId = _data["awayTeamId"];
            this.homeTeamDisplayName = _data["homeTeamDisplayName"];
            this.awayTeamDisplayName = _data["awayTeamDisplayName"];
            this.homeTeam = _data["homeTeam"] ? TeamVm.fromJS(_data["homeTeam"]) : <any>undefined;
            this.awayTeam = _data["awayTeam"] ? TeamVm.fromJS(_data["awayTeam"]) : <any>undefined;
            this.lineupStamp = _data["lineupStamp"];
            this.players = Array.isArray(_data["players"]) ? _data["players"].map((item: any) => MatchLineupPlayerVm.fromJS(item)) : [];
            this.coaches = Array.isArray(_data["coaches"]) ? _data["coaches"].map((item: any) => MatchLineupCoachVm.fromJS(item)) : [];
            this.officials = Array.isArray(_data["officials"]) ? _data["officials"].map((item: any) => MatchLineupOfficialVm.fromJS(item)) : [];
        }
    }

    static fromJS(data: any): MatchLineupVm {
        data = typeof data === 'object' ? data : {};
        let result = new MatchLineupVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchId"] = this.matchId;
        data["homeTeamId"] = this.homeTeamId;
        data["awayTeamId"] = this.awayTeamId;
        data["homeTeamDisplayName"] = this.homeTeamDisplayName;
        data["awayTeamDisplayName"] = this.awayTeamDisplayName;
        data["homeTeam"] = this.homeTeam ? this.homeTeam.toJSON() : <any>undefined;
        data["awayTeam"] = this.awayTeam ? this.awayTeam.toJSON() : <any>undefined;
        data["lineupStamp"] = this.lineupStamp;
        data["players"] = this.players ? this.players.map(item => item.toJSON()) : [];
        data["coaches"] = this.coaches ? this.coaches.map(item => item.toJSON()) : [];
        data["officials"] = this.officials ? this.officials.map(item => item.toJSON()) : [];
        return data;
    }
}

export interface IMatchLineupVm {
    matchId: number;
    homeTeamId: number;
    awayTeamId: number;
    homeTeamDisplayName: string | undefined;
    awayTeamDisplayName: string | undefined;
    homeTeam: TeamVm;
    awayTeam: TeamVm;
    lineupStamp: string;
    players: MatchLineupPlayerVm[];
    coaches: MatchLineupCoachVm[];
    officials: MatchLineupOfficialVm[];
}

/** Additive desktop validation API; existing match/feed contracts are unchanged. */
export interface BulkValidatorGameResult {
    email: string;
    status: 'created' | 'inviteResent' | 'refused';
    matchId?: number | null;
    error?: string | null;
}

export interface ValidationWindowVm {
    isPractice?: boolean | null;
    startedAt?: string | null;
    deadline?: string | null;
    submittedAt?: string | null;
    submitReason?: string | null;
    serverUtc: string;
}
